<template>
  <div class="mutual-fund-page">
    <v-container fluid>
      <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t('_MutualFund') }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text class="list-toolbar">
          <v-row align="center" class="list-toolbar-row">
            <v-col cols="12" md="4">
              <!-- <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="9" class="pa-2">
                    <v-text-field
                      id="field-search-rowtable-mutualFundIntegration"
                      :label="'Table Name'"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-clipboard-text-search-outline"
                      hide-details
                      clearable
                      v-model="searchMutualFundIntegrationName"
                      @keydown.enter="Search"
                      color="primary"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-2 d-flex align-center justify-end">
                    <v-btn id="button-search-rowtable-mutualFundIntegration" color="primary" class="ml-2" variant="elevated" prepend-icon="mdi-magnify" @click="Search"> Search </v-btn>
                  </v-col>
                </v-row>
              </v-card> -->
              <div class="page-title">Mutual Fund List</div>
            </v-col>
            <v-col cols="12" md="8" class="toolbar-actions">
              <v-dialog v-model="AddMutualFundIntegration" max-width="800" persistent class="modern-dialog">
                <template v-slot:activator="{ props: activatorProps }">
                  <!-- Search Text Field -->
                  <v-text-field v-model="searchMutualFundIntegrationName" placeholder="Search table name" variant="outlined" density="comfortable" class="custom-search-field" hide-details>
                    <template v-slot:prepend-inner>
                      <v-icon class="search-icon" size="23">mdi-magnify</v-icon>
                    </template>
                  </v-text-field>

                  <!-- Document Button -->
                  <v-btn v-if="canAdd" variant="elevated" class="custom-document-btn" v-bind="activatorProps" id="button-add-dataIntergration">
                    <v-icon size="23" class="mr-2">mdi-plus</v-icon>
                    <span class="database-text">Database</span>
                  </v-btn>

                  <v-btn v-if="isImportAdministrator" variant="outlined" class="sync-schedule-btn" prepend-icon="mdi-tune-variant" @click.stop="openScheduleDialog">
                    Sync settings
                  </v-btn>

                  <!-- @click.stop is required: this button lives inside the Add Table dialog's activator slot,
                       so without it opening the card configs opens Add Table on top of it as well. -->
                  <v-btn v-if="canEdit" variant="outlined" class="sync-schedule-btn" prepend-icon="mdi-card-account-details-outline" @click.stop="showCardConfigDialog = true">
                    Tax card configs
                  </v-btn>

                  <!-- Which view the fund node reads, and what is in it. Before this the answer lived only in
                       C# constants, so an empty app looked like a broken node. -->
                  <v-btn v-if="isImportAdministrator" variant="outlined" class="sync-schedule-btn"
                    prepend-icon="mdi-database-search" @click.stop="showViewLayerDialog = true"
                    data-testid="mutualfund-view-layer-button">
                    View layer
                  </v-btn>

                  <v-btn variant="outlined" class="refresh-table-btn" prepend-icon="mdi-refresh" :loading="loadingTable" aria-label="Refresh mutual fund table list" @click="refreshTable">
                    Refresh
                  </v-btn>

                  <!-- Filter Button -->
                  <v-btn color="#4B2869" variant="elevated" class="filter-btn" icon aria-label="Filter mutual fund tables" @click="toggleFilterDrawer">
                    <v-icon color="white" size="25">mdi-filter-variant</v-icon>
                  </v-btn>

                  <!-- <v-btn
                    id="button-add-dataIntergration"
                    color="primary"
                    class="control-btn create-btn"
                    variant="elevated"
                    size="large"
                    prepend-icon="mdi-plus-circle"
                    rounded="xl"
                    v-bind="activatorProps"
                  >
                    <span class="btn-text">{{ $t('add') }}</span>
                  </v-btn> -->
                </template>

                <v-card class="dialog-card" elevation="0">
                  <!-- Enhanced Header -->
                  <div class="dialog-header dialog-header-add">
                    <div class="header-main">
                      <div class="header-icon-container">
                        <div class="icon-background">
                          <v-icon size="24" color="white">mdi-table-plus</v-icon>
                        </div>
                      </div>
                      <div class="header-text-content">
                        <h2 class="dialog-title">Add New Table</h2>
                        <p class="dialog-subtitle">Configure your mutual fund table</p>
                      </div>
                    </div>
                    <div class="header-actions">
                      <v-btn icon variant="text" color="white" @click="closeDialogAddMutualFundIntegration" class="close-button">
                        <v-icon size="20">mdi-close</v-icon>
                      </v-btn>
                    </div>
                    <!-- <div
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                      "
                    >
                      <div class="header-content">
                        <div class="header-icon">
                          <v-icon size="24" color="primary"
                            >mdi-table-plus</v-icon
                          >
                        </div>
                        <div class="header-text">
                          <h2 class="title-text">Add New Table</h2>
                          <p class="subtitle-text">
                            Configure your mutual fund table
                          </p>
                        </div>
                      </div>
                      <v-btn
                        icon
                        variant="text"
                        size="small"
                        @click="AddMutualFundIntegration = false"
                        class="close-btn"
                      >
                        <v-icon size="20">mdi-close</v-icon>
                      </v-btn>
                    </div> -->
                  </div>

                  <v-divider class="header-divider"></v-divider>

                  <v-card-text class="modern-content">
                    <!-- Mutual Fund tables are internal only -->
                    <div class="section-container">
                      <div class="section-header">
                        <v-icon size="18" color="primary" class="section-icon">mdi-database</v-icon>
                        <span class="section-title">Internal Table</span>
                      </div>
                      <p class="upload-hint mb-0">Add columns manually, or upload an Excel file to fill them automatically.</p>
                    </div>

                    <!-- Internal System Configuration -->
                    <div class="config-section">
                      <div class="section-container">
                        <div class="section-header">
                          <v-icon size="18" color="primary" class="section-icon">mdi-database</v-icon>
                          <span class="section-title">Internal Configuration</span>
                        </div>

                        <div class="form-grid">
                          <div class="form-group form-group-large">
                            <v-text-field
                              id="add-tablename-internal-mutualFundIntegration"
                              label="Table Name"
                              v-model="requestMutualFundIntegration.MutualFundIntegrationName"
                              :rules="[rules.required]"
                              variant="outlined"
                              density="comfortable"
                              class="modern-input"
                            >
                              <template v-slot:append-inner>
                                <v-tooltip text="Table name information" location="top">
                                  <template v-slot:activator="{ props }">
                                    <v-icon v-bind="props" size="16" color="grey-darken-1" class="info-icon"> mdi-help-circle-outline </v-icon>
                                  </template>
                                </v-tooltip>
                              </template>
                            </v-text-field>
                          </div>
                        </div>

                        <!-- Columns Configuration -->
                        <div v-if="requestMutualFundIntegration.Columns.length > 0" class="columns-section">
                          <div class="columns-header">
                            <h3 class="columns-title">Column Configuration</h3>
                            <div class="d-flex align-center ga-2">
                              <v-chip size="small" color="primary" variant="tonal">
                                {{ requestMutualFundIntegration.Columns.length }}
                                columns
                              </v-chip>
                              <v-btn color="primary" variant="outlined" size="small" prepend-icon="mdi-plus" @click="AddColumn">
                                Add Column
                              </v-btn>
                            </div>
                          </div>

                          <div class="columns-list">
                            <v-card v-for="(item, index) in requestMutualFundIntegration.Columns" :key="index" class="column-card" variant="outlined">
                              <v-card-text class="column-content">
                                <div class="column-fields">
                                  <v-text-field
                                    :id="`add-columnName-Internal-mutualFundIntegration-${index}`"
                                    :label="$t('_columnDataIntegration')"
                                    v-model="item.name"
                                    variant="outlined"
                                    density="comfortable"
                                    class="column-input"
                                    :error="errorMessages.columns[index]?.error"
                                    :error-messages="errorMessages.columns[index]?.message"
                                  >
                                    <template v-slot:append-inner>
                                      <v-tooltip :text="$t('_columnDataIntegration')" location="top">
                                        <template v-slot:activator="{ props }">
                                          <v-icon v-bind="props" size="14" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                        </template>
                                      </v-tooltip>
                                    </template>
                                  </v-text-field>

                                  <v-select
                                    :id="`add-dataType-Internal-mutualFundIntegration-${index}`"
                                    :label="$t('_typeDataIntegration')"
                                    :items="DDDataType"
                                    item-title="name"
                                    item-value="id"
                                    v-model="item.typeId"
                                    @update:model-value="setDefault(item)"
                                    variant="outlined"
                                    density="comfortable"
                                    class="column-input"
                                  >
                                    <template v-slot:append-inner>
                                      <v-tooltip :text="$t('_typeDataIntegration')" location="top">
                                        <template v-slot:activator="{ props }">
                                          <v-icon v-bind="props" size="14" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                        </template>
                                      </v-tooltip>
                                    </template>
                                  </v-select>

                                  <v-tooltip text="Remove column" location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-btn
                                        v-bind="props"
                                        icon="mdi-delete-outline"
                                        variant="text"
                                        color="error"
                                        size="small"
                                        :disabled="requestMutualFundIntegration.Columns.length === 1"
                                        @click="DeleteAction(index)"
                                      ></v-btn>
                                    </template>
                                  </v-tooltip>
                                </div>

                                <div class="column-fields">
                                  <v-select
                                    :items="fuzzyOptions"
                                    item-title="text"
                                    item-value="value"
                                    variant="outlined"
                                    class="fuzzy-select"
                                    density="compact"
                                    hide-details
                                    @update:model-value="setFuzzyValue(item, $event)"
                                    :disabled="item.typeId != 'nvarchar' && item.typeId != 'varchar' && item.typeId != 'varchar2' && item.typeId != 'text'
                                    && item.typeId != 'char' && item.typeId != 'nchar' && item.typeId != 'VARCHAR2' && item.typeId != 'TEXT'
                                    && item.typeId != 'CHAR' && item.typeId != 'NCHAR' && item.typeId != 'NVARCHAR2'"
                                  >
                                    <template v-slot:selection="{ item: selectedItem }">
                                      <div class="selection-content">
                                        <v-icon :color="getFuzzyColor(selectedItem.raw)" size="16" class="mr-2">
                                          {{ getFuzzyIcon(selectedItem.raw) }}
                                        </v-icon>
                                        <span class="selection-text">{{ selectedItem.raw.text }}</span>
                                      </div>
                                    </template>

                                    <template v-slot:item="{ props, item: dropdownItem }">
                                      <v-list-item v-bind="props" class="fuzzy-list-item">
                                        <template v-slot:prepend>
                                          <v-icon :color="getFuzzyColor(dropdownItem.raw)" size="18">
                                            {{ getFuzzyIcon(dropdownItem.raw) }}
                                          </v-icon>
                                        </template>

                                        <v-list-item-subtitle class="fuzzy-item-subtitle">
                                          {{ dropdownItem.raw.description }}
                                        </v-list-item-subtitle>
                                      </v-list-item>
                                    </template>

                                    <template v-slot:label>
                                      <div class="label-content">
                                        <v-icon size="16" class="mr-2" color="primary">mdi-tune</v-icon>
                                        <span>Fuzzy Matching</span>
                                      </div>
                                    </template>
                                  </v-select>

                                  <div class="personal-info-wrapper">
                                    <div class="personal-info-container">
                                      <div class="personal-info-header">
                                        <v-tooltip location="top" max-width="300px">
                                          <template v-slot:activator="{ props }">
                                            <div class="personal-info-label" v-bind="props">
                                              <v-icon size="16" color="warning" class="mr-1">mdi-shield-account</v-icon>
                                              <span class="text-caption">
                                                Personal Info:
                                                <span :class="item.personalInformation ? 'status-on' : 'status-off'">
                                                  {{ item.personalInformation ? 'ON' : 'OFF' }}
                                                </span>
                                              </span>
                                            </div>
                                          </template>
                                          <span>{{ $t('_Personal_Info') }}</span>
                                        </v-tooltip>

                                        <v-switch
                                          v-model="item.personalInformation"
                                          inset
                                          density="compact"
                                          color="warning"
                                          hide-details
                                          class="personal-info-switch"
                                          :disabled="
                                            item.typeId != null &&
                                            item.typeId.toLowerCase() != 'nvarchar' &&
                                            item.typeId.toLowerCase() != 'text' &&
                                            item.typeId.toLowerCase() != 'varchar' &&
                                            item.typeId.toLowerCase() != 'varchar2' &&
                                            item.typeId.toLowerCase() != 'char' &&
                                            item.typeId.toLowerCase() != 'nchar'
                                          "
                                        ></v-switch>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- <v-checkbox
                                    :id="`add-checkbox-fuzzy-mutualFundIntegration-${index}`"
                                    v-model="item.fuzzy"
                                    @update:model-value="item.fuzzyBot = false"
                                    :disabled="item.typeId != 'nvarchar'"
                                    label="Fuzzy"
                                    color="primary"
                                    density="comfortable"
                                    hide-details
                                    class="modern-checkbox"
                                  ></v-checkbox>

                                  <v-checkbox
                                    :id="`add-checkbox-fuzzybot-mutualFundIntegration-${index}`"
                                    v-model="item.fuzzyBot"
                                    @update:model-value="item.fuzzy = false"
                                    :disabled="
                                      requestMutualFundIntegration.Type == 'I' &&
                                      item.typeId != 'nvarchar'
                                    "
                                    label="Fuzzy with bot"
                                    color="primary"
                                    density="comfortable"
                                    hide-details
                                    class="modern-checkbox"
                                  ></v-checkbox> -->
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>
                        </div>

                        <!-- Optional Excel shortcut -->
                        <div class="form-group upload-section mt-6">
                          <div class="upload-container">
                            <div class="upload-area">
                              <v-btn id="proxy-upload-button" color="primary" variant="outlined" size="large" prepend-icon="mdi-file-excel-outline" @click="triggerFileUpload" class="upload-main-btn">
                                <span class="upload-text">Upload Excel (Optional)</span>
                              </v-btn>

                              <div class="upload-info">
                                <div class="upload-description">
                                  <v-icon size="16" color="grey-darken-1" class="mr-1">mdi-information-outline</v-icon>
                                  <span class="upload-hint">Use the first row as column names and upload any remaining rows as data</span>
                                </div>

                                <v-tooltip text="Supported format: Excel (.xlsx) files only" location="top">
                                  <template v-slot:activator="{ props }">
                                    <v-btn v-bind="props" icon variant="text" size="small" class="upload-help-btn">
                                      <v-icon size="18" color="grey-darken-1">mdi-help-circle-outline</v-icon>
                                    </v-btn>
                                  </template>
                                </v-tooltip>
                              </div>

                              <div v-if="uploadedFiles.length > 0" class="uploaded-file-info">
                                <v-chip color="success" variant="tonal" size="small" prepend-icon="mdi-file-excel" class="file-chip">
                                  {{ uploadedFiles[0].name }}
                                </v-chip>
                              </div>
                            </div>

                            <DragDropFile
                              ref="dragDropRef"
                              :dialog="true"
                              :DragDrop="false"
                              :ShowListFile="false"
                              :accept="accept"
                              @filesUploaded="processUpload($event)"
                              :allowType="[]"
                              class="modern-upload hidden-upload"
                              id="add-UploadFile-Internal-MutualFundIntegration"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- External System Configuration -->
                    <div v-if="false" class="config-section">
                      <div class="section-container">
                        <div class="section-header">
                          <v-icon size="18" color="primary" class="section-icon">mdi-cloud-outline</v-icon>
                          <span class="section-title">External Configuration</span>
                        </div>

                        <div class="form-grid">
                          <v-text-field
                            id="add-tablename-external-mutualFundIntegration"
                            label="Table Name"
                            v-model="requestMutualFundIntegration.MutualFundIntegrationName"
                            :rules="[rules.required]"
                            variant="outlined"
                            density="comfortable"
                            class="modern-input"
                          >
                            <template v-slot:append-inner>
                              <v-tooltip :text="$t('_InfoDataIntegrationName')" location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon v-bind="props" size="16" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                </template>
                              </v-tooltip>
                            </template>
                          </v-text-field>

                          <v-select
                            id="add-database-external-mutualFundIntegration"
                            label="Database*"
                            :items="DDDatabase"
                            item-title="name"
                            item-value="id"
                            @update:model-value="onInputConnectionString()"
                            v-model="requestMutualFundIntegration.Database"
                            :rules="[rules.required]"
                            variant="outlined"
                            density="comfortable"
                            class="modern-input"
                          >
                            <template v-slot:append-inner>
                              <v-tooltip :text="$t('_InfoModel')" location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon v-bind="props" size="16" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                </template>
                              </v-tooltip>
                            </template>
                          </v-select>
                        </div>

                        <v-text-field
                          id="add-connection-external-mutualFundIntegration"
                          label="Connection String"
                          @input="onInputConnectionString()"
                          v-model="requestMutualFundIntegration.ConnectionString"
                          :rules="[rules.required]"
                          variant="outlined"
                          density="comfortable"
                          class="modern-input full-width"
                        >
                          <template v-slot:append-inner>
                            <v-tooltip :text="$t('_InfoConnectionString')" location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon v-bind="props" size="16" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                              </template>
                            </v-tooltip>
                          </template>
                        </v-text-field>

                        <div class="form-grid">
                          <v-text-field
                            id="add-schema-external-mutualFundIntegration"
                            label="Schema"
                            @input="onInputSchema()"
                            v-model="requestMutualFundIntegration.Schema"
                            :rules="[rules.required]"
                            variant="outlined"
                            density="comfortable"
                            class="modern-input"
                          >
                            <template v-slot:append-inner>
                              <v-tooltip :text="$t('_InfoSchema')" location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon v-bind="props" size="16" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                </template>
                              </v-tooltip>
                            </template>
                          </v-text-field>

                          <v-text-field
                            id="add-view-external-dataIntergration"
                            label="View"
                            v-model="requestMutualFundIntegration.View"
                            :rules="[rules.required]"
                            variant="outlined"
                            density="comfortable"
                            class="modern-input"
                          >
                            <template v-slot:append-inner>
                              <v-tooltip :text="$t('_InfoTable')" location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon v-bind="props" size="16" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                </template>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </div>

                        <!-- External Columns -->
                        <div class="external-columns-section">
                          <div class="columns-header">
                            <h3 class="columns-title">Column Configuration</h3>
                            <v-btn id="add-column-external-mutualFundIntegration" variant="outlined" color="primary" size="small" prepend-icon="mdi-plus" @click="AddColumn()" class="add-column-btn">
                              Add Column
                              <v-tooltip activator="parent" location="top"> à¹€à¸žà¸´à¹ˆà¸¡à¹€à¸‰à¸žà¸²à¸° Column à¸—à¸µà¹ˆà¸•à¹‰à¸­à¸‡à¹ƒà¸Šà¹‰ (à¹„à¸¡à¹ˆà¸ˆà¸³à¹€à¸›à¹‡à¸™à¸•à¹‰à¸­à¸‡à¹ƒà¸Šà¹‰à¸—à¸¸à¸ Column à¸—à¸µà¹ˆà¸¡à¸µà¸­à¸¢à¸¹à¹ˆà¹ƒà¸™ Table) </v-tooltip>
                            </v-btn>
                          </div>

                          <div class="external-columns-grid">
                            <v-card v-for="(item, index) in requestMutualFundIntegration.Columns" :key="index" class="external-column-card" variant="outlined">
                              <v-card-text class="external-column-content">
                                <div class="external-column-header">
                                  <v-chip size="x-small" color="primary" variant="tonal">
                                    {{ index + 1 }}
                                  </v-chip>
                                  <v-btn
                                    :id="`add-deleteColumn-external-mutualFundIntegration${index}`"
                                    icon
                                    variant="text"
                                    size="x-small"
                                    color="error"
                                    @click="DeleteAction(index)"
                                    class="delete-column-btn"
                                  >
                                    <v-icon size="16">mdi-close</v-icon>
                                  </v-btn>
                                </div>

                                <v-text-field
                                  :id="`add-columnname-external-mutualFundIntegration-${index}`"
                                  :label="'Column'"
                                  v-model="item.name"
                                  variant="outlined"
                                  density="comfortable"
                                  class="external-column-input"
                                  :error="errorMessages.columns[index]?.error"
                                  :error-messages="errorMessages.columns[index]?.message"
                                ></v-text-field>

                                <!-- <v-checkbox
                                  :id="`add-checkbox-fuzzy-external-mutualFundIntegration${index}`"
                                  v-model="item.fuzzy"
                                  @update:model-value="item.fuzzyBot = false"
                                  color="primary"
                                  density="comfortable"
                                  hide-details
                                  class="modern-checkbox"
                                >
                                  <template v-slot:label>
                                    <div class="checkbox-label">
                                      <span>Fuzzy</span>
                                      <v-tooltip :text="$t('_InfoFuzzy')" location="top">
                                        <template v-slot:activator="{ props }">
                                          <v-icon v-bind="props" size="14" color="grey-darken-1" class="ml-1"> mdi-help-circle-outline </v-icon>
                                        </template>
                                      </v-tooltip>
                                    </div>
                                  </template>
                                </v-checkbox> -->
                                <!-- <v-checkbox
                                  :id="`add-checkbox-fuzzy-external-mutualFundIntegration${index}`"
                                  v-model="item.fuzzyBot"
                                  @update:model-value="item.fuzzy = false"
                                  color="primary"
                                  density="comfortable"
                                  hide-details
                                  class="modern-checkbox"
                                >
                                  <template v-slot:label>
                                    <div class="checkbox-label">
                                      <span>Fuzzy with bot</span>
                                      <v-tooltip :text="$t('_InfoFuzzyWithBot')" location="top">
                                        <template v-slot:activator="{ props }">
                                          <v-icon v-bind="props" size="14" color="grey-darken-1" class="ml-1"> mdi-help-circle-outline </v-icon>
                                        </template>
                                      </v-tooltip>
                                    </div>
                                  </template>
                                </v-select> -->
                                <div class="column-fields">
                                  <v-select
                                    :items="fuzzyOptions"
                                    item-title="text"
                                    item-value="value"
                                    variant="outlined"
                                    class="fuzzy-select"
                                    density="compact"
                                    hide-details
                                    @update:model-value="setFuzzyValue(item, $event)"
                                    :disabled="validateString(item)"
                                  >
                                    <!-- :disabled="type == 'I' && item.typeId != 'nvarchar'" -->
                                    <template v-slot:selection="{ item: selectedItem }">
                                      <div class="selection-content">
                                        <v-icon :color="getFuzzyColor(selectedItem.raw)" size="16" class="mr-2">
                                          {{ getFuzzyIcon(selectedItem.raw) }}
                                        </v-icon>
                                        <span class="selection-text">{{ selectedItem.raw.text }}</span>
                                      </div>
                                    </template>

                                    <template v-slot:item="{ props, item: dropdownItem }">
                                      <v-list-item v-bind="props" class="fuzzy-list-item">
                                        <template v-slot:prepend>
                                          <v-icon :color="getFuzzyColor(dropdownItem.raw)" size="18">
                                            {{ getFuzzyIcon(dropdownItem.raw) }}
                                          </v-icon>
                                        </template>

                                        <v-list-item-subtitle class="fuzzy-item-subtitle">
                                          {{ dropdownItem.raw.description }}
                                        </v-list-item-subtitle>
                                      </v-list-item>
                                    </template>

                                    <template v-slot:label>
                                      <div class="label-content">
                                        <v-icon size="16" class="mr-2" color="primary">mdi-tune</v-icon>
                                        <span>Fuzzy Matching</span>
                                      </div>
                                    </template>
                                  </v-select>

                                  <div class="personal-info-wrapper">
                                    <div class="personal-info-container">
                                      <div class="personal-info-header">
                                        <v-tooltip location="top" max-width="300px">
                                          <template v-slot:activator="{ props }">
                                            <div class="personal-info-label" v-bind="props">
                                              <v-icon size="16" color="warning" class="mr-1">mdi-shield-account</v-icon>
                                              <span class="text-caption">
                                                Personal Info:
                                                <span :class="item.personalInformation ? 'status-on' : 'status-off'">
                                                  {{ item.personalInformation ? 'ON' : 'OFF' }}
                                                </span>
                                              </span>
                                            </div>
                                          </template>
                                          <span>{{ $t('_Personal_Info') }}</span>
                                        </v-tooltip>

                                        <v-switch
                                          v-model="item.personalInformation"
                                          inset
                                          density="compact"
                                          color="warning"
                                          hide-details
                                          class="personal-info-switch"
                                          :disabled="validateString(item)"
                                        ></v-switch>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card-text>

                  <v-divider></v-divider>

                  <!-- Enhanced Actions -->
                  <div class="dialog-actions">
                    <div class="actions-content">
                      <div class="actions-left"></div>
                      <div class="actions-right">
                        <v-btn variant="outlined" color="grey-darken-1" @click="closeDialogAddMutualFundIntegration" class="dialog-action-btn cancel-btn"> Cancel </v-btn>
                        <v-btn
                          v-if="canAdd"
                          variant="flat"
                          @click="ConfirmProcess('I')"
                          class="dialog-action-btn save-btn-add"
                          :disabled="!requestMutualFundIntegration.MutualFundIntegrationName"
                        >
                          <v-icon start>mdi-content-save</v-icon>
                          Save Configuration
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <!-- <v-card-actions class="modern-actions">
                    <v-spacer></v-spacer>
                    <v-btn
                      variant="text"
                      color="grey-darken-1"
                      @click="AddMutualFundIntegration = false"
                      class="action-btn cancel-btn"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      color="success"
                      variant="flat"
                      @click="
                        requestMutualFundIntegration.Type === 'I'
                          ? ConfirmProcess('I')
                          : ConfirmProcess('E')
                      "
                      class="action-btn save-btn"
                      :disabled="!requestMutualFundIntegration.MutualFundIntegrationName"
                    >
                      <v-icon start>mdi-content-save</v-icon>
                      Save Configuration
                    </v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-dialog>

              <v-dialog v-model="showTestImportDialog" max-width="720" persistent>
                <v-card class="import-dialog-card">
                  <v-card-title class="import-dialog-header">
                    <div>
                      <div class="import-dialog-title">Import managed file feed</div>
                      <div class="import-dialog-subtitle">Select a delivered CSV folder. The files are queued as one batch and continue processing in the background.</div>
                    </div>
                    <v-btn icon variant="text" aria-label="Close managed file feed import" @click="closeTestImportDialog"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text class="pt-5">
                    <v-alert v-if="!importFrameworkReady" type="info" variant="tonal" density="comfortable" class="mb-4" role="status">
                      The five mapped file-feed tables will be prepared automatically when this feed is queued.
                    </v-alert>
                    <input ref="morningStarFolderInput" class="folder-file-input" type="file" accept=".csv,text/csv" multiple webkitdirectory directory @change="onMorningStarFolderSelected" />
                    <input ref="morningStarCsvInput" class="folder-file-input" type="file" accept=".csv,text/csv" multiple @change="onMorningStarFolderSelected" />
                    <button type="button" class="folder-picker" @click="browseMorningStarFolder">
                      <span class="folder-picker-icon"><v-icon size="30">mdi-folder-upload-outline</v-icon></span>
                      <span class="folder-picker-copy">
                        <strong>{{ morningStarFiles.length ? morningStarFolderName : 'Choose CSV folder' }}</strong>
                        <small v-if="morningStarFiles.length">{{ morningStarFiles.length }} CSV file(s) · {{ morningStarFolderSize }}</small>
                        <small v-else>Select a folder containing the supported CSV files. ZIP files are not used.</small>
                      </span>
                      <v-icon color="primary">mdi-chevron-right</v-icon>
                    </button>
                    <div class="folder-picker-alternative">
                      <span>or</span>
                      <v-btn variant="text" color="primary" prepend-icon="mdi-file-delimited-outline" @click="browseMorningStarCsvFiles">Select individual CSV files</v-btn>
                    </div>
                    <v-alert type="info" variant="tonal" density="compact" class="mt-4" role="status">
                      Current profile: Morningstar (5 mapped tables). This manual flow does not contact a remote file server; only recognized CSV filenames are imported.
                    </v-alert>
                    <v-alert v-if="lastImportMessage" :type="lastImportAlertType" variant="tonal" density="comfortable" class="mt-5" role="alert">
                      {{ lastImportMessage }}
                    </v-alert>
                    <div v-if="importHistory.length" class="import-history mt-5">
                      <div class="import-history-title">Recent import batches</div>
                      <div v-for="item in importHistory.slice(0, 5)" :key="item.importBatchId" class="import-history-row">
                        <div>
                          <strong>{{ sourceDisplayName(item.sourceCode) }}</strong>
                          <span>{{ item.fileName || '-' }}</span>
                        </div>
                        <v-chip size="x-small" :color="importStatusColor(item.status)" variant="tonal">
                          <v-progress-circular v-if="isImportActiveStatus(item.status)" indeterminate size="12" width="2" class="mr-1"></v-progress-circular>
                          {{ item.status }}
                        </v-chip>
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-actions class="px-6 pb-5">
                    <v-spacer></v-spacer>
                    <v-btn variant="text" @click="closeTestImportDialog">Cancel</v-btn>
                    <v-btn color="primary" variant="flat" :disabled="morningStarFiles.length === 0" :loading="runningTestImport" @click="runMorningStarFolderImport">
                      <v-icon start>mdi-cloud-upload-outline</v-icon> Queue file feed
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="showScheduleDialog" max-width="1320" content-class="mutual-fund-schedule-overlay" persistent>
                <v-card class="schedule-dialog-card">
                  <v-card-title class="schedule-dialog-header">
                    <div class="schedule-header-copy">
                      <div class="schedule-header-icon"><v-icon size="24">mdi-calendar-clock</v-icon></div>
                      <div>
                        <div class="schedule-dialog-title">Mutual Fund Data Sources</div>
                        <div class="schedule-dialog-subtitle">Manage live connections, synchronization, and controlled file-feed imports.</div>
                      </div>
                    </div>
                    <v-btn icon variant="text" color="white" aria-label="Close sync settings" @click="closeScheduleDialog"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>

                  <v-card-text class="schedule-dialog-content">
                    <div class="schedule-timezone-row">
                      <div>
                        <div class="schedule-section-label">Data operations</div>
                        <div class="schedule-section-hint">Live connections can run on a schedule. Managed file feeds are started by an administrator.</div>
                      </div>
                      <v-chip prepend-icon="mdi-earth" color="primary" variant="tonal" size="small">Asia/Bangkok (UTC+7)</v-chip>
                    </div>

                    <v-row class="schedule-card-grid">
                      <v-col v-for="schedule in schedulePreview" :key="schedule.source" cols="12" :md="schedule.source === 'CustomerApi' ? 7 : 5">
                        <v-card variant="outlined" class="source-schedule-card">
                          <div class="source-schedule-accent" :class="`source-schedule-accent--${schedule.tone}`"></div>
                          <v-card-text class="source-schedule-content">
                            <div class="source-schedule-topline">
                              <div class="source-identity">
                                <div class="source-icon" :class="`source-icon--${schedule.tone}`"><v-icon size="22">{{ schedule.icon }}</v-icon></div>
                                <div>
                                  <div class="source-title">{{ schedule.title }}</div>
                                  <div class="source-description">{{ schedule.description }}</div>
                                </div>
                              </div>
                              <v-chip size="small" color="indigo" variant="tonal">Per connection</v-chip>
                            </div>

                            <div class="source-table-summary">
                              <v-chip size="small" variant="tonal" :color="schedule.tone === 'api' ? 'primary' : 'indigo'">
                                <v-icon start size="16">mdi-table-multiple</v-icon>{{ schedule.source === 'CustomerApi' ? `${apiEndpoints.length} configured connections` : `${fileTableMappings.length || 5} configured file tables` }}
                              </v-chip>
                              <span>{{ schedule.source === 'CustomerApi' ? 'Each connection has its own schedule' : 'One path per connection' }}</span>
                            </div>

                            <template v-if="schedule.source === 'CustomerApi'">
                              <div class="endpoint-section-header">
                                <div>
                                  <strong>Configured connections</strong>
                                  <span>Each URL owns one logical Mutual Fund table and its own schedule.</span>
                                 </div>
                                 <div class="endpoint-section-actions">
                                   <v-btn size="small" color="primary" variant="text" prepend-icon="mdi-history" @click="openApiSyncHistory">History log</v-btn>
                                   <v-btn size="small" color="primary" variant="tonal" prepend-icon="mdi-play-circle-outline" :disabled="!apiEndpoints.some(endpoint => endpoint.isEnabled && !endpoint.isDraft)" :loading="runningAllEndpointSyncs" @click="runAllEndpointSyncs">Sync all now</v-btn>
                                   <v-btn size="small" color="primary" variant="outlined" prepend-icon="mdi-plus" @click="openApiEndpointDialog()">Add connection</v-btn>
                                 </div>
                              </div>

                              <div v-if="loadingApiEndpoints" class="endpoint-empty"><v-progress-circular indeterminate size="22"></v-progress-circular> Loading connections...</div>
                              <div v-else-if="apiEndpoints.length === 0" class="endpoint-empty">No connections yet. Add a customer API connection.</div>
                              <div v-else class="endpoint-list">
                                <div v-for="endpoint in apiEndpoints" :key="endpoint.apiEndpointId" class="endpoint-row api-connection-row">
                                  <div class="endpoint-row-main">
                                    <div class="endpoint-name-line">
                                      <strong>{{ endpoint.tableName }}</strong>
                                      <v-chip size="x-small" :color="endpoint.isDraft ? 'warning' : endpoint.isEnabled ? 'success' : 'grey'" variant="tonal">{{ endpoint.isDraft ? 'Pending' : endpoint.isEnabled ? 'Active' : 'Inactive' }}</v-chip>
                                    </div>
                                    <span>{{ endpoint.httpMethod }} · {{ endpoint.endpointUrl }}</span>
                                    <small v-if="endpoint.isDraft">Settings saved. Edit and test to finish response mappings; imports are off.</small>
                                    <small v-else>Response path: {{ endpoint.responseDataPath || 'Root response' }}</small>
                                  </div>
                                  <div class="api-connection-schedule">
                                    <div class="api-schedule-toggle">
                                      <v-switch v-model="endpoint.scheduleEnabled" :disabled="endpoint.isDraft || !endpoint.isEnabled" color="primary" inset hide-details density="compact" :aria-label="`Enable ${endpoint.tableName} schedule`" :title="`Enable ${endpoint.tableName} schedule`"></v-switch>
                                      <span>Daily sync</span>
                                    </div>
                                    <v-text-field v-model="endpoint.scheduleTime" type="time" aria-label="Daily sync time" title="Daily sync time" variant="outlined" density="compact" hide-details :disabled="!endpoint.scheduleEnabled"></v-text-field>
                                    <small>{{ endpoint.scheduleEnabled ? `Runs daily at ${endpoint.scheduleTime || '--:--'}` : 'Schedule off' }}</small>
                                    <div class="api-connection-schedule-actions">
                                      <v-btn size="small" variant="outlined" color="primary" :disabled="endpoint.isDraft || !endpoint.isEnabled" :loading="runningEndpointSyncId === endpoint.apiEndpointId" @click="runEndpointSync(endpoint)">Run now</v-btn>
                                      <v-btn size="small" color="primary" variant="flat" :disabled="endpoint.isDraft" :loading="savingEndpointScheduleId === endpoint.apiEndpointId" @click="saveEndpointSchedule(endpoint)">Save</v-btn>
                                    </div>
                                  </div>
                                  <div class="endpoint-actions">
                                    <v-btn icon size="small" variant="text" color="primary" :loading="testingApiEndpointId === endpoint.apiEndpointId" aria-label="Test connection" @click="testApiEndpoint(endpoint)"><v-icon size="19">mdi-connection</v-icon></v-btn>
                                    <v-btn icon size="small" variant="text" color="primary" aria-label="Edit connection" @click="openApiEndpointDialog(endpoint)"><v-icon size="19">mdi-pencil-outline</v-icon></v-btn>
                                    <v-btn icon size="small" variant="text" color="error" aria-label="Remove connection" @click="deleteApiEndpoint(endpoint)"><v-icon size="19">mdi-delete-outline</v-icon></v-btn>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <template v-else>
                              <div v-if="loadingFileFeedConnections" class="endpoint-empty"><v-progress-circular indeterminate size="22"></v-progress-circular> Loading file-feed connections...</div>
                              <div v-else class="endpoint-list">
                                <div v-for="connection in fileFeedConnections" :key="connection.fileFeedConnectionId" class="endpoint-row file-feed-row">
                                  <div class="endpoint-row-main file-feed-heading">
                                    <div class="endpoint-name-line">
                                      <strong>{{ connection.connectionName.replace(/^Morningstar demo /i, 'Morningstar ') }}</strong>
                                      <v-chip size="x-small" :color="connection.isEnabled ? 'success' : 'grey'" variant="tonal">{{ connection.isEnabled ? 'Active' : 'Inactive' }}</v-chip>
                                    </div>
                                    <small>Reads matching files from the source folder. Remote files are never moved or deleted.</small>
                                  </div>
                                  <div class="file-feed-summary" aria-label="SFTP connection summary">
                                    <div><span>Server</span><strong>SFTP · {{ connection.host || 'Not configured' }}<template v-if="connection.host">:{{ connection.port || 22 }}</template></strong></div>
                                    <div><span>Source folder</span><strong>{{ connection.remoteFolder || 'Not configured' }}</strong></div>
                                    <div><span>Authentication</span><strong>{{ fileFeedAuthenticationSummary(connection) }}</strong></div>
                                  </div>
                                  <div class="schedule-run-meta file-feed-activity mt-3">
                                    <div><span>Last connection activity</span><strong>{{ formatSftpRunTime(connection.lastRunAt) }}</strong></div>
                                  </div>
                                  <small v-if="!connection.isConfigured" class="file-feed-setup-message d-block mt-3">Complete the required connection fields before testing or running this feed.</small>
                                  <small v-if="connection.lastRunMessage" class="file-feed-last-message d-block mt-2">{{ connection.lastRunMessage }}</small>
                                  <div class="file-feed-run-controls">
                                    <v-text-field v-model="fileFeedRunDates[connection.fileFeedConnectionId]" type="date" label="Delivery date" variant="outlined" density="comfortable" :disabled="isFileFeedRunActive(connection.fileFeedConnectionId)" hint="Choose the date in the filenames to import." persistent-hint></v-text-field>
                                  </div>
                                  <div v-if="fileFeedRuns[connection.fileFeedConnectionId]" class="file-feed-import-status" role="status" aria-live="polite">
                                    <div class="d-flex align-center justify-space-between ga-2"><strong>Latest import</strong><v-chip size="small" :color="sftpRunColor(fileFeedRuns[connection.fileFeedConnectionId].status)" variant="tonal">{{ sftpRunStatus(fileFeedRuns[connection.fileFeedConnectionId].status) }}</v-chip></div>
                                    <small>Delivery {{ formatSftpDeliveryDate(fileFeedRuns[connection.fileFeedConnectionId].selectedDate) }}</small>
                                    <p>{{ sftpRunSummary(fileFeedRuns[connection.fileFeedConnectionId]) }}</p>
                                  </div>
                                  <div v-if="fileFeedRunPollErrors[connection.fileFeedConnectionId]" class="file-feed-poll-error text-error mt-2" role="alert">
                                    {{ fileFeedRunPollErrors[connection.fileFeedConnectionId] }}
                                    <v-btn size="small" variant="text" @click="refreshFileFeedRun(connection.fileFeedConnectionId)">Refresh run status</v-btn>
                                  </div>
                                  <div class="file-feed-actions">
                                    <v-btn size="small" variant="flat" color="indigo" prepend-icon="mdi-tune-variant" @click="openFileFeedConnectionDialog(connection)">Configure connection</v-btn>
                                    <v-btn size="small" variant="outlined" color="indigo" prepend-icon="mdi-connection" :disabled="!connection.isConfigured" :loading="testingFileFeedConnectionId === connection.fileFeedConnectionId" @click="testFileFeedConnection(connection)">Test connection</v-btn>
                                    <v-btn size="small" variant="tonal" color="indigo" prepend-icon="mdi-play-circle-outline" :disabled="!connection.isConfigured || !fileFeedRunDates[connection.fileFeedConnectionId] || isFileFeedRunActive(connection.fileFeedConnectionId) || !!fileFeedRunPollErrors[connection.fileFeedConnectionId] || !!fileFeedRunLoading[connection.fileFeedConnectionId]" :loading="runningFileFeedConnectionId === connection.fileFeedConnectionId" @click="runFileFeedConnection(connection)">Run now</v-btn>
                                    <v-btn class="file-feed-download" size="small" variant="outlined" color="indigo" prepend-icon="mdi-download" :disabled="!connection.isConfigured || !fileFeedRunDates[connection.fileFeedConnectionId]" :href="fileFeedDownloadUrl(connection)" target="_blank" rel="noopener" referrerpolicy="origin">Download this date as ZIP</v-btn>
                                    <v-btn class="file-feed-history-button" size="small" variant="outlined" color="indigo" prepend-icon="mdi-history" @click="openFileFeedHistory(connection)">History log</v-btn>
                                    <small class="file-feed-download-note">The ZIP holds only the files in the source folder matching the delivery date above. Nothing is imported and no remote file is moved. A new tab handles preparation and any errors; large ZIPs may take several minutes.</small>
                                  </div>
                                </div>
                              </div>
                              <v-divider class="my-4"></v-divider>
                              <div class="endpoint-section-header">
                                <div>
                                  <strong>Configured file tables</strong>
                                  <span>Choose which CSV fields are retained for each table.</span>
                                </div>
                              </div>
                              <div v-if="loadingFileTableMappings" class="endpoint-empty"><v-progress-circular indeterminate size="22"></v-progress-circular> Loading table mappings...</div>
                              <div v-else class="endpoint-list file-table-mapping-list">
                                <div v-for="mapping in fileTableMappings" :key="mapping.importTableId" class="endpoint-row file-table-mapping-row">
                                  <div class="endpoint-row-main">
                                    <div class="endpoint-name-line">
                                      <strong>{{ mapping.tableName }}</strong>
                                      <v-chip size="x-small" :color="mapping.isEnabled ? 'success' : 'grey'" variant="tonal">{{ mapping.isEnabled ? 'Active' : 'Inactive' }}</v-chip>
                                    </div>
                                    <span>{{ mapping.filePattern }}</span>
                                    <small>{{ importedFieldCount(mapping) }} kept fields · {{ fileRuleLabel(mapping) }} · Version {{ mapping.configurationVersion || 1 }}</small>
                                  </div>
                                  <div class="endpoint-actions">
                                    <v-btn size="small" color="indigo" variant="outlined" prepend-icon="mdi-table-cog" @click="openFileTableMappingDialog(mapping)">Configure fields</v-btn>
                                  </div>
                                </div>
                              </div>
                              <v-divider class="my-4"></v-divider>
                              <v-btn block color="indigo" variant="outlined" prepend-icon="mdi-folder-upload-outline" class="manual-sync-btn" @click="openMorningStarFolderDialog">Import files manually</v-btn>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-card variant="outlined" class="import-problem-panel mt-5">
                      <v-card-text>
                        <div class="import-problem-heading">
                          <div>
                            <div class="source-title"><v-icon start color="error">mdi-alert-circle-outline</v-icon>Connection &amp; import problems</div>
                            <div class="source-description">Live API and Morningstar SFTP connection test failures, ZIP download failures, run failures, and rejected imports appear here. Every failure sends a notification email automatically; Send email delivers the same notification again.</div>
                          </div>
                          <v-btn size="small" variant="outlined" color="primary" prepend-icon="mdi-refresh" :loading="loadingImportProblems" @click="loadImportProblems">Refresh</v-btn>
                        </div>

                        <v-row class="mt-2" align="center">
                          <v-col cols="12" md="9">
                            <label class="recipient-field-label" for="mutual-fund-recipient-input">Notification email recipients</label>
                            <div class="recipient-chip-editor">
                              <v-icon size="20" color="primary">mdi-email-outline</v-icon>
                              <v-chip v-for="recipient in importNotificationRecipients" :key="recipient" size="small" color="primary" variant="tonal" closable @click:close="removeImportNotificationRecipient(recipient)">{{ recipient }}</v-chip>
                              <input id="mutual-fund-recipient-input" v-model.trim="importNotificationRecipientDraft" type="email" inputmode="email" placeholder="Add email, then press Enter" aria-label="Add notification email recipient" @keydown.enter.prevent="addImportNotificationRecipient" @blur="addImportNotificationRecipient">
                            </div>
                            <small class="recipient-field-hint">One shared list for this company. Add an address with Enter; select × to remove it.</small>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-btn block class="recipient-save-button" color="primary" variant="flat" prepend-icon="mdi-content-save-outline" :loading="savingImportNotificationSettings" @click="saveImportNotificationSettings">Save recipients</v-btn>
                          </v-col>
                        </v-row>

                        <div v-if="loadingImportProblems" class="endpoint-empty"><v-progress-circular indeterminate size="22"></v-progress-circular> Loading connection and import problems...</div>
                        <div v-else class="import-problem-table-wrap">
                          <table class="import-problem-table">
                            <thead>
                              <tr><th>Batch / time</th><th>Operation / source</th><th>Problem</th><th>Rejected rows</th><th>Action</th></tr>
                            </thead>
                            <tbody>
                              <tr v-for="problem in displayedImportProblems" :key="problem.importBatchId">
                                <td><div class="import-problem-batch"><strong>{{ problem.importBatchId }}</strong></div><small>{{ formatScheduleDate(problem.startedAt) }}</small></td>
                                <td><strong class="import-problem-source">{{ importProblemOperation(problem) }}</strong><small class="d-block">{{ importProblemSource(problem) }}</small><small v-if="problem.fileName" class="d-block">{{ problem.fileName }}</small></td>
                                <td>
                                  <div class="import-problem-message">{{ problem.display.summary }}</div>
                                  <div v-if="problem.display.server" class="import-problem-server">{{ problem.display.server }}</div>
                                  <details v-if="problem.display.details" class="import-problem-details">
                                    <summary>{{ problem.display.network ? 'Network error' : 'Error details' }}</summary>
                                    <div>{{ problem.display.details }}</div>
                                  </details>
                                  <small>{{ problem.status }}<template v-if="problem.latestEmailStatus === 'Sent'"> · Email sent{{ problem.latestEmailBy === 'Automatic import notification' ? ' automatically' : '' }} {{ formatScheduleDate(problem.latestEmailAt) }}</template><template v-else-if="problem.latestEmailStatus === 'Failed'"> · Email delivery failed</template><template v-else> · Email not sent</template></small>
                                  <details v-if="problem.latestEmailStatus === 'Failed' && problem.latestEmailMessage" class="import-problem-details is-email-error"><summary>Email error</summary><div>{{ problem.latestEmailMessage }}</div></details>
                                </td>
                                <td class="import-problem-count">{{ problem.rejectedCount || 0 }}</td>
                                <td><v-btn size="small" :color="problem.latestEmailStatus === 'Sent' ? 'success' : 'error'" variant="outlined" :prepend-icon="problem.latestEmailStatus === 'Sent' ? 'mdi-email-check-outline' : 'mdi-email-sync-outline'" :disabled="problem.latestEmailStatus === 'Sent'" :loading="sendingImportProblemId === problem.importBatchId" @click="sendImportProblemEmail(problem)">{{ problem.latestEmailStatus === 'Sent' ? 'Email sent' : problem.latestEmailStatus === 'Failed' ? 'Retry email' : 'Send email' }}</v-btn></td>
                              </tr>
                              <tr v-if="importProblems.length === 0"><td colspan="5" class="import-problems-empty"><v-icon color="success" size="20">mdi-check-circle-outline</v-icon> No connection or import problems need review.</td></tr>
                            </tbody>
                          </table>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-card-text>

                  <v-divider></v-divider>
                  <v-card-actions class="schedule-dialog-actions">
                    <div class="schedule-action-note"><v-icon size="17">mdi-shield-key-outline</v-icon>API keys are encrypted and are never returned to the browser after saving.</div>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" variant="flat" @click="closeScheduleDialog">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="showApiSyncHistoryDialog" max-width="1000" scrollable>
                <v-card class="sftp-history-dialog">
                  <v-card-title class="d-flex align-center">
                    <span>History log</span>
                    <v-spacer></v-spacer>
                    <v-btn icon variant="text" aria-label="Close live data connection history" @click="closeApiSyncHistory"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-alert v-if="apiSyncHistoryError" type="warning" variant="tonal" class="mb-3">{{ apiSyncHistoryError }}</v-alert>
                    <v-progress-linear v-if="loadingApiSyncHistory" indeterminate class="mb-3"></v-progress-linear>
                    <template v-if="selectedApiSyncHistoryRun">
                      <v-btn variant="text" prepend-icon="mdi-arrow-left" class="sftp-history-back" @click="apiSyncHistorySelectedId = null; apiSyncTechnicalPanel = undefined">Back to history</v-btn>
                      <h2 class="sftp-history-title">History details</h2>
                      <p class="sftp-history-subtitle">{{ apiSyncConnectionLabel(selectedApiSyncHistoryRun) }} · {{ apiSyncTriggerLabel(selectedApiSyncHistoryRun.sourceType) }} · Run #{{ selectedApiSyncHistoryRun.importBatchId }}</p>
                      <div class="sftp-history-facts">
                        <div><span>Started (Bangkok)</span><strong>{{ formatSftpRunTime(selectedApiSyncHistoryRun.startedAt) }}</strong></div>
                        <div><span>Connection</span><strong>{{ apiSyncConnectionLabel(selectedApiSyncHistoryRun) }}</strong></div>
                        <div><span>Status</span><v-chip size="small" :color="sftpRunColor(selectedApiSyncHistoryRun.status)" variant="tonal">{{ sftpRunStatus(selectedApiSyncHistoryRun.status) }}</v-chip></div>
                      </div>
                      <v-alert :type="sftpRunAlertType(selectedApiSyncHistoryRun.status)" variant="tonal" class="my-5">{{ apiSyncRunSummary(selectedApiSyncHistoryRun) }}</v-alert>
                      <v-expansion-panels v-model="apiSyncTechnicalPanel" variant="accordion">
                        <v-expansion-panel title="Technical log">
                          <v-expansion-panel-text><pre class="file-feed-history-log">{{ apiSyncTechnicalLog(selectedApiSyncHistoryRun) }}</pre><small class="d-block mt-3">Row and table errors are available in Connection &amp; import problems.</small></v-expansion-panel-text>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </template>
                    <template v-else>
                      <div class="sftp-history-toolbar">
                        <div><h2 class="sftp-history-title">Live Data Connections</h2><p class="sftp-history-subtitle">Latest 25 runs · Newest first · Bangkok (UTC+7)</p></div>
                        <v-select v-model="apiSyncHistoryStatus" :items="['All statuses', 'Complete', 'Completed with warnings', 'Completed with errors', 'Failed', 'Running', 'Queued']" label="Status" variant="outlined" density="compact" hide-details class="sftp-history-filter"></v-select>
                      </div>
                      <div class="sftp-history-table-wrap">
                        <table class="sftp-history-table"><thead><tr><th>Time (Bangkok)</th><th>Connection</th><th>Trigger</th><th>Status</th><th><span class="sr-only">Details</span></th></tr></thead>
                          <tbody><tr v-for="run in filteredApiSyncHistory" :key="run.importBatchId"><td>{{ formatSftpRunTime(run.startedAt) }}</td><td>{{ apiSyncConnectionLabel(run) }}</td><td>{{ apiSyncTriggerLabel(run.sourceType) }}</td><td><v-chip size="small" :color="sftpRunColor(run.status)" variant="tonal"><v-progress-circular v-if="isImportActiveStatus(run.status)" indeterminate size="12" width="2" class="mr-1"></v-progress-circular>{{ sftpRunStatus(run.status) }}</v-chip></td><td><v-btn variant="text" size="small" color="primary" :aria-label="`View details for run ${run.importBatchId}`" @click="apiSyncHistorySelectedId = run.importBatchId; apiSyncTechnicalPanel = undefined">View details</v-btn></td></tr></tbody>
                        </table>
                      </div>
                      <p v-if="!loadingApiSyncHistory && !filteredApiSyncHistory.length" class="sftp-history-empty">{{ apiSyncHistoryStatus === 'All statuses' ? 'No live connection runs recorded yet.' : 'No runs match this status.' }}</p>
                    </template>
                  </v-card-text>
                  <v-card-actions><v-btn variant="text" :loading="loadingApiSyncHistory" @click="loadApiSyncHistory">Refresh history</v-btn><v-spacer></v-spacer><v-btn color="primary" variant="flat" @click="closeApiSyncHistory">Close</v-btn></v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="showFileFeedHistoryDialog" max-width="1000" scrollable>
                <v-card class="sftp-history-dialog">
                  <v-card-title class="d-flex align-center">
                    <span>History log</span>
                    <v-spacer></v-spacer>
                    <v-btn icon variant="text" aria-label="Close history log" @click="showFileFeedHistoryDialog = false"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-alert v-if="fileFeedHistoryError" type="warning" variant="tonal" class="mb-3">{{ fileFeedHistoryError }}</v-alert>
                    <v-progress-linear v-if="loadingFileFeedHistory" indeterminate class="mb-3"></v-progress-linear>
                    <template v-if="selectedFileFeedHistoryRun">
                      <v-btn variant="text" prepend-icon="mdi-arrow-left" class="sftp-history-back" @click="fileFeedHistorySelectedId = null; fileFeedTechnicalPanel = undefined">Back to history</v-btn>
                      <h2 class="sftp-history-title">History details</h2>
                      <p class="sftp-history-subtitle">{{ fileFeedHistoryConnection?.connectionName }} · {{ sftpRunTriggerLabel(selectedFileFeedHistoryRun) }} · Run #{{ selectedFileFeedHistoryRun.importBatchId }}</p>
                      <div class="sftp-history-facts">
                        <div><span>Started (Bangkok)</span><strong>{{ formatSftpRunTime(selectedFileFeedHistoryRun.startedAt) }}</strong></div>
                        <div v-if="isScheduledSftpRun(selectedFileFeedHistoryRun)"><span>File rule</span><strong>{{ selectedFileFeedHistoryRun.filePattern || '—' }}</strong></div>
                        <div v-else><span>Delivery date</span><strong>{{ formatSftpDeliveryDate(selectedFileFeedHistoryRun.selectedDate) }}</strong></div>
                        <div><span>Status</span><v-chip size="small" :color="sftpRunColor(selectedFileFeedHistoryRun.status)" variant="tonal">{{ sftpRunStatus(selectedFileFeedHistoryRun.status) }}</v-chip></div>
                      </div>
                      <v-alert :type="sftpRunAlertType(selectedFileFeedHistoryRun.status)" variant="tonal" class="my-5">{{ sftpRunSummary(selectedFileFeedHistoryRun) }}</v-alert>
                      <v-expansion-panels v-model="fileFeedTechnicalPanel" variant="accordion">
                        <v-expansion-panel title="Technical log">
                          <v-expansion-panel-text><pre class="file-feed-history-log">{{ sftpTechnicalLog(selectedFileFeedHistoryRun) }}</pre><small class="d-block mt-3">Row and table errors are available in Connection &amp; import problems.</small></v-expansion-panel-text>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </template>
                    <template v-else>
                      <div class="sftp-history-toolbar">
                        <div><h2 class="sftp-history-title">{{ fileFeedHistoryConnection?.connectionName }}</h2><p class="sftp-history-subtitle">Latest 25 runs, manual and scheduled · Newest first · Bangkok (UTC+7)</p></div>
                        <v-select v-model="fileFeedHistoryStatus" :items="['All statuses', 'Complete', 'Completed with errors', 'Failed', 'Running', 'Queued']" label="Status" variant="outlined" density="compact" hide-details class="sftp-history-filter"></v-select>
                      </div>
                      <div class="sftp-history-table-wrap">
                        <table class="sftp-history-table"><thead><tr><th>Time (Bangkok)</th><th>Trigger</th><th>Delivery date / file rule</th><th>Status</th><th><span class="sr-only">Details</span></th></tr></thead>
                          <tbody><tr v-for="run in filteredFileFeedHistory" :key="run.importBatchId"><td>{{ formatSftpRunTime(run.startedAt) }}</td><td>{{ sftpRunTriggerLabel(run) }}</td><td>{{ isScheduledSftpRun(run) ? (run.filePattern || '—') : formatSftpDeliveryDate(run.selectedDate) }}</td><td><v-chip size="small" :color="sftpRunColor(run.status)" variant="tonal">{{ sftpRunStatus(run.status) }}</v-chip></td><td><v-btn variant="text" size="small" color="primary" :aria-label="`View details for run ${run.importBatchId}`" @click="fileFeedHistorySelectedId = run.importBatchId; fileFeedTechnicalPanel = undefined">View details</v-btn></td></tr></tbody>
                        </table>
                      </div>
                      <p v-if="!loadingFileFeedHistory && !filteredFileFeedHistory.length" class="sftp-history-empty">{{ fileFeedHistoryStatus === 'All statuses' ? 'No imports recorded yet.' : 'No runs match this status.' }}</p>
                    </template>
                  </v-card-text>
                  <v-card-actions><v-btn variant="text" :loading="loadingFileFeedHistory" @click="loadFileFeedHistory">Refresh history</v-btn><v-spacer></v-spacer><v-btn color="primary" variant="flat" @click="showFileFeedHistoryDialog = false">Close</v-btn></v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="showFileFeedConnectionDialog" max-width="820" persistent>
                <v-card class="api-endpoint-dialog file-feed-connection-dialog">
                  <v-card-title class="api-endpoint-dialog-title">
                    <div>
                      <strong>Configure Morningstar SFTP</strong>
                      <span>Connect to the customer file server with username and password.</span>
                    </div>
                    <v-btn icon variant="text" aria-label="Close SFTP connection dialog" @click="closeFileFeedConnectionDialog"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="api-endpoint-dialog-content">
                    <v-alert type="info" variant="tonal" density="compact" class="mb-5">
                      Enter SFTP-visible folder paths such as <code>/Profita-Uat</code>. The server's Windows <code>D:\</code> path may not be visible to SFTP clients.
                    </v-alert>
                    <div class="endpoint-form-section-title"><span>1</span><div><strong>Connection</strong><small>The password is encrypted and never returned to the browser after saving.</small></div></div>
                    <v-row>
                      <v-col cols="12"><v-text-field v-model.trim="fileFeedConnectionForm.connectionName" label="Connection name" placeholder="Morningstar file feed" variant="outlined" density="comfortable"></v-text-field></v-col>
                      <v-col cols="12" md="9"><v-text-field v-model.trim="fileFeedConnectionForm.host" label="Host" placeholder="sftp-uat-internal.example.com" variant="outlined" density="comfortable" prepend-inner-icon="mdi-server-network"></v-text-field></v-col>
                      <v-col cols="12" md="3"><v-text-field v-model.number="fileFeedConnectionForm.port" label="Port" type="number" min="1" max="65535" variant="outlined" density="comfortable"></v-text-field></v-col>
                      <v-col cols="12" md="6"><v-text-field v-model.trim="fileFeedConnectionForm.sftpUsername" label="Username" autocomplete="username" variant="outlined" density="comfortable"></v-text-field></v-col>
                      <v-col cols="12" md="6"><v-select v-model="fileFeedConnectionForm.authenticationMethod" :items="['Username / password']" label="Authentication method" variant="outlined" density="comfortable" readonly></v-select></v-col>
                      <v-col cols="12">
                        <v-text-field v-model="fileFeedConnectionForm.password" :label="fileFeedConnectionForm.hasPassword ? 'Password (leave blank to keep current)' : 'Password'" :type="showSftpPassword ? 'text' : 'password'" autocomplete="new-password" variant="outlined" density="comfortable" hide-details><template #append-inner><v-btn icon size="small" variant="text" :aria-label="showSftpPassword ? 'Hide SFTP password' : 'Show SFTP password'" @click="showSftpPassword = !showSftpPassword"><v-icon size="18">{{ showSftpPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon></v-btn></template></v-text-field>
                        <small v-if="fileFeedConnectionForm.hasPassword && !fileFeedConnectionForm.password" class="sftp-password-kept"><v-icon size="15">mdi-lock-check-outline</v-icon> Stored password will be kept.</small>
                      </v-col>
                      <v-col cols="12"><v-text-field v-model.trim="fileFeedConnectionForm.remoteFolder" label="Remote source folder" placeholder="/Profita-Uat" variant="outlined" density="comfortable" hint="Files are read from this SFTP folder" persistent-hint></v-text-field></v-col>
                      <v-col cols="12"><v-text-field v-model.trim="fileFeedConnectionForm.hostKeyFingerprint" label="Server host-key fingerprint (optional for UAT)" placeholder="SHA256:..." variant="outlined" density="comfortable" hint="When supplied, a mismatch blocks the connection" persistent-hint></v-text-field></v-col>
                      <v-col cols="12"><v-switch v-model="fileFeedConnectionForm.isEnabled" color="indigo" inset hide-details label="Connection active"></v-switch></v-col>
                    </v-row>
                    <v-alert v-if="!fileFeedConnectionForm.hostKeyFingerprint" type="warning" variant="tonal" density="compact" class="mt-1 mb-4">
                      Host-key verification is not configured. Test connection will show the observed fingerprint so the team can confirm it before production.
                    </v-alert>
                    <v-alert v-if="fileFeedConfigurationTestResult" :type="fileFeedConfigurationTestResult.connected ? 'success' : 'error'" variant="tonal" density="compact" class="mb-4" role="status">
                      <strong>{{ fileFeedConfigurationTestResult.message }}</strong>
                      <div v-if="fileFeedConfigurationTestResult.observedHostKeyFingerprint" class="sftp-test-fingerprint">Observed fingerprint: {{ fileFeedConfigurationTestResult.observedHostKeyFingerprint }}</div>
                    </v-alert>
                    <div class="endpoint-test-row">
                      <span>Test authenticates and lists both folders. It does not import, move, or delete any file.</span>
                      <v-btn color="indigo" variant="outlined" prepend-icon="mdi-connection" :disabled="!canTestFileFeedConnection" :loading="testingFileFeedConfiguration" @click="testFileFeedConfiguration">Test connection</v-btn>
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="px-6 py-4"><v-spacer></v-spacer><v-btn variant="text" @click="closeFileFeedConnectionDialog">Cancel</v-btn><v-btn color="primary" variant="flat" prepend-icon="mdi-content-save-outline" :disabled="!canSaveFileFeedConnection" :loading="savingFileFeedConnectionId === fileFeedConnectionForm.fileFeedConnectionId" @click="saveFileFeedConnection">Save connection</v-btn></v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="showFileTableMappingDialog" max-width="960" persistent>
                <v-card class="api-endpoint-dialog file-table-mapping-dialog">
                  <v-card-title class="api-endpoint-dialog-title">
                    <div>
                      <strong>Configure file table</strong>
                      <span>Choose which delivered CSV fields are retained. Safe row matching is managed internally.</span>
                    </div>
                    <v-btn icon variant="text" color="white" aria-label="Close file-table configuration" @click="closeFileTableMappingDialog"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text class="pt-6">
                    <v-alert type="info" variant="tonal" density="compact" class="mb-5">
                      Saving prepares the logical table safely. New kept fields are added; removed fields remain in stored history but are no longer imported.
                    </v-alert>
                    <v-row>
                      <v-col cols="12"><v-text-field v-model.trim="fileTableMappingForm.tableName" label="Logical table name" variant="outlined" density="comfortable" disabled hide-details></v-text-field></v-col>
                    </v-row>
                    <section class="delivered-files-panel" aria-label="Delivered CSV files">
                      <div class="delivered-files-heading">
                        <div>
                          <strong>Delivered CSV files</strong>
                          <span>For Run now, use exactly one delivery-date token: <code>YYYYMMDD</code>, <code>DDMMYYYY</code> or <code>YYYY-MM-DD</code>, case-insensitive, without braces. Wildcards may appear elsewhere.</span>
                        </div>
                        <v-chip size="small" color="indigo" variant="tonal">{{ fileTableMappingForm.fileRules.length }} file{{ fileTableMappingForm.fileRules.length === 1 ? '' : 's' }}</v-chip>
                      </div>
                      <div class="delivered-file-rule-list">
                        <div v-for="(file, index) in fileTableMappingForm.fileRules" :key="`${file.fileRuleId || 'new'}-${index}`" class="delivered-file-rule-row" :class="{ 'is-monthly': file.scheduleFrequency === 'Monthly', 'is-hourly': file.scheduleFrequency === 'Hourly' }">
                          <div class="rule-file-identity">
                            <span class="rule-file-icon"><v-icon size="18">mdi-file-delimited-outline</v-icon></span>
                            <v-text-field v-model.trim="file.filePattern" label="Delivered CSV filename" placeholder="Historical_NAVYYYYMMDD.csv" variant="outlined" density="compact" :error-messages="file.isEnabled ? manualFilePatternError(file.filePattern) : []" hide-details="auto"></v-text-field>
                          </div>
                          <div class="rule-schedule-controls">
                            <v-select v-model="file.scheduleFrequency" :items="[{ title: 'Daily', value: 'Daily' }, { title: 'Monthly', value: 'Monthly' }, { title: 'Hourly', value: 'Hourly' }]" label="Schedule" variant="outlined" density="compact" hide-details @update:model-value="setFileRuleFrequency(file)"></v-select>
                            <v-menu v-if="file.scheduleFrequency === 'Monthly'" v-model="file.monthlyDayPickerOpen" :close-on-content-click="false" location="bottom start" transition="scale-transition">
                              <template #activator="{ props }">
                                <v-text-field :model-value="monthlyDayLabel(file.monthlyDay)" label="Monthly day" prepend-inner-icon="mdi-calendar-month-outline" readonly variant="outlined" density="compact" hide-details v-bind="props"></v-text-field>
                              </template>
                              <v-card class="monthly-day-picker-card" elevation="8">
                                <div class="monthly-day-picker-copy"><strong>Choose day of month</strong><span>The selected day repeats each month.</span></div>
                                <v-date-picker :model-value="monthlyDayCalendarValue(file.monthlyDay)" min="2024-01-01" max="2024-01-31" hide-header color="indigo" @update:model-value="selectMonthlyDay(file, $event)"></v-date-picker>
                              </v-card>
                            </v-menu>
                            <div v-else-if="file.scheduleFrequency === 'Hourly'" class="rule-hourly-summary"><v-icon size="16">mdi-clock-outline</v-icon><span>Every {{ file.hourlyIntervalHours || 1 }} hour{{ (file.hourlyIntervalHours || 1) === 1 ? '' : 's' }}</span></div>
                            <div v-else class="rule-daily-summary"><v-icon size="16">mdi-calendar-check-outline</v-icon><span>Every day</span></div>
                            <v-select v-if="file.scheduleFrequency === 'Hourly'" v-model.number="file.hourlyIntervalHours" :items="hourlyIntervalOptions" label="Hours" variant="outlined" density="compact" hide-details @update:model-value="setHourlyInterval(file, $event)"></v-select>
                            <v-text-field v-else v-model="file.expectedLocalTime" type="time" label="Run time" variant="outlined" density="compact" hide-details></v-text-field>
                            <v-select v-model="file.importMode" :items="[{ title: 'Update / insert', value: 'Upsert' }, { title: 'Replace snapshot', value: 'Replace' }]" label="Data action" variant="outlined" density="compact" hide-details></v-select>
                            <v-switch v-model="file.isEnabled" color="indigo" inset hide-details density="compact" :aria-label="`Enable ${file.filePattern || 'new file rule'}`" :title="`Enable ${file.filePattern || 'new file rule'}`"></v-switch>
                            <v-btn icon size="small" variant="text" color="error" :disabled="fileTableMappingForm.fileRules.length === 1" :aria-label="`Remove ${file.filePattern || 'file rule'}`" @click="removeFileTableRule(index)"><v-icon size="18">mdi-delete-outline</v-icon></v-btn>
                          </div>
                          <div v-if="file.scheduleFrequency === 'Monthly'" class="rule-monthly-note"><v-icon size="16">mdi-calendar-month-outline</v-icon><span>Runs on day {{ file.monthlyDay || 1 }} each month. If that day does not exist, it runs on the month’s last day.</span></div>
                          <div v-else-if="file.scheduleFrequency === 'Hourly'" class="rule-hourly-note"><v-icon size="16">mdi-clock-outline</v-icon><span>Runs every {{ file.hourlyIntervalHours || 1 }} hour{{ (file.hourlyIntervalHours || 1) === 1 ? '' : 's' }} after the previous queued run.</span></div>
                          <small v-if="file.lastRunStatus" class="delivered-file-rule-status" :class="`is-${String(file.lastRunStatus).toLowerCase()}`">Last run: {{ formatScheduleDate(file.lastRunAt) }} · {{ file.lastRunStatus }}<template v-if="file.lastRunMessage"> · {{ file.lastRunMessage }}</template></small>
                        </div>
                      </div>
                      <v-btn size="small" color="indigo" variant="text" prepend-icon="mdi-plus" class="mt-2" @click="addFileTableRule">Add delivered file</v-btn>
                    </section>
                    <div class="file-field-heading mt-6">
                      <div><strong>Field mappings</strong><span>Only kept fields are imported from the delivered CSV.</span></div>
                      <v-switch v-model="fileTableMappingForm.isEnabled" color="indigo" inset hide-details label="Table active"></v-switch>
                    </div>
                    <div class="file-field-grid-header"><span>Keep</span><span>CSV source column</span><span>Stored column</span><span>Required</span></div>
                    <div v-for="(field, index) in fileTableMappingForm.fields" :key="`${field.sourceColumn}-${index}`" class="file-field-grid">
                      <v-switch v-model="field.isImported" color="indigo" inset hide-details density="compact" :aria-label="`Keep ${field.sourceColumn}`"></v-switch>
                      <v-text-field v-model.trim="field.sourceColumn" variant="outlined" density="compact" hide-details :disabled="!field.isImported"></v-text-field>
                      <v-text-field v-model.trim="field.destinationColumn" variant="outlined" density="compact" hide-details :disabled="!field.isImported"></v-text-field>
                      <v-switch v-model="field.isRequired" color="primary" inset hide-details density="compact" :disabled="!field.isImported" :aria-label="`Require ${field.sourceColumn}`"></v-switch>
                    </div>
                    <v-btn variant="text" color="indigo" prepend-icon="mdi-plus" class="mt-3" @click="addFileTableField">Add field</v-btn>
                  </v-card-text>
                  <v-card-actions class="px-6 pb-5">
                    <v-spacer></v-spacer>
                    <v-btn variant="text" @click="closeFileTableMappingDialog">Cancel</v-btn>
                    <v-btn color="primary" variant="flat" prepend-icon="mdi-content-save-outline" :loading="savingFileTableMapping" @click="saveFileTableMapping">Save table configuration</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="showApiEndpointDialog" max-width="760" persistent>
                <v-card class="api-endpoint-dialog">
                  <v-card-title class="api-endpoint-dialog-title">
                    <div>
                      <strong>{{ apiEndpointForm.apiEndpointId ? 'Edit live connection' : 'Add live connection' }}</strong>
                      <span>{{ apiEndpointForm.useCompositeMapping ? 'One customer response can map to multiple logical tables.' : 'The table name is logical. Data is stored in tmp.mfTemporary&#123;ID&#125;.' }}</span>
                    </div>
                    <v-btn icon variant="text" aria-label="Close live connection dialog" @click="closeApiEndpointDialog"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="api-endpoint-dialog-content">
                    <div class="endpoint-form-section-title"><span>1</span><div><strong>Connection</strong><small>Enter the details supplied by the customer.</small></div></div>
                    <v-row>
                      <v-col cols="12"><v-text-field v-model.trim="apiEndpointForm.tableName" label="Table name" placeholder="fci_fund_master" variant="outlined" density="comfortable" hint="Shown in the Mutual Fund list" persistent-hint></v-text-field></v-col>
                      <v-col cols="12" md="3"><v-select v-model="apiEndpointForm.authenticationType" :items="[{ title: 'OAuth client credentials', value: 'OAuthClientCredentials' }, { title: 'API key', value: 'ApiKey' }]" label="Authentication" variant="outlined" density="comfortable" @update:model-value="onAuthenticationTypeChanged"></v-select></v-col>
                      <v-col cols="12" md="2"><v-select v-model="apiEndpointForm.httpMethod" :items="['GET', 'POST']" label="Method" variant="outlined" density="comfortable" @update:model-value="clearApiEndpointDiscovery"></v-select></v-col>
                      <v-col cols="12" md="7"><v-text-field v-model.trim="apiEndpointForm.endpointUrl" label="Fund API URL" placeholder="https://customer.example/enterprise/v1/mutual-funds/information" variant="outlined" density="comfortable" @update:model-value="clearApiEndpointDiscovery"></v-text-field></v-col>
                      <template v-if="apiEndpointForm.authenticationType === 'OAuthClientCredentials'">
                        <v-col cols="12" md="3"><v-select v-model="apiEndpointForm.authHttpMethod" :items="['GET', 'POST']" label="Auth method" variant="outlined" density="comfortable" @update:model-value="clearApiEndpointDiscovery"></v-select></v-col>
                        <v-col cols="12" md="9"><v-text-field v-model.trim="apiEndpointForm.authUrl" label="Auth URL" placeholder="https://customer.example/enterprise/v1/auth/token" variant="outlined" density="comfortable" @update:model-value="clearApiEndpointDiscovery"></v-text-field></v-col>
                        <v-col cols="12" md="5"><v-text-field v-model.trim="apiEndpointForm.clientId" label="Client ID" variant="outlined" density="comfortable" @update:model-value="clearApiEndpointDiscovery"></v-text-field></v-col>
                        <v-col cols="12" md="7"><v-text-field v-model="apiEndpointForm.clientSecret" :label="apiEndpointForm.apiEndpointId ? 'Client secret (leave blank to keep current)' : 'Client secret'" :type="showApiKey ? 'text' : 'password'" variant="outlined" density="comfortable"><template v-slot:append-inner><v-btn icon size="small" variant="text" :aria-label="showApiKey ? 'Hide client secret' : 'Show client secret'" @click="showApiKey = !showApiKey"><v-icon size="18">{{ showApiKey ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon></v-btn></template></v-text-field></v-col>
                      </template>
                      <template v-else>
                        <v-col cols="12" md="5"><v-text-field v-model.trim="apiEndpointForm.apiKeyHeader" label="API key header" placeholder="Api-Key" variant="outlined" density="comfortable" @update:model-value="clearApiEndpointDiscovery"></v-text-field></v-col>
                        <v-col cols="12" md="7"><v-text-field v-model="apiEndpointForm.apiKey" :label="apiEndpointForm.apiEndpointId ? 'API key (leave blank to keep current)' : 'API key'" :type="showApiKey ? 'text' : 'password'" variant="outlined" density="comfortable" @update:model-value="clearApiEndpointDiscovery"><template v-slot:append-inner><v-btn icon size="small" variant="text" :aria-label="showApiKey ? 'Hide API key' : 'Show API key'" @click="showApiKey = !showApiKey"><v-icon size="18">{{ showApiKey ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon></v-btn></template></v-text-field></v-col>
                        <v-col v-if="apiEndpointForm.httpMethod === 'POST'" cols="12"><v-textarea v-model="apiEndpointForm.requestBody" label="POST request body (JSON, optional)" variant="outlined" rows="4" auto-grow @update:model-value="clearApiEndpointDiscovery"></v-textarea></v-col>
                      </template>
                    </v-row>
                    <div class="endpoint-test-row">
                      <span>Save as pending keeps these settings without testing and leaves imports off. Test connection discovers the response mappings; failures appear in Connection &amp; import problems.</span>
                      <v-btn color="primary" variant="outlined" prepend-icon="mdi-connection" :loading="previewingApiEndpoint" @click="previewApiEndpoint">Test connection</v-btn>
                    </div>

                    <v-expansion-panels v-if="apiEndpointResponseJson" v-model="apiEndpointResponsePanel" class="mt-4 mb-4">
                      <v-expansion-panel title="View sample JSON response">
                        <v-expansion-panel-text>
                          <div class="d-flex align-start justify-space-between ga-3 mb-2">
                            <p class="text-caption mb-0">Actual fund API response from this test. Credentials are redacted. Nothing has been imported.</p>
                            <v-btn class="flex-shrink-0" size="small" variant="outlined" color="primary" prepend-icon="mdi-download" @click="downloadApiEndpointResponseJson">Download JSON</v-btn>
                          </div>
                          <pre style="max-height: 360px; overflow: auto; white-space: pre-wrap; overflow-wrap: anywhere;">{{ apiEndpointResponseJson }}</pre>
                        </v-expansion-panel-text>
                      </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expand-transition>
                      <div v-if="apiEndpointStructureReady" class="endpoint-discovery-panel">
                        <div class="endpoint-form-section-title"><span>2</span><div><strong>{{ apiEndpointForm.useCompositeMapping ? 'Returned collections' : 'Returned data' }}</strong><small>{{ apiEndpointForm.useCompositeMapping ? 'Keep the parent fund_code and map each returned section to its logical table.' : 'Confirm the detected rows and choose the field used to update matching records.' }}</small></div></div>
                        <v-alert type="success" variant="tonal" density="compact" class="mb-4" role="status">{{ apiEndpointPreviewMessage }}</v-alert>
                        <template v-if="apiEndpointForm.useCompositeMapping">
                          <v-row>
                            <v-col cols="12" md="4"><v-text-field v-model.trim="apiEndpointForm.identityField" label="Identity field" variant="outlined" density="comfortable" hint="Inherited by every child row" persistent-hint></v-text-field></v-col>
                            <v-col cols="12" md="8"><v-text-field v-model.trim="apiEndpointForm.identityPath" label="Identity JSON path" variant="outlined" density="comfortable" hint="Example: $.data[*].fund_code" persistent-hint></v-text-field></v-col>
                          </v-row>

                          <section class="composite-mapping-group" aria-label="One-to-one paths">
                            <div class="composite-mapping-group-heading"><div><strong>1:1 paths</strong><small>Objects merged into the table name above</small></div><div class="composite-mapping-group-actions"><v-btn size="small" color="primary" variant="outlined" prepend-icon="mdi-plus" @click="addCompositeCollection('1:1')">Add path</v-btn></div></div>
                            <div v-if="!compositeCollectionGroups.oneToOne.length" class="composite-mapping-empty">No 1:1 paths added yet.</div>
                            <div v-for="collection in compositeCollectionGroups.oneToOne" :key="collection.sourceName" class="composite-mapping-row composite-mapping-row--path-only">
                              <v-text-field v-model.trim="collection.path" label="JSON path" variant="outlined" density="compact" hide-details placeholder="$.data[*].configuration"></v-text-field>
                              <v-btn icon size="small" variant="text" color="error" :aria-label="'Remove ' + collection.sourceName" @click="removeCompositeCollection(collection)"><v-icon size="18">mdi-delete-outline</v-icon></v-btn>
                            </div>
                          </section>

                          <section class="composite-mapping-group composite-mapping-group-many" aria-label="One-to-many tables">
                            <div class="composite-mapping-group-heading"><div><strong>1:many tables</strong><small>Multiple returned objects per fund; each table keeps its own name</small></div><div class="composite-mapping-group-actions"><v-btn size="small" color="indigo" variant="outlined" prepend-icon="mdi-plus" @click="addCompositeCollection('1:many')">Add table</v-btn></div></div>
                            <div v-if="!compositeCollectionGroups.oneToMany.length" class="composite-mapping-empty">No 1:many tables added yet.</div>
                            <div v-for="collection in compositeCollectionGroups.oneToMany" :key="collection.sourceName" class="composite-mapping-row">
                              <v-text-field v-model.trim="collection.tableName" label="Table name" variant="outlined" density="compact" hide-details placeholder="fci_fund_fee"></v-text-field>
                              <v-text-field v-model.trim="collection.path" label="JSON path" variant="outlined" density="compact" hide-details placeholder="$.data[*].fees[*]"></v-text-field>
                              <v-btn icon size="small" variant="text" color="error" :aria-label="'Remove ' + collection.sourceName" @click="removeCompositeCollection(collection)"><v-icon size="18">mdi-delete-outline</v-icon></v-btn>
                            </div>
                          </section>
                        </template>
                        <template v-else>
                          <v-select v-if="apiEndpointResponseCandidates.length > 1" v-model="apiEndpointForm.responseDataPath" :items="apiEndpointResponseCandidates" item-title="label" item-value="path" label="Response data path" variant="outlined" density="comfortable" hint="More than one row array was found. Select the one that represents this table." persistent-hint @update:model-value="selectApiResponseCandidate"></v-select>
                          <v-text-field v-else v-model="apiEndpointForm.responseDataPath" label="Detected response data path" variant="outlined" density="comfortable" readonly></v-text-field>
                        </template>
                        <div v-if="!apiEndpointForm.useCompositeMapping && apiEndpointDiscoveredColumns.length" class="discovered-column-list">
                          <span>Returned columns</span>
                          <div><v-chip v-for="column in apiEndpointDiscoveredColumns" :key="column" size="x-small" variant="tonal">{{ column }}</v-chip></div>
                        </div>
                        <v-switch v-model="apiEndpointForm.isEnabled" color="primary" inset hide-details label="Endpoint active"></v-switch>
                      </div>
                    </v-expand-transition>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="px-6 py-4 flex-wrap ga-2">
                    <v-spacer></v-spacer>
                    <v-btn variant="text" @click="closeApiEndpointDialog">Cancel</v-btn>
                    <v-btn color="primary" variant="flat" :disabled="(!canSaveApiEndpoint && !canSaveApiEndpointDraft) || savingApiEndpoint || previewingApiEndpoint" :loading="savingApiEndpoint" @click="saveApiEndpoint(!canSaveApiEndpoint)">{{ canSaveApiEndpoint ? 'Save endpoint' : 'Save as pending' }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <MutualFundCardConfigDialog v-model="showCardConfigDialog" />
              <MutualFundViewLayerDialog v-model="showViewLayerDialog" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server class="mutual-fund-list-table" v-model:options="options" :items-per-page="itemsPerPage" :items-length="searchTotalTable" :items="dataTable" :headers="headers" :loading="loadingTable">
          <template v-slot:item="{ item }">
            <tr>
              <td class="number-cell">{{ item.number }}</td>
              <td class="table-name-cell">
                <div class="table-name-content">
                  <span class="table-icon-shell"><v-icon size="18">mdi-table</v-icon></span>
                  <span class="table-name-text">{{ item.dataName }}</span>
                </div>
              </td>
              <td class="created-by-cell">{{ item.createBy }}</td>
              <td class="status-cell">
                <v-chip :color="item.status ? '#F58468' : '#2ABF56'" size="small" class="status-chip">
                  <v-icon icon="mdi-circle-medium" start></v-icon>
                  <span style="color: black !important; font-size: 14px !important">{{ item.status || 'Active' }}</span>
                </v-chip>
              </td>
              <td class="active-cell">
                <div class="active-switch-wrap">
                  <v-switch
                    :model-value="item.activeStatus !== false"
                    @update:model-value="toggleActive(item, $event)"
                    size="small"
                    density="compact"
                    inset
                    hide-details
                    :disabled="!canEdit"
                    class="toggle-switch"
                    :class="item.activeStatus ? 'on' : 'off'"
                  ></v-switch>
                </div>
              </td>
              <td class="action-cell">
                <div class="action-group">
                  <div style="width: 35px; height: 35px; cursor: pointer" @click="Edit(item)">
                    <v-img v-if="canEdit" :src="editImgAction" alt="Edit Icon" height="30" width="30" aspect-ratio="1" />
                    <v-icon v-else color="primary" size="28">mdi-eye-outline</v-icon>
                  </div>
                  <div v-if="canDelete" class="trash-icon-wrapper" :class="{ 'is-disabled': btnDisableDelete(item) }">
                    <v-icon
                      @click="btnDisableDelete(item) ? null : Delete(item.id)"
                      :style="{ cursor: btnDisableDelete(item) ? 'not-allowed' : 'pointer' }"
                      :color="btnDisableDelete(item) ? 'grey-lighten-1' : 'red'"
                      size="30"
                    >mdi-trash-can-outline</v-icon>
                    <v-tooltip v-if="btnDisableDelete(item)" activator="parent" location="top">You can only delete items you created</v-tooltip>
                  </div>

                  <!-- <v-btn id="button-edit-uploadCSV" variant="text" density="comfortable" @click="Edit(item)" class="action-btn edit-btn" icon>
                    <v-icon size="18">mdi-pencil-outline</v-icon>
                  </v-btn>
                  <div class="action-divider"></div>
                  <!-- Delete -->
                  <!-- <v-btn id="button-delete-uploadCSV" variant="text" density="comfortable" @click="Delete(item.id)" class="action-btn delete-btn" icon :disabled="btnDisableDelete(item)">
                    <v-icon size="18">mdi-delete-outline</v-icon>
                  </v-btn> -->
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>
    <!-- loading -->
    <v-overlay :model-value="dialog" class="align-center justify-center">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <!-- Filter Navigation Drawer -->
    <v-navigation-drawer v-model="filterDrawer" location="right" temporary scrim width="400" class="filter-drawer-fullpage">
      <v-card flat height="100%" class="filter-drawer-card">
        <v-card-title class="d-flex align-center justify-space-between pa-4">
          <div class="d-flex align-center">
            <img :src="drawerIcon" alt="Filter" class="drawer-icon mr-2" />
            <span class="text-h7 font-weight-bold">Filter</span>
          </div>
          <v-btn icon variant="text" @click="filterDrawer = false" size="small">
            <v-icon size="24" color="#903F98">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <hr style="border: none; border-top: 1px solid #ededed" class="mx-4" />
        <v-card-text class="pa-4">
          <div class="mb-1">
            <h4 class="filter-section-title">Status</h4>
            <v-checkbox
              v-model="statusFilters.all"
              label="All"
              density="compact"
              hide-details
              class="mb-1 ml-1 custom-checkbox"
              :color="statusFilters.all ? '#76237E' : '#C9C9C9'"
              @click="handleStatusFilterClick('all')"
            ></v-checkbox>
            <v-checkbox
              v-model="statusFilters.active"
              label="Active"
              density="compact"
              hide-details
              class="mb-1 ml-1 custom-checkbox"
              :color="statusFilters.active ? '#76237E' : '#C9C9C9'"
              @click="handleStatusFilterClick('active')"
            ></v-checkbox>
            <v-checkbox
              v-model="statusFilters.inactive"
              label="Inactive"
              density="compact"
              hide-details
              class="mb-1 ml-1 custom-checkbox"
              :color="statusFilters.inactive ? '#76237E' : '#C9C9C9'"
              @click="handleStatusFilterClick('inactive')"
            ></v-checkbox>
          </div>

        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>
<script>
import checkPermissionTwo from '@/api/function.js';
import dateUtils from '../plugins/date-utils';
import DragDropFile from '@/components/DragDropFile.vue';
import MutualFundCardConfigDialog from '@/components/MutualFundCardConfigDialog.vue';
import MutualFundViewLayerDialog from '@/components/MutualFundViewLayerDialog.vue';
import ExcelJS from 'exceljs';
import moment from 'moment';
import editImg from '@/assets/edit1.png';
import deleteImg from '@/assets/delete1.png';
import EditIcon from '@/assets/images/edit-icon-new.svg';
import FilterIcon from '@/assets/images/mage_filter.svg';
import { cloneCustomerCompositeCollections, groupCustomerCompositeCollections } from '@/utils/mutualFundCompositeMapping.js';
import { formatApiSyncRunSummary } from '@/utils/mutualFundApiHistory.js';

export default {
  name: 'MutualFund',
  inject: ['flagNav', 'FontColorTitle', 'SubNavbarBackGround', 'Username', 'RoleId'],
  components: { DragDropFile, MutualFundCardConfigDialog, MutualFundViewLayerDialog },
  mixins: [checkPermissionTwo],
  data: () => ({
    showCardConfigDialog: false, // Tax card configs dialog (loads and saves itself)
    showViewLayerDialog: false, // View layer dialog (loads, saves and refreshes itself)
    updatingStatusFilters: false, // Flag to prevent infinite loops in status filter watcher
    searchDebounceTimer: null, // Timer for debouncing search input
    drawerIcon: FilterIcon,
    searchText: null,
    filterDrawer: false, // Filter drawer data
    statusFilters: {
      all: true,
      active: false,
      inactive: false,
    },
    editImgAction: EditIcon,

    //.......

    today: null,
    accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    searchMutualFundIntegrationName: null,
    AddMutualFundIntegration: false,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    loadingTable: false,
    dataTable: [],
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    dialog: false,
    files: [],
    uploadedFiles: [],
    chkAllColumns: false,
    requestMutualFundIntegration: {
      entity: null,
      MutualFundIntegrationName: null,
      ConnectionString: '',
      Schema: '',
      View: '',
      Columns: [{ name: '', typeId: 'nvarchar', fuzzy: false, fuzzyBot: false }],
      Type: 'I',
      Database: '',
    },
    DataRowUpload: [],
    DDDataType: [
      {
        id: 'nvarchar',
        name: 'nvarchar',
      },
      {
        id: 'varchar',
        name: 'varchar',
      },
      {
        id: 'int',
        name: 'int',
      },
      {
        id: 'bigint',
        name: 'bigint',
      },
      {
        id: 'float',
        name: 'float',
      },
      {
        id: 'decimal',
        name: 'decimal',
      },
      {
        id: 'datetime',
        name: 'datetime',
      },
      {
        id: 'datetimeoffset',
        name: 'datetimeoffset',
      },
      {
        id: 'bit',
        name: 'bit',
      },
    ],
    DDDatabase: [
      {
        id: '1',
        name: 'SQL Server',
      },
      {
        id: '2',
        name: 'Oracle',
      },
      {
        id: '3',
        name: 'Postgresql',
      },
      {
        id: '4',
        name: 'Mysql',
      },
      {
        id: '5',
        name: 'Snowflake',
      },
    ],
    rules: {
      required: (value) => !!value || 'Required.',
    },
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    sortBy: [],
    sortDesc: [],
    isFirst: true,
    isSearch: false,
    defaultFuzzy: 'none', // Default fuzzy option
    fuzzyOptions: [
      {
        text: 'None',
        value: 'none',
        description: 'No fuzzy matching applied',
        icon: 'mdi-close-circle-outline',
        color: 'grey',
      },
      {
        text: 'Fuzzy Search',
        value: 'fuzzy',
        description: 'Enable approximate text matching for this column',
        icon: 'mdi-magnify',
        color: 'primary',
      },
      {
        text: 'Fuzzy with Bot',
        value: 'fuzzyBot',
        description: 'AI-powered smart matching with enhanced accuracy',
        icon: 'mdi-robot',
        color: 'success',
      },
    ],
    errorMessages: {
      columns: [
        {
          error: false,
          message: '',
        },
      ],
    },
    showTestImportDialog: false,
    morningStarFiles: [],
    morningStarFolderName: '',
    importFrameworkReady: false,
    initializingImportFramework: false,
    runningTestImport: false,
    importHistory: [],
    lastImportMessage: '',
    lastImportHasErrors: false,
    lastImportAlertType: 'info',
    activeImportBatchId: null,
    importHistoryPollTimer: null,
    showScheduleDialog: false,
    apiEndpoints: [],
    loadingApiEndpoints: false,
    savingApiEndpoint: false,
    previewingApiEndpoint: false,
    apiEndpointStructureReady: false,
    apiEndpointDiscoveredColumns: [],
    apiEndpointResponseCandidates: [],
    apiEndpointPreviewMessage: '',
    apiEndpointResponseJson: '',
    apiEndpointResponsePanel: undefined,
    testingApiEndpointId: null,
    apiEndpointSchedules: {},
    savingEndpointScheduleId: null,
    runningEndpointSyncId: null,
    runningAllEndpointSyncs: false,
    showApiSyncHistoryDialog: false,
    apiSyncHistory: [],
    loadingApiSyncHistory: false,
    apiSyncHistoryError: '',
    apiSyncHistorySelectedId: null,
    apiSyncHistoryStatus: 'All statuses',
    apiSyncTechnicalPanel: undefined,
    apiSyncHistoryPollTimer: null,
    apiSyncHistoryGeneration: 0,
    fileFeedConnections: [],
    fileFeedRunDates: {},
    fileFeedRuns: {},
    fileFeedRunPollErrors: {},
    fileFeedRunLoading: {},
    fileFeedRunTimers: {},
    fileFeedRunGeneration: 0,
    showFileFeedHistoryDialog: false,
    fileFeedHistoryConnection: null,
    fileFeedHistory: [],
    loadingFileFeedHistory: false,
    fileFeedHistoryError: '',
    fileFeedHistorySelectedId: null,
    fileFeedHistoryStatus: 'All statuses',
    fileFeedTechnicalPanel: undefined,
    fileFeedHistoryGeneration: 0,
    loadingFileFeedConnections: false,
    showFileFeedConnectionDialog: false,
    showSftpPassword: false,
    testingFileFeedConfiguration: false,
    fileFeedConfigurationTestResult: null,
    fileFeedConnectionForm: {
      fileFeedConnectionId: null,
      connectionName: '',
      host: '',
      port: 22,
      sftpUsername: '',
      password: '',
      hasPassword: false,
      remoteFolder: '',
      hostKeyFingerprint: '',
      authenticationMethod: 'Username / password',
      isEnabled: false,
      localTime: '00:00',
      timeZoneId: 'Asia/Bangkok',
    },
    fileTableMappings: [],
    loadingFileTableMappings: false,
    showFileTableMappingDialog: false,
    savingFileTableMapping: false,
    fileTableMappingForm: {
      importTableId: null,
      tableName: '',
      filePattern: '',
      importMode: 'Upsert',
      isEnabled: true,
      fields: [],
      fileRules: [],
    },
    savingFileFeedConnectionId: null,
    testingFileFeedConnectionId: null,
    runningFileFeedConnectionId: null,
    importProblems: [],
    loadingImportProblems: false,
    importNotificationSettings: { recipients: '' },
    importNotificationRecipients: [],
    importNotificationRecipientDraft: '',
    savingImportNotificationSettings: false,
    sendingImportProblemId: null,
    showApiEndpointDialog: false,
    showApiKey: false,
    apiEndpointForm: {
      apiEndpointId: null,
      tableName: '',
      endpointUrl: '',
      httpMethod: 'GET',
      requestBody: '',
      apiKeyHeader: 'Api-Key',
      apiKey: '',
      hasApiKey: false,
      matchingKeys: [],
      responseDataPath: '',
      isEnabled: true,
      useCompositeMapping: true,
      identityField: 'fund_code',
      identityPath: '$.data[*].fund_code',
      collectionMappings: [],
    },
    schedulePreview: [
      {
        source: 'CustomerApi',
        title: 'Live Data Connections',
        description: 'Configurable HTTP sources with schema discovery',
        tableCount: 7,
        enabled: true,
        time: '01:00',
        frequency: 'Daily',
        icon: 'mdi-api',
        tone: 'api',
        lastRunAt: null,
      },
      {
        source: 'MorningStarSftp',
        title: 'Managed File Feeds',
        description: 'One connection path and timer per file feed',
        tableCount: 5,
        enabled: false,
        time: '03:00',
        frequency: 'Connection schedule',
        icon: 'mdi-folder-network-outline',
        tone: 'sftp',
        lastRunAt: null,
      },
    ],
  }),
  computed: {
    selectedApiSyncHistoryRun() {
      return this.apiSyncHistory.find(run => run.importBatchId === this.apiSyncHistorySelectedId) || null;
    },
    filteredApiSyncHistory() {
      return this.apiSyncHistory.filter(run => this.apiSyncHistoryStatus === 'All statuses' || this.sftpRunStatus(run.status) === this.apiSyncHistoryStatus);
    },
    selectedFileFeedHistoryRun() {
      return this.displayedFileFeedHistory.find(run => run.importBatchId === this.fileFeedHistorySelectedId) || null;
    },
    filteredFileFeedHistory() {
      return this.displayedFileFeedHistory.filter(run => this.fileFeedHistoryStatus === 'All statuses' || this.sftpRunStatus(run.status) === this.fileFeedHistoryStatus);
    },
    displayedFileFeedHistory() {
      const current = this.fileFeedRuns[this.fileFeedHistoryConnection?.fileFeedConnectionId];
      const runs = [...this.fileFeedHistory];
      if (current) {
        const index = runs.findIndex((run) => run.importBatchId === current.importBatchId);
        if (index < 0) runs.unshift(current);
        else runs[index] = this.newerFileFeedRun(runs[index], current);
      }
      return runs.sort((left, right) => right.importBatchId - left.importBatchId).slice(0, 25);
    },
    apiEndpointPreviewFingerprint() {
      const form = this.apiEndpointForm;
      return JSON.stringify([form.apiEndpointId, form.authenticationType, form.endpointUrl, form.httpMethod,
        form.requestBody, form.apiKeyHeader, form.apiKey, form.authUrl, form.authHttpMethod, form.clientId, form.clientSecret]);
    },
    displayedImportProblems() {
      return this.importProblems.map((problem) => ({ ...problem, display: this.describeImportProblem(problem) }));
    },
    hourlyIntervalOptions() {
      return Array.from({ length: 24 }, (_, index) => {
        const hours = index + 1;
        return {
          title: String(hours),
          value: hours,
        };
      });
    },
    isImportAdministrator() {
      return String(this.RoleId) === '0' || String(this.RoleId) === '1';
    },
    morningStarFolderSize() {
      const bytes = this.morningStarFiles.reduce((total, file) => total + Number(file.size || 0), 0);
      if (bytes < 1024) return `${bytes} B`;
      if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
      return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    },
    canSaveApiEndpointDraft() {
      const form = this.apiEndpointForm;
      if (!String(form.tableName || '').trim() || !String(form.endpointUrl || '').trim()) return false;
      if (form.authenticationType === 'OAuthClientCredentials') {
        return !!(String(form.authUrl || '').trim() && String(form.clientId || '').trim()
          && (String(form.clientSecret || '').trim() || (form.apiEndpointId && form.hasClientSecret)));
      }
      return !!(String(form.apiKeyHeader || '').trim()
        && (String(form.apiKey || '').trim() || (form.apiEndpointId && form.hasApiKey)));
    },
    canSaveApiEndpoint() {
      const form = this.apiEndpointForm;
      const hasKey = !!form.apiKey || (!!form.apiEndpointId && !!form.hasApiKey);
      const hasClientSecret = !!form.clientSecret || (!!form.apiEndpointId && !!form.hasClientSecret);
      if (form.useCompositeMapping && form.authenticationType === 'OAuthClientCredentials') {
        return !!(this.apiEndpointStructureReady && form.tableName && form.endpointUrl && form.authUrl && form.clientId && hasClientSecret && form.identityField && form.identityPath && (form.collectionMappings || []).length);
      }
      return !!(!form.useCompositeMapping && this.apiEndpointStructureReady && form.tableName && form.endpointUrl && hasKey && form.responseDataPath);
    },
    canTestFileFeedConnection() {
      const form = this.fileFeedConnectionForm;
      const hasPassword = !!form.password || (!!form.fileFeedConnectionId && !!form.hasPassword);
      const port = Number(form.port);
      return !!(form.host && port >= 1 && port <= 65535 && form.sftpUsername && hasPassword && form.remoteFolder);
    },
    canSaveFileFeedConnection() {
      return !!(this.fileFeedConnectionForm.connectionName && this.canTestFileFeedConnection);
    },
    compositeCollectionGroups() {
      return groupCustomerCompositeCollections(this.apiEndpointForm.collectionMappings || []);
    },
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('MutualFund');
    },
    canAdd() {
      return !!(this.$pagePermission && this.$pagePermission.canAdd('MutualFund'));
    },
    canEdit() {
      return !!(this.$pagePermission && this.$pagePermission.canEdit('MutualFund'));
    },
    canDelete() {
      return !!(this.$pagePermission && this.$pagePermission.canDelete('MutualFund'));
    },
    permissions() {
      return {
        add: this.$pagePermission && this.$pagePermission.canAdd('MutualFund'),
        edit: this.$pagePermission && this.$pagePermission.canEdit('MutualFund'),
        delete: this.$pagePermission && this.$pagePermission.canDelete('MutualFund'),
      }
    },
    headers() {
      return [
        {
          title: 'No.',
          align: 'center',
          sortable: false,
          width: '6%',
          minWidth: '60px',
        },
        {
          title: 'Table Name',
          value: 'Name',
          align: 'left',
          sortable: true,
          width: '48%',
          minWidth: '260px',
        },
        {
          title: 'Create by',
          value: 'CreateBy',
          align: 'left',
          sortable: true,
          width: '16%',
          minWidth: '140px',
        },
        {
          title: 'Status',
          value: 'Status',
          align: 'center',
          sortable: true,
          width: '11%',
          minWidth: '110px',
        },
        {
          title: 'Active',
          value: 'Active',
          align: 'center',
          sortable: false,
          width: '9%',
          minWidth: '96px',
        },
        {
          title: 'Action',
          align: 'center',
          sortable: false,
          width: '10%',
          minWidth: '120px',
        },
      ];
    },

  },
  watch: {
    showScheduleDialog(open) {
      if (!open) { this.stopFileFeedRunPolling(); this.showFileFeedHistoryDialog = false; }
    },
    showFileFeedHistoryDialog(open) {
      if (!open) { this.fileFeedHistoryGeneration += 1; this.loadingFileFeedHistory = false; }
    },
    showApiSyncHistoryDialog(open) {
      if (!open) this.stopApiSyncHistoryPolling();
    },
    apiEndpointPreviewFingerprint() {
      this.apiEndpointResponseJson = '';
      this.apiEndpointResponsePanel = undefined;
    },
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
    searchMutualFundIntegrationName: {
      handler() {
        this.debouncedSearch();
      },
    },
  },
  methods: {
    // Debounced search method to prevent excessive API calls
    debouncedSearch(searchValue) {
      // Clear existing timer
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }

      // Set new timer with 400ms delay
      this.searchDebounceTimer = setTimeout(() => {
        this.Search();
      }, 400);
    },
    formatDate(date) {
      if (!date) return null;
      // Format date to YYYY-MM-DD format
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    applyFilters() {
      this.Search();
    },

    handleStatusFilterClick(clickedFilter) {
      // Handle mutual exclusivity for status filters
      if (clickedFilter === 'all') {
        this.statusFilters = {
          all: !this.statusFilters.all,
          active: false,
          inactive: false,
        };
      } else if (clickedFilter === 'active') {
        this.statusFilters = {
          all: false,
          active: !this.statusFilters.active,
          inactive: false,
        };
      } else if (clickedFilter === 'inactive') {
        this.statusFilters = {
          all: false,
          active: false,
          inactive: !this.statusFilters.inactive,
        };
      }
      console.log('Status filter clicked:', clickedFilter, this.statusFilters);
      this.Search();
    },
    toggleFilterDrawer() {
      this.filterDrawer = !this.filterDrawer;
    },
    closeDialogAddMutualFundIntegration() {
      this.AddMutualFundIntegration = false;
      this.errorMessages.columns = [{ error: false, message: '' }];
    },
    loadImportFrameworkStatus() {
      if (!this.isImportAdministrator) return;
      this.$call.GetMutualFundImportFrameworkStatus(
        (response) => {
          if (response.status === 0) {
            this.importFrameworkReady = !!response.data?.isInitialized;
          }
        },
        () => {
          // The operational tables do not exist until setup. Keep the manual Mutual Fund page fully usable.
          this.importFrameworkReady = false;
        }
      );
    },
    loadImportHistory() {
      if (!this.isImportAdministrator) return;
      this.$call.GetMutualFundImportBatchHistory(
        10,
        (response) => {
          if (response.status !== 0) return;
          this.importHistory = response.data || [];
          if (this.showScheduleDialog) this.loadImportProblems();
          // SFTP runs own their connection-scoped polling lifecycle. Do not start the global timer for their parent/child rows.
          const activeBatch = this.importHistory.some((item) => !['SftpManualRun', 'SftpScheduledRun', 'Sftp'].includes(item.sourceType) && this.isImportActiveStatus(item.status));
          if (activeBatch) this.startImportHistoryPolling();
          else this.stopImportHistoryPolling();

          if (this.activeImportBatchId) {
            const tracked = this.importHistory.find((item) => item.importBatchId === this.activeImportBatchId);
            if (tracked && !this.isImportActiveStatus(tracked.status)) {
              const hasErrors = tracked.status === 'Failed' || tracked.status === 'CompletedWithErrors';
              const hasWarnings = tracked.status === 'CompletedWithWarnings';
              this.lastImportHasErrors = hasErrors || hasWarnings;
              this.lastImportAlertType = hasErrors ? 'error' : hasWarnings ? 'warning' : 'success';
              this.lastImportMessage = `Batch ${tracked.importBatchId}: ${tracked.status}. Inserted ${tracked.insertedCount || 0}, updated ${tracked.updatedCount || 0}, rejected ${tracked.rejectedCount || 0}.`;
              this.activeImportBatchId = null;
            }
          }
        },
        () => {
          this.importHistory = [];
          this.stopImportHistoryPolling();
        }
      );
    },
    isImportActiveStatus(status) {
      return status === 'Queued' || status === 'Running';
    },
    importStatusColor(status) {
      if (status === 'Succeeded' || status === 'Completed') return 'success';
      if (status === 'Running') return 'info';
      if (status === 'Queued') return 'primary';
      if (status === 'CompletedWithWarnings') return 'warning';
      return 'error';
    },
    sourceDisplayName(sourceCode) {
      return sourceCode === 'CustomerApi' ? 'Live Data Connections' : 'Managed File Feed';
    },
    startImportHistoryPolling() {
      if (this.importHistoryPollTimer) return;
      this.importHistoryPollTimer = setInterval(() => this.loadImportHistory(), 3000);
    },
    stopImportHistoryPolling() {
      if (!this.importHistoryPollTimer) return;
      clearInterval(this.importHistoryPollTimer);
      this.importHistoryPollTimer = null;
    },
    initializeImportFramework() {
      const self = this;
      self.$swal.fire({
        icon: 'warning',
        title: 'Prepare the 12 Mutual Fund tables?',
        text: 'This creates only the approved destination tables. It does not contact any live connection or remote file server.',
        showCancelButton: true,
        confirmButtonText: 'Prepare tables',
      }).then((result) => {
        if (!result.isConfirmed) return;
        self.initializingImportFramework = true;
        self.$call.InitializeMutualFundImportFramework(
          (response) => {
            self.initializingImportFramework = false;
            if (response.status === 0) {
              self.importFrameworkReady = !!response.data?.isInitialized;
              self.Get();
              self.$swal.fire({ icon: 'success', title: 'The 12 approved Mutual Fund tables are ready.', timer: 1800, showConfirmButton: false });
            } else {
              self.$swal.fire({ icon: 'error', title: response.message || 'Table setup failed.' });
            }
          },
          () => { self.initializingImportFramework = false; }
        );
      });
    },
    openTestImportDialog() {
      this.openMorningStarFolderDialog();
    },
    openMorningStarFolderDialog() {
      this.lastImportMessage = '';
      this.lastImportHasErrors = false;
      this.lastImportAlertType = 'info';
      this.showTestImportDialog = true;
      this.loadImportFrameworkStatus();
      this.loadImportHistory();
    },
    openScheduleDialog() {
      this.showScheduleDialog = true;
      this.loadApiEndpoints();
      this.loadSyncSchedules();
      this.loadFileFeedConnections();
      this.loadFileTableMappings();
      this.loadImportProblems();
      this.loadImportNotificationSettings();
    },
    closeScheduleDialog() {
      this.showScheduleDialog = false;
    },
    loadApiEndpoints() {
      this.loadingApiEndpoints = true;
      this.$call.GetMutualFundApiEndpoints(
        (response) => {
          this.loadingApiEndpoints = false;
          if (response.status === 0) {
            this.apiEndpoints = Array.isArray(response.data) ? response.data : [];
            this.applyApiEndpointSchedules();
          }
        },
        () => { this.loadingApiEndpoints = false; }
      );
    },
    loadFileFeedConnections() {
      this.loadingFileFeedConnections = true;
      this.$call.GetMutualFundFileFeedConnections(
        (response) => {
          this.loadingFileFeedConnections = false;
          if (response.status === 0) {
            this.fileFeedConnections = (Array.isArray(response.data) ? response.data : []).map((connection) => ({
              ...connection,
              port: Number(connection.port || 22),
            }));
            const ids = new Set(this.fileFeedConnections.map((connection) => String(connection.fileFeedConnectionId)));
            Object.keys(this.fileFeedRunTimers).forEach((id) => {
              if (!ids.has(id)) { clearTimeout(this.fileFeedRunTimers[id]); delete this.fileFeedRunTimers[id]; }
            });
            if (this.fileFeedHistoryConnection && !ids.has(String(this.fileFeedHistoryConnection.fileFeedConnectionId))) this.showFileFeedHistoryDialog = false;
            this.fileFeedConnections.forEach((connection) => {
              const id = connection.fileFeedConnectionId;
              if (!(id in this.fileFeedRunDates)) this.fileFeedRunDates[id] = '';
              if (this.showScheduleDialog) this.refreshFileFeedRun(id);
            });
          }
        },
        () => { this.loadingFileFeedConnections = false; }
      );
    },
    loadFileTableMappings() {
      this.loadingFileTableMappings = true;
      this.$call.GetMutualFundManagedFileTableMappings(
        (response) => {
          this.loadingFileTableMappings = false;
          if (response.status === 0) this.fileTableMappings = Array.isArray(response.data) ? response.data : [];
        },
        () => { this.loadingFileTableMappings = false; }
      );
    },
    loadImportProblems() {
      this.loadingImportProblems = true;
      this.$call.GetMutualFundImportProblems(
        (response) => {
          this.loadingImportProblems = false;
          if (response.status === 0) this.importProblems = Array.isArray(response.data) ? response.data : [];
        },
        () => { this.loadingImportProblems = false; }
      );
    },
    importProblemOperation(problem) {
      if (problem.sourceType === 'ConnectionTest') return 'Connection test';
      if (problem.sourceType === 'ConnectionDownload') return 'ZIP download';
      if (problem.sourceType === 'ConnectionRun') return 'Connection run';
      if (problem.sourceType === 'SftpScheduledRun') return 'Scheduled import';
      return 'Import';
    },
    isScheduledSftpRun(run) {
      return run?.sourceType === 'SftpScheduledRun';
    },
    sftpRunTriggerLabel(run) {
      return this.isScheduledSftpRun(run) ? 'Scheduled import' : 'Manual import';
    },
    describeImportProblem(problem) {
      const raw = String(problem.latestIssue || problem.message || 'No error details were recorded.');
      // HTTP responses are distinct from socket failures. Do not classify text inside a
      // customer's response body as our network error, and keep legacy status-only rows expandable.
      const httpFailure = raw.match(/Customer (?:(token|fund|data) )?endpoint returned HTTP (\d{3})\./i);
      if (httpFailure) {
        const status = Number(httpFailure[2]);
        const operation = httpFailure[1]?.toLowerCase() === 'token' ? 'Authentication request' : 'API request';
        let summary = `${operation} failed (HTTP ${status}).`;
        if (status === 401) summary = `${operation} was rejected as unauthorized (HTTP 401).`;
        else if (status === 403) summary = `${operation} was denied access (HTTP 403).`;
        const endpoint = raw.match(/\nEndpoint: ([^\r\n]+)/)?.[1] || '';
        const response = raw.match(/\nResponse: ([\s\S]*)/)?.[1];
        return {
          summary,
          server: endpoint,
          details: response
            ? `HTTP ${status}\n${response}`
            : `HTTP ${status}\nAdditional response details were not recorded for this attempt. Test again after the update to capture them.`,
          network: false,
        };
      }
      const causes = raw.split(/\s*→\s*/).filter(Boolean);
      // Keep the recorded network cause verbatim, without repeating our outer exception summaries.
      const socketCause = [...causes].reverse().find((cause) => /\b(?:NoData|HostNotFound|TryAgain|ConnectionRefused|TimedOut|NetworkUnreachable|HostUnreachable|ConnectionReset)\s*:/.test(cause));
      const server = raw.match(/\b(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9-]+:\d{1,5}\b/i)?.[0] || '';
      let summary = '';
      let network = false;
      if (/\b(?:NoData|HostNotFound|TryAgain)\s*:|no such host is known|no data of the requested type|name or service not known/i.test(raw)) {
        summary = 'DNS lookup failed. The server address could not be resolved.';
        network = true;
      } else if (/\bConnectionRefused\s*:|actively refused|connection refused/i.test(raw)) {
        summary = 'The server refused the connection.';
        network = true;
      } else if (/\bTimedOut\s*:|timed out|connection timeout/i.test(raw)) {
        summary = 'The connection timed out.';
        network = true;
      } else if (/\b(?:NetworkUnreachable|HostUnreachable)\s*:/i.test(raw)) {
        summary = 'The network could not reach the server.';
        network = true;
      } else if (/\bConnectionReset\s*:|connection reset/i.test(raw)) {
        summary = 'The connection was reset.';
        network = true;
      } else if (/HTTP 401\b|SFTP authentication failed/i.test(raw)) {
        summary = 'Authentication failed. Check the connection credentials.';
      } else if (/HTTP 403\b|does not have permission/i.test(raw)) {
        summary = 'The server denied access.';
      } else if (/SFTP folder was not found/i.test(raw)) {
        summary = 'The configured SFTP folder was not found.';
      }
      if (!summary) {
        if (raw.length <= 180 && causes.length === 1) return { summary: raw, server: '', details: '', network: false };
        summary = problem.sourceType === 'ConnectionTest' ? 'Connection test failed.' : 'The operation failed.';
      }
      return { summary, server, details: network ? (socketCause || causes[causes.length - 1] || raw) : raw, network };
    },
    importProblemSource(problem) {
      if (problem.sourceCode === 'CustomerApi') return 'Live API';
      if (problem.sourceCode === 'MorningStarSftp') return 'Morningstar SFTP';
      return problem.sourceCode || 'Unknown source';
    },
    loadImportNotificationSettings() {
      this.$call.GetMutualFundImportNotificationSettings(
        (response) => {
          if (response.status === 0) {
            const recipients = response.data?.recipients || '';
            this.importNotificationSettings = { recipients };
            this.importNotificationRecipients = this.parseImportNotificationRecipients(recipients);
          }
        }
      );
    },
    saveImportNotificationSettings() {
      if (!this.addImportNotificationRecipient()) return;
      if (this.importNotificationRecipients.length === 0) {
        this.$swal.fire({ icon: 'warning', title: 'Enter at least one email recipient.' });
        return;
      }
      this.importNotificationSettings.recipients = this.importNotificationRecipients.join('; ');
      this.savingImportNotificationSettings = true;
      this.$call.SaveMutualFundImportNotificationSettings(
        { recipients: this.importNotificationSettings.recipients },
        (response) => {
          this.savingImportNotificationSettings = false;
          if (response.status === 0) {
            const recipients = response.data?.recipients || this.importNotificationSettings.recipients;
            this.importNotificationSettings = { recipients };
            this.importNotificationRecipients = this.parseImportNotificationRecipients(recipients);
            this.$swal.fire({ icon: 'success', title: 'Notification recipients saved.', timer: 1600, showConfirmButton: false });
          } else this.$swal.fire({ icon: 'error', title: response.message || 'Recipients could not be saved.' });
        },
        () => { this.savingImportNotificationSettings = false; }
      );
    },
    sendImportProblemEmail(problem) {
      if (this.importNotificationRecipients.length === 0) {
        this.$swal.fire({ icon: 'warning', title: 'Save notification recipients first.' });
        return;
      }
      this.$swal.fire({
        icon: 'warning',
        title: problem.latestEmailStatus === 'Failed' ? 'Retry notification email?' : 'Send notification email?',
        text: 'This sends a notification for batch ' + problem.importBatchId + '; it does not rerun the connection or import.',
        showCancelButton: true,
        confirmButtonText: problem.latestEmailStatus === 'Failed' ? 'Retry email' : 'Send email',
      }).then((result) => {
        if (!result.isConfirmed) return;
        this.sendingImportProblemId = problem.importBatchId;
        this.$call.SendMutualFundImportProblemEmail(
          problem.importBatchId,
          (response) => {
            this.sendingImportProblemId = null;
            this.loadImportProblems();
            if (response.status === 0 && response.data?.sent) {
              this.$swal.fire({ icon: 'success', title: 'Notification email sent.', timer: 1800, showConfirmButton: false });
            } else this.$swal.fire({ icon: 'error', title: response.message || 'Email was not sent.' });
          },
          (error) => {
            this.sendingImportProblemId = null;
            this.loadImportProblems();
            const message = error?.response?.data?.message || error?.response?.data || 'Email was not sent.';
            this.$swal.fire({ icon: 'error', title: 'Email was not sent.', text: typeof message === 'string' ? message : '' });
          }
        );
      });
    },
    parseImportNotificationRecipients(value) {
      return [...new Set(String(value || '').split(/[;,\n]+/).map((item) => item.trim()).filter(Boolean).map((item) => item.toLowerCase()))];
    },
    addImportNotificationRecipient() {
      const entries = this.parseImportNotificationRecipients(this.importNotificationRecipientDraft);
      if (entries.length === 0) return true;
      const invalid = entries.find((entry) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(entry));
      if (invalid) {
        this.$swal.fire({ icon: 'warning', title: 'Enter a valid email address.', text: invalid });
        return false;
      }
      this.importNotificationRecipients = [...new Set([...this.importNotificationRecipients, ...entries])];
      this.importNotificationRecipientDraft = '';
      return true;
    },
    removeImportNotificationRecipient(recipient) {
      this.importNotificationRecipients = this.importNotificationRecipients.filter((item) => item !== recipient);
    },
    importedFieldCount(mapping) {
      return (mapping?.fields || []).filter((field) => field.isImported !== false).length;
    },
    fileRuleLabel(mapping) {
      if ((mapping?.tableName || '').startsWith('mns_historical_')) return 'Daily update/insert · monthly replace';
      return mapping?.importMode === 'Replace' ? 'Replace validated snapshot' : 'Update/insert';
    },
    openFileTableMappingDialog(mapping) {
      this.fileTableMappingForm = {
        importTableId: mapping.importTableId,
        tableName: mapping.tableName,
        filePattern: mapping.filePattern || '',
        importMode: mapping.importMode || 'Upsert',
        isEnabled: !!mapping.isEnabled,
        fields: (mapping.fields || []).map((field) => ({
          sourceColumn: field.sourceColumn || '',
          destinationColumn: field.destinationColumn || '',
          dataType: field.dataType || 'nvarchar',
          isRequired: !!field.isRequired,
          isImported: field.isImported !== false,
        })),
        fileRules: (mapping.fileRules || []).map((rule) => ({
          fileRuleId: rule.fileRuleId || null,
          filePattern: rule.filePattern || '',
          expectedLocalTime: rule.expectedLocalTime || '00:00',
          scheduleFrequency: rule.scheduleFrequency || 'Daily',
          hourlyIntervalHours: rule.scheduleFrequency === 'Hourly' ? (Number(rule.hourlyIntervalHours) || 1) : 1,
          monthlyDay: rule.monthlyDay || (rule.scheduleFrequency === 'Monthly' ? 1 : null),
          monthlyDayPickerOpen: false,
          importMode: rule.importMode || 'Upsert',
          isEnabled: rule.isEnabled !== false,
          lastRunAt: rule.lastRunAt || null,
          lastRunStatus: rule.lastRunStatus || null,
          lastRunMessage: rule.lastRunMessage || null,
        })),
      };
      if (this.fileTableMappingForm.fileRules.length === 0) this.addFileTableRule();
      this.showFileTableMappingDialog = true;
    },
    closeFileTableMappingDialog() {
      this.showFileTableMappingDialog = false;
    },
    addFileTableField() {
      this.fileTableMappingForm.fields.push({ sourceColumn: '', destinationColumn: '', dataType: 'nvarchar', isRequired: false, isImported: true });
    },
    addFileTableRule() {
      this.fileTableMappingForm.fileRules.push({ fileRuleId: null, filePattern: '', expectedLocalTime: '00:00', scheduleFrequency: 'Daily', hourlyIntervalHours: 1, monthlyDay: null, monthlyDayPickerOpen: false, importMode: 'Upsert', isEnabled: true });
    },
    setFileRuleFrequency(file) {
      if (file.scheduleFrequency === 'Monthly') {
        if (!file.monthlyDay) file.monthlyDay = 1;
        file.hourlyIntervalHours = 1;
      } else if (file.scheduleFrequency === 'Hourly') {
        file.monthlyDay = null;
        if (!Number.isInteger(file.hourlyIntervalHours) || file.hourlyIntervalHours < 1 || file.hourlyIntervalHours > 24) file.hourlyIntervalHours = 1;
        this.setHourlyInterval(file, file.hourlyIntervalHours);
      } else {
        file.monthlyDay = null;
        file.hourlyIntervalHours = 1;
      }
    },
    setHourlyInterval(file, interval) {
      const value = Number(interval);
      file.hourlyIntervalHours = Number.isInteger(value) && value >= 1 && value <= 24 ? value : 1;
      file.expectedLocalTime = '00:00';
    },
    monthlyDayLabel(day) {
      return `Day ${String(Math.min(31, Math.max(1, Number(day) || 1))).padStart(2, '0')}`;
    },
    monthlyDayCalendarValue(day) {
      return `2024-01-${String(Math.min(31, Math.max(1, Number(day) || 1))).padStart(2, '0')}`;
    },
    selectMonthlyDay(file, selectedDate) {
      const value = Array.isArray(selectedDate) ? selectedDate[0] : selectedDate;
      const day = value instanceof Date
        ? value.getDate()
        : Number(String(value || '').match(/(\d{2})(?:T.*)?$/)?.[1]);
      if (Number.isInteger(day) && day >= 1 && day <= 31) file.monthlyDay = day;
      file.monthlyDayPickerOpen = false;
    },
    removeFileTableRule(index) {
      if (this.fileTableMappingForm.fileRules.length > 1) this.fileTableMappingForm.fileRules.splice(index, 1);
    },
    saveFileTableMapping() {
      const form = this.fileTableMappingForm;
      if (!form.importTableId || !form.fileRules.length || form.fileRules.some((rule) => !rule.filePattern || !rule.expectedLocalTime || (rule.scheduleFrequency === 'Monthly' && !rule.monthlyDay)) || !form.fields.some((field) => field.isImported)) {
        this.$swal.fire({ icon: 'warning', title: 'Configure at least one delivered CSV file and keep at least one field.' });
        return;
      }
      this.savingFileTableMapping = true;
      this.$call.SaveMutualFundManagedFileTableMapping(
        {
          importTableId: form.importTableId,
          filePattern: form.filePattern,
          importMode: form.importMode,
          isEnabled: !!form.isEnabled,
          fields: form.fields,
          fileRules: form.fileRules,
        },
        (response) => {
          this.savingFileTableMapping = false;
          if (response.status === 0) {
            this.closeFileTableMappingDialog();
            this.loadFileTableMappings();
            this.$swal.fire({ icon: 'success', title: 'File-table configuration saved', text: 'The table is prepared safely for its next import.', timer: 1800, showConfirmButton: false });
          } else this.$swal.fire({ icon: 'error', title: response.message || 'Configuration could not be saved.' });
        },
        () => { this.savingFileTableMapping = false; }
      );
    },
    openFileFeedConnectionDialog(connection) {
      this.fileFeedConfigurationTestResult = null;
      this.showSftpPassword = false;
      this.fileFeedConnectionForm = {
        fileFeedConnectionId: connection?.fileFeedConnectionId || null,
        connectionName: connection?.connectionName?.replace(/^Morningstar demo /i, 'Morningstar ') || 'Morningstar file feed',
        host: connection?.host || '',
        port: Number(connection?.port || 22),
        sftpUsername: connection?.sftpUsername || '',
        password: '',
        hasPassword: !!connection?.hasPassword,
        remoteFolder: connection?.remoteFolder || '',
        hostKeyFingerprint: connection?.hostKeyFingerprint || '',
        authenticationMethod: 'Username / password',
        isEnabled: !!connection?.isEnabled,
        localTime: connection?.localTime || '00:00',
        timeZoneId: connection?.timeZoneId || 'Asia/Bangkok',
      };
      this.showFileFeedConnectionDialog = true;
    },
    fileFeedAuthenticationSummary(connection) {
      if (connection?.sftpUsername && connection?.hasPassword) return 'Username / password';
      if (connection?.sftpUsername) return 'Username set · Password missing';
      if (connection?.hasPassword) return 'Password set · Username missing';
      return 'Username / password · Not configured';
    },
    closeFileFeedConnectionDialog() {
      if (this.testingFileFeedConfiguration || this.savingFileFeedConnectionId !== null) return;
      this.showFileFeedConnectionDialog = false;
      this.fileFeedConfigurationTestResult = null;
      this.showSftpPassword = false;
      this.fileFeedConnectionForm.password = '';
    },
    fileFeedConnectionRequest() {
      const form = this.fileFeedConnectionForm;
      return {
        fileFeedConnectionId: form.fileFeedConnectionId,
        connectionName: form.connectionName,
        host: form.host,
        port: Number(form.port || 22),
        sftpUsername: form.sftpUsername,
        password: form.password,
        remoteFolder: form.remoteFolder,
        hostKeyFingerprint: form.hostKeyFingerprint || null,
        isEnabled: !!form.isEnabled,
        // Legacy schedule fields remain for compatibility; individual CSV rules own the schedule.
        localTime: form.localTime || '00:00',
        timeZoneId: form.timeZoneId || 'Asia/Bangkok',
      };
    },
    saveFileFeedConnection() {
      if (!this.canSaveFileFeedConnection) {
        this.$swal.fire({ icon: 'warning', title: 'Complete the required SFTP connection fields.' });
        return;
      }
      const connectionId = this.fileFeedConnectionForm.fileFeedConnectionId;
      this.savingFileFeedConnectionId = connectionId;
      this.$call.SaveMutualFundFileFeedConnection(
        this.fileFeedConnectionRequest(),
        (response) => {
          this.savingFileFeedConnectionId = null;
          if (response.status === 0) {
            this.showFileFeedConnectionDialog = false;
            this.fileFeedConnectionForm.password = '';
            this.loadFileFeedConnections();
            this.$swal.fire({ icon: 'success', title: 'File-feed connection saved.', timer: 1600, showConfirmButton: false });
          } else this.$swal.fire({ icon: 'error', title: response.message || 'Connection could not be saved.' });
        },
        () => { this.savingFileFeedConnectionId = null; }
      );
    },
    testFileFeedConfiguration() {
      if (!this.canTestFileFeedConnection) return;
      this.testingFileFeedConfiguration = true;
      this.fileFeedConfigurationTestResult = null;
      this.$call.TestMutualFundFileFeedConfiguration(
        this.fileFeedConnectionRequest(),
        (response) => {
          this.testingFileFeedConfiguration = false;
          this.loadImportProblems();
          if (response.status === 0) {
            this.fileFeedConfigurationTestResult = response.data || { connected: false, message: 'Connection test failed.' };
            if (this.fileFeedConnectionForm.fileFeedConnectionId) this.loadFileFeedConnections();
          } else {
            this.fileFeedConfigurationTestResult = { connected: false, message: response.message || 'Connection test failed.' };
          }
        },
        () => {
          this.testingFileFeedConfiguration = false;
          this.loadImportProblems();
          this.fileFeedConfigurationTestResult = { connected: false, message: 'Connection test could not be completed. Review Connection & import problems for recorded failures.' };
        }
      );
    },
    testFileFeedConnection(connection) {
      this.testingFileFeedConnectionId = connection.fileFeedConnectionId;
      this.$call.TestMutualFundFileFeedConnection(
        connection.fileFeedConnectionId,
        (response) => {
          this.testingFileFeedConnectionId = null;
          this.loadImportProblems();
          if (response.status === 0) {
            const result = response.data || {};
            this.loadFileFeedConnections();
            this.$swal.fire({
              icon: result.connected ? 'success' : 'error',
              title: result.connected ? 'SFTP connection authenticated' : 'SFTP connection failed',
              text: result.message || 'Connection test failed.',
            });
          } else this.$swal.fire({ icon: 'error', title: response.message || 'Connection test failed.' });
        },
        () => {
          this.testingFileFeedConnectionId = null;
          this.loadImportProblems();
        }
      );
    },
    fileFeedRunLastMessage(run) {
      return String(run?.message || '').split('\n').filter(Boolean).pop() || '';
    },
    formatSftpDeliveryDate(value) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return value || '—';
      return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' }).format(new Date(`${value}T00:00:00Z`));
    },
    formatSftpRunTime(value) {
      if (!value) return '—';
      const text = String(value);
      const date = new Date(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(text) ? text : `${text}Z`);
      if (Number.isNaN(date.getTime())) return '—';
      return new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Bangkok', day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).format(date);
    },
    sftpRunStatus(status) {
      return ({ Completed: 'Complete', Succeeded: 'Complete', CompletedWithErrors: 'Completed with errors', CompletedWithWarnings: 'Completed with warnings' })[status] || status || 'Unknown';
    },
    sftpRunColor(status) {
      return ({ Completed: 'success', Succeeded: 'success', CompletedWithErrors: 'warning', CompletedWithWarnings: 'warning', Failed: 'error', Running: 'info', Queued: 'info' })[status] || 'grey';
    },
    sftpRunAlertType(status) {
      return ({ Completed: 'success', Succeeded: 'success', CompletedWithErrors: 'warning', Failed: 'error' })[status] || 'info';
    },
    sftpRunSummary(run) {
      if (run?.status === 'Queued') return 'Waiting to start. No files have been imported by this run yet.';
      const message = this.fileFeedRunLastMessage(run).replace(/^\d{4}-\d{2}-\d{2}T[\d:.]+\s+UTC\s*[—-]\s*/, '').replace(/^Delivery \d{4}-\d{2}-\d{2}:\s*/, '');
      if (/No matching CSV files for delivery/.test(message)) return `No files matched ${this.formatSftpDeliveryDate(run.selectedDate)}. Nothing was imported.`;
      return message || (run?.status === 'Running' ? 'Import in progress. Open the technical log for details.' : 'No result details were recorded.');
    },
    sftpTechnicalLog(run) {
      return String(run?.message || 'No details recorded.').replace(/(\d{4}-\d{2}-\d{2}T[\d:.]+) UTC/g, (_, stamp) => `${this.formatSftpRunTime(stamp)} Bangkok`);
    },
    newerFileFeedRun(left, right) {
      if (!left) return right;
      if (!right) return left;
      if (left.importBatchId !== right.importBatchId) return left.importBatchId > right.importBatchId ? left : right;
      const leftActive = this.isImportActiveStatus(left.status);
      const rightActive = this.isImportActiveStatus(right.status);
      if (leftActive !== rightActive) return leftActive ? right : left;
      return String(left.message || '').length >= String(right.message || '').length ? left : right;
    },
    openFileFeedHistory(connection) {
      this.fileFeedHistoryGeneration += 1;
      this.fileFeedHistoryConnection = connection;
      this.fileFeedHistory = [];
      this.fileFeedHistorySelectedId = null;
      this.fileFeedHistoryStatus = 'All statuses';
      this.fileFeedTechnicalPanel = undefined;
      this.showFileFeedHistoryDialog = true;
      this.loadFileFeedHistory();
    },
    loadFileFeedHistory() {
      if (!this.showFileFeedHistoryDialog || !this.fileFeedHistoryConnection) return;
      const id = this.fileFeedHistoryConnection.fileFeedConnectionId;
      const generation = ++this.fileFeedHistoryGeneration;
      this.loadingFileFeedHistory = true;
      this.fileFeedHistoryError = '';
      const isCurrent = () => generation === this.fileFeedHistoryGeneration && this.showFileFeedHistoryDialog && this.fileFeedHistoryConnection?.fileFeedConnectionId === id;
      const failed = () => {
        if (!isCurrent()) return;
        this.loadingFileFeedHistory = false;
        this.fileFeedHistoryError = 'History could not be loaded. This does not mean an import failed.';
      };
      this.$call.GetMutualFundFileFeedRunHistory(id, (response) => {
        if (!isCurrent()) return;
        if (response.status !== 0) { failed(); return; }
        this.loadingFileFeedHistory = false;
        this.fileFeedHistory = Array.isArray(response.data) ? response.data : [];
        const wasActive = this.isFileFeedRunActive(id);
        // Only Run now rows drive the Latest import card and Run now lock; scheduled rows are listed but never polled.
        const latestManualRun = this.fileFeedHistory.find((run) => !this.isScheduledSftpRun(run));
        if (latestManualRun) this.fileFeedRuns[id] = this.newerFileFeedRun(this.fileFeedRuns[id], latestManualRun);
        if (wasActive && !this.isFileFeedRunActive(id)) { this.loadImportHistory(); this.loadImportProblems(); }
        this.refreshFileFeedRun(id);
      }, failed);
    },
    manualFilePatternError(pattern) {
      const value = String(pattern || '');
      const tokens = value.match(/YYYYMMDD|DDMMYYYY|YYYY-MM-DD/gi) || [];
      const remainder = value.replace(/YYYYMMDD|DDMMYYYY|YYYY-MM-DD/gi, '');
      if (tokens.length !== 1 || /[{}]|Y{2,}|D{2,}[-_/]?M{2,}|M{2,}[-_/]?D{2,}/i.test(remainder))
        return 'Run now requires exactly one YYYYMMDD, DDMMYYYY or YYYY-MM-DD token, without braces. Other patterns remain usable by legacy schedules only.';
      return '';
    },
    isFileFeedRunActive(id) {
      return ['Queued', 'Running'].includes(this.fileFeedRuns[id]?.status);
    },
    stopFileFeedRunPolling() {
      this.fileFeedRunGeneration += 1;
      this.fileFeedHistoryGeneration += 1;
      Object.values(this.fileFeedRunTimers).forEach(clearTimeout);
      this.fileFeedRunTimers = {};
      this.fileFeedRunLoading = {};
      this.runningFileFeedConnectionId = null;
    },
    refreshFileFeedRun(id) {
      if (!this.showScheduleDialog || this.fileFeedRunLoading[id] || !this.fileFeedConnections.some((connection) => connection.fileFeedConnectionId === Number(id))) return;
      clearTimeout(this.fileFeedRunTimers[id]);
      delete this.fileFeedRunTimers[id];
      const generation = this.fileFeedRunGeneration;
      const currentRun = this.fileFeedRuns[id];
      const runId = this.isFileFeedRunActive(id) ? currentRun.importBatchId : null;
      this.fileFeedRunLoading[id] = true;
      const isCurrent = () => generation === this.fileFeedRunGeneration && this.showScheduleDialog && this.fileFeedConnections.some((connection) => connection.fileFeedConnectionId === Number(id));
      const failed = () => {
        if (!isCurrent()) return;
        this.fileFeedRunLoading[id] = false;
        this.fileFeedRunPollErrors[id] = 'Run status could not be refreshed. This does not mean the import failed. Refresh status before submitting again.';
      };
      this.$call.GetMutualFundFileFeedRun(id, runId, (response) => {
        if (!isCurrent()) return;
        if (response.status !== 0) { failed(); return; }
        this.fileFeedRunLoading[id] = false;
        this.fileFeedRunPollErrors[id] = '';
        this.fileFeedRuns[id] = this.newerFileFeedRun(this.fileFeedRuns[id], response.data || null);
        if (this.isFileFeedRunActive(id)) {
          this.fileFeedRunTimers[id] = setTimeout(() => this.refreshFileFeedRun(id), 2500);
        } else if (currentRun && ['Queued', 'Running'].includes(currentRun.status)) {
          this.loadImportHistory();
          this.loadImportProblems();
        }
      }, failed);
    },
    fileFeedDownloadUrl(connection) {
      // Anchor downloads cannot carry a body, so the delivery date travels in the query string.
      const selectedDate = this.fileFeedRunDates[connection.fileFeedConnectionId];
      return selectedDate ? this.$call.GetMutualFundFileFeedDownloadUrl(connection.fileFeedConnectionId, selectedDate) : undefined;
    },
    runFileFeedConnection(connection) {
      const id = connection.fileFeedConnectionId;
      const selectedDate = this.fileFeedRunDates[id];
      if (!selectedDate || this.isFileFeedRunActive(id) || this.fileFeedRunLoading[id] || this.fileFeedRunPollErrors[id]) return;
      this.runningFileFeedConnectionId = id;
      this.fileFeedRunLoading[id] = true;
      const generation = this.fileFeedRunGeneration;
      const isCurrent = () => generation === this.fileFeedRunGeneration && this.showScheduleDialog && this.fileFeedConnections.some((item) => item.fileFeedConnectionId === id);
      this.$call.RunMutualFundFileFeedConnection(
        id,
        selectedDate,
        (response) => {
          if (!isCurrent()) return;
          this.runningFileFeedConnectionId = null;
          this.fileFeedRunLoading[id] = false;
          if (response.status === 0) {
            this.fileFeedRuns[id] = this.newerFileFeedRun(this.fileFeedRuns[id], response.data);
            this.fileFeedRunPollErrors[id] = '';
            this.refreshFileFeedRun(id);
          } else this.$swal.fire({ icon: 'error', title: response.message || 'File-feed run could not be queued.' });
        },
        () => {
          if (!isCurrent()) return;
          this.runningFileFeedConnectionId = null;
          this.fileFeedRunLoading[id] = false;
          this.fileFeedRunPollErrors[id] = 'The queue response could not be confirmed. Refresh run status before submitting again.';
          this.refreshFileFeedRun(id);
        }
      );
    },
    loadSyncSchedules() {
      this.$call.GetMutualFundSyncSchedules((response) => {
        if (response.status !== 0 || !Array.isArray(response.data)) return;
        this.apiEndpointSchedules = response.data.reduce((schedules, saved) => {
          if (String(saved.sourceCode || '').startsWith('ApiEndpoint:')) schedules[saved.sourceCode] = saved;
          return schedules;
        }, {});
        this.applyApiEndpointSchedules();
      });
    },
    apiEndpointScheduleSource(endpoint) {
      return `ApiEndpoint:${endpoint.apiEndpointId}`;
    },
    applyApiEndpointSchedules() {
      this.apiEndpoints = this.apiEndpoints.map((endpoint) => {
        const schedule = this.apiEndpointSchedules[this.apiEndpointScheduleSource(endpoint)];
        return {
          ...endpoint,
          scheduleEnabled: !endpoint.isDraft && !!schedule?.enabled,
          scheduleTime: schedule?.localTime || '01:00',
          scheduleLastRunAt: schedule?.lastRunAt || null,
        };
      });
    },
    saveEndpointSchedule(endpoint) {
      if (!endpoint?.scheduleTime) return;
      this.savingEndpointScheduleId = endpoint.apiEndpointId;
      this.$call.SaveMutualFundSyncSchedule(
        { sourceCode: this.apiEndpointScheduleSource(endpoint), enabled: !!endpoint.scheduleEnabled, localTime: endpoint.scheduleTime, timeZoneId: 'Asia/Bangkok' },
        (response) => {
          this.savingEndpointScheduleId = null;
          if (response.status === 0) {
            const saved = response.data || {};
            this.apiEndpointSchedules[this.apiEndpointScheduleSource(endpoint)] = saved;
            endpoint.scheduleLastRunAt = saved.lastRunAt || endpoint.scheduleLastRunAt;
            this.$swal.fire({ icon: 'success', title: 'Connection schedule saved.', timer: 1600, showConfirmButton: false });
          } else this.$swal.fire({ icon: 'error', title: response.message || 'Schedule could not be saved.' });
        },
        () => { this.savingEndpointScheduleId = null; }
      );
    },
    formatScheduleDate(value) {
      if (!value) return 'Not run yet';
      const text = String(value);
      // SQL DATETIME2 values are UTC but arrive without a timezone suffix.
      const date = new Date(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(text) ? text : `${text}Z`);
      return Number.isNaN(date.getTime()) ? 'Not run yet' : new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Bangkok',
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      }).format(date);
    },
    emptyApiEndpointForm() {
      return {
        apiEndpointId: null,
        tableName: '',
        endpointUrl: '',
        httpMethod: 'GET',
        requestBody: '',
        apiKeyHeader: 'Api-Key',
        apiKey: '',
        hasApiKey: false,
        authenticationType: 'OAuthClientCredentials',
        authHttpMethod: 'POST',
        authUrl: '',
        clientId: '',
        clientSecret: '',
        hasClientSecret: false,
        matchingKeys: [],
        responseDataPath: '',
        isEnabled: true,
        useCompositeMapping: true,
        identityField: 'fund_code',
        identityPath: '$.data[*].fund_code',
        collectionMappings: [],
      };
    },
    openApiEndpointDialog(endpoint = null) {
      this.apiEndpointResponseJson = '';
      this.apiEndpointResponsePanel = undefined;
      this.showApiKey = false;
      this.previewingApiEndpoint = false;
      this.apiEndpointStructureReady = !!endpoint && !endpoint.isDraft;
      this.apiEndpointDiscoveredColumns = endpoint ? [...(endpoint.matchingKeys || [])] : [];
      this.apiEndpointResponseCandidates = endpoint?.responseDataPath
        ? [{ path: endpoint.responseDataPath, rowCount: 0, columns: [...(endpoint.matchingKeys || [])], label: `${endpoint.responseDataPath} · saved configuration` }]
        : [];
      this.apiEndpointPreviewMessage = endpoint && !endpoint.isDraft ? 'Using the saved response configuration. Test the connection to rediscover all returned columns.' : '';
      this.apiEndpointForm = endpoint
        ? {
            apiEndpointId: endpoint.apiEndpointId,
            tableName: endpoint.tableName,
            endpointUrl: endpoint.endpointUrl,
            httpMethod: endpoint.httpMethod || 'GET',
            requestBody: endpoint.requestBody || '',
            apiKeyHeader: endpoint.apiKeyHeader || 'Api-Key',
            apiKey: '',
            hasApiKey: !!endpoint.hasApiKey,
            authenticationType: endpoint.authenticationType || 'ApiKey',
            authHttpMethod: 'POST',
            authUrl: endpoint.authUrl || '',
            clientId: endpoint.clientId || '',
            clientSecret: '',
            hasClientSecret: !!endpoint.hasClientSecret,
            matchingKeys: [...(endpoint.matchingKeys || [])],
            responseDataPath: endpoint.responseDataPath || '',
            isEnabled: endpoint.isEnabled,
            useCompositeMapping: (endpoint.authenticationType || '').toLowerCase() === 'oauthclientcredentials',
            identityField: endpoint.identityField || 'fund_code',
            identityPath: endpoint.identityPath || '$.data[*].fund_code',
            collectionMappings: this.collectionMappingsFromEndpoint(endpoint),
          }
        : this.emptyApiEndpointForm();
      this.showApiEndpointDialog = true;
    },
    closeApiEndpointDialog() {
      if (this.savingApiEndpoint || this.previewingApiEndpoint) return;
      this.showApiEndpointDialog = false;
    },
    clearApiEndpointDiscovery() {
      this.apiEndpointResponseJson = '';
      this.apiEndpointResponsePanel = undefined;
      this.apiEndpointStructureReady = false;
      this.apiEndpointDiscoveredColumns = [];
      this.apiEndpointResponseCandidates = [];
      this.apiEndpointPreviewMessage = '';
      this.apiEndpointForm.matchingKeys = [];
      this.apiEndpointForm.responseDataPath = '';
      if (this.apiEndpointForm.useCompositeMapping) this.apiEndpointForm.collectionMappings = [];
    },
    onAuthenticationTypeChanged(authenticationType) {
      const isOAuth = authenticationType === 'OAuthClientCredentials';
      this.apiEndpointForm.useCompositeMapping = isOAuth;
      this.clearApiEndpointDiscovery();
    },
    collectionMappingsFromEndpoint(endpoint) {
      if (endpoint?.isDraft) return [];
      const mappings = Array.isArray(endpoint?.tableMappings) ? endpoint.tableMappings : [];
      if (!mappings.length) return cloneCustomerCompositeCollections();
      return mappings.map((mapping, index) => ({
        sourceName: String(mapping.responseDataPath || `mapping_${index + 1}`).split('.').pop().replace('[*]', ''),
        tableName: mapping.targetTableName || '',
        path: mapping.responseDataPath || '',
        relation: mapping.relationKind === 'OneToMany' ? '1:many' : '1:1',
      }));
    },
    buildCompositeTableMappings(form) {
      const defaultKeys = {
        '$.data[*].configuration': ['fund_code'],
        '$.data[*].profile': ['fund_code'],
        '$.data[*].latest_nav': ['fund_code'],
        '$.data[*].fees[*]': ['fund_code', 'fee_type'],
        '$.data[*].strong_points[*]': ['fund_code', 'fund_strong_point_id'],
      };
      const collections = (form.collectionMappings || []).length ? form.collectionMappings : cloneCustomerCompositeCollections();
      return collections.map((collection, index) => {
        const isMany = collection.relation === '1:many';
        const path = String(collection.path || '').trim();
        return {
          targetTableName: isMany ? String(collection.tableName || '').trim() : String(form.tableName || '').trim(),
          responseDataPath: path,
          relationKind: isMany ? 'OneToMany' : 'OneToOne',
          matchingKeys: defaultKeys[path] || [],
          sortOrder: index + 1,
        };
      });
    },
    buildApiEndpointRequest(form) {
      if (!form.useCompositeMapping || form.authenticationType !== 'OAuthClientCredentials') {
        return {
          ...form,
          matchingKeys: this.selectAutomaticMatchingKeys(this.apiEndpointDiscoveredColumns, form.matchingKeys, form.tableName).map((item) => String(item).trim()).filter(Boolean),
        };
      }
      return {
        apiEndpointId: form.apiEndpointId,
        tableName: String(form.tableName || '').trim(),
        endpointUrl: String(form.endpointUrl || '').trim(),
        httpMethod: 'GET',
        authenticationType: 'OAuthClientCredentials',
        authUrl: String(form.authUrl || '').trim(),
        clientId: String(form.clientId || '').trim(),
        clientSecret: form.clientSecret || '',
        identityField: String(form.identityField || '').trim(),
        identityPath: String(form.identityPath || '').trim(),
        tableMappings: this.buildCompositeTableMappings(form),
        isEnabled: !!form.isEnabled,
      };
    },
    applyCustomerCompositePreview() {
      const collections = cloneCustomerCompositeCollections();
      if (!this.apiEndpointForm.tableName) this.apiEndpointForm.tableName = 'fci_fund_master';
      this.apiEndpointForm.useCompositeMapping = true;
      this.apiEndpointForm.identityField = 'fund_code';
      this.apiEndpointForm.identityPath = '$.data[*].fund_code';
      this.apiEndpointForm.collectionMappings = collections;
      this.apiEndpointStructureReady = true;
      this.apiEndpointPreviewMessage = 'Customer composite sample loaded. Review the identity and child table mappings below.';
    },
    addCompositeCollection(relation = '1:1') {
      const many = relation === '1:many';
      this.apiEndpointForm.collectionMappings.push({
        sourceName: `new_${many ? 'collection' : 'path'}_${Date.now()}`,
        ...(many ? { tableName: 'new_child_table' } : {}),
        path: '',
        relation,
      });
    },
    removeCompositeCollection(collection) {
      const index = this.apiEndpointForm.collectionMappings.indexOf(collection);
      if (index < 0) return;
      if (this.apiEndpointForm.collectionMappings.length <= 1) return;
      this.apiEndpointForm.collectionMappings.splice(index, 1);
    },
    selectAutomaticMatchingKeys(columns, existingKeys = [], tableName = this.apiEndpointForm?.tableName) {
      const available = Array.isArray(columns) ? columns.filter(Boolean) : [];
      const normalizedTableName = String(tableName || '').trim().toLowerCase();
      const hasColumn = (name) => available.some((column) => column.toLowerCase() === name);

      // NAV rows are identified by the fund and the NAV business date together.
      // Keep this automatic because matching keys are intentionally hidden from
      // administrators; using import_id alone would create duplicate NAV dates.
      if (normalizedTableName === 'fci_fund_nav' && hasColumn('fund_code') && hasColumn('nav_date')) {
        return [
          available.find((column) => column.toLowerCase() === 'fund_code'),
          available.find((column) => column.toLowerCase() === 'nav_date'),
        ];
      }

      const existing = (existingKeys || []).filter((key) => available.some((column) => column.toLowerCase() === String(key).toLowerCase()));
      if (existing.length) return existing;

      const find = (predicate) => available.find((column) => predicate(String(column).toLowerCase()));
      const key = find((column) => column === 'id')
        || find((column) => column.endsWith('_id'))
        || find((column) => column === 'fund_code')
        || find((column) => column === 'code')
        || available[0];
      return key ? [key] : [];
    },
    downloadApiEndpointResponseJson() {
      // The sample response is already in memory from Test connection; save it without calling the customer API again.
      if (!this.apiEndpointResponseJson) return;
      const table = String(this.apiEndpointForm.tableName || '').trim().replace(/[^A-Za-z0-9._-]+/g, '-').replace(/^-+|-+$/g, '');
      const blob = new Blob([this.apiEndpointResponseJson], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${table || 'fund-api'}-sample-response.json`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 0);
    },
    previewApiEndpoint() {
      this.apiEndpointResponseJson = '';
      this.apiEndpointResponsePanel = undefined;
      const fingerprint = this.apiEndpointPreviewFingerprint;
      const form = this.apiEndpointForm;
      const hasKey = !!form.apiKey || (!!form.apiEndpointId && !!form.hasApiKey);
      const hasClientSecret = !!form.clientSecret || (!!form.apiEndpointId && !!form.hasClientSecret);
      const isOAuth = form.authenticationType === 'OAuthClientCredentials';
      if ((isOAuth && (!form.tableName || !form.endpointUrl || !form.authUrl || !form.clientId || !hasClientSecret)) || (!isOAuth && (!form.tableName || !form.endpointUrl || !form.apiKeyHeader || !hasKey))) {
        this.$swal.fire({ icon: 'warning', title: isOAuth ? 'Complete the table name, Fund API URL, Auth URL, Client ID, and Client Secret.' : 'Complete the table name, method, URL, API key header, and API key.' });
        return;
      }
      this.previewingApiEndpoint = true;
      this.$call.PreviewMutualFundApiEndpoint(
        this.buildApiEndpointRequest(form),
        (response) => {
          this.previewingApiEndpoint = false;
          this.loadImportProblems();
          if (response.status !== 0) {
            this.$swal.fire({ icon: 'error', title: response.message || 'Connection test failed.' });
            return;
          }
          const preview = response.data || {};
          if (fingerprint !== this.apiEndpointPreviewFingerprint || !this.showApiEndpointDialog) return;
          if (preview.responseJson) {
            try { this.apiEndpointResponseJson = JSON.stringify(JSON.parse(preview.responseJson), null, 2); }
            catch { this.apiEndpointResponseJson = ''; }
          }
          if (form.useCompositeMapping) {
            this.applyCustomerCompositePreview();
            this.apiEndpointPreviewMessage = `${preview.message || 'Connection succeeded.'} Customer sections loaded for review; choose which tables to keep.`;
            return;
          }
          this.apiEndpointResponseCandidates = (preview.candidates || []).map((candidate) => ({
            ...candidate,
            label: `${candidate.path} · ${candidate.rowCount || 0} row(s) · ${(candidate.columns || []).length} column(s)`,
          }));
          this.apiEndpointStructureReady = true;
          this.apiEndpointPreviewMessage = preview.message || 'Connection succeeded and returned data was discovered.';
          this.apiEndpointForm.responseDataPath = preview.responseDataPath || '';
          this.apiEndpointDiscoveredColumns = preview.columns || [];
          this.apiEndpointForm.matchingKeys = this.selectAutomaticMatchingKeys(this.apiEndpointDiscoveredColumns, form.matchingKeys, form.tableName);
        },
        (error) => {
          this.previewingApiEndpoint = false;
          this.loadImportProblems();
          const message = error?.response?.data?.message || error?.response?.data?.Message || (typeof error?.response?.data === 'string' ? error.response.data : '') || 'Connection test failed.';
          this.$swal.fire({ icon: 'error', title: 'Connection test failed.', text: message });
        }
      );
    },
    selectApiResponseCandidate(path) {
      const candidate = this.apiEndpointResponseCandidates.find((item) => item.path === path);
      this.apiEndpointDiscoveredColumns = candidate?.columns || [];
      this.apiEndpointForm.matchingKeys = this.selectAutomaticMatchingKeys(this.apiEndpointDiscoveredColumns, this.apiEndpointForm.matchingKeys, this.apiEndpointForm.tableName);
    },
    saveApiEndpoint(saveAsDraft = false) {
      const form = this.apiEndpointForm;
      if (saveAsDraft ? !this.canSaveApiEndpointDraft : !this.canSaveApiEndpoint) {
        this.$swal.fire({ icon: 'warning', title: saveAsDraft ? 'Complete the connection details and credentials before saving as pending.' : 'Test the connection and complete response mappings, or choose Save as pending.' });
        return;
      }
      const request = this.buildApiEndpointRequest(form);
      request.saveAsDraft = saveAsDraft;
      if (saveAsDraft) {
        request.isEnabled = false;
        request.responseDataPath = '';
        request.tableMappings = [];
      }
      this.savingApiEndpoint = true;
      this.$call.SaveMutualFundApiEndpoint(
        request,
        (response) => {
          this.savingApiEndpoint = false;
          if (response.status === 0) {
            this.showApiEndpointDialog = false;
            this.loadApiEndpoints();
            this.$swal.fire({ icon: 'success', title: saveAsDraft ? 'Connection saved as pending. Imports are off.' : 'Live connection saved.', timer: 1800, showConfirmButton: false });
          } else this.$swal.fire({ icon: 'error', title: response.message || 'Endpoint could not be saved.' });
        },
        () => { this.savingApiEndpoint = false; }
      );
    },
    deleteApiEndpoint(endpoint) {
      this.$swal.fire({
        icon: 'warning',
        title: `Remove ${endpoint.tableName}?`,
        text: 'The connector will be removed. Its Mutual Fund table and imported data will be kept.',
        showCancelButton: true,
        confirmButtonText: 'Remove connector',
      }).then((result) => {
        if (!result.isConfirmed) return;
        this.$call.DeleteMutualFundApiEndpoint(endpoint.apiEndpointId, (response) => {
          if (response.status === 0) this.loadApiEndpoints();
        });
      });
    },
    testApiEndpoint(endpoint) {
      if (endpoint.isDraft) {
        this.openApiEndpointDialog(endpoint);
        this.previewApiEndpoint();
        return;
      }
      this.testingApiEndpointId = endpoint.apiEndpointId;
      this.$call.TestMutualFundApiEndpoint(
        endpoint.apiEndpointId,
        (response) => {
          this.testingApiEndpointId = null;
          this.loadImportProblems();
          if (response.status === 0) {
            const data = response.data || {};
            this.$swal.fire({ icon: 'success', title: 'Connection successful', text: `${data.rowCount || 0} row(s), ${(data.columns || []).length} column(s) found.` });
          } else this.$swal.fire({ icon: 'error', title: response.message || 'Connection failed.' });
        },
        () => {
          this.testingApiEndpointId = null;
          this.loadImportProblems();
        }
      );
    },
    runEndpointSync(endpoint) {
      this.runningEndpointSyncId = endpoint.apiEndpointId;
      this.$call.RunMutualFundApiSync(
        endpoint.apiEndpointId,
        (response) => {
          this.runningEndpointSyncId = null;
          this.loadImportProblems();
          if (response.status === 0) {
            this.$swal.fire({ icon: 'success', title: 'Live connection sync queued.', text: 'The import will continue in the background.', timer: 2200, showConfirmButton: false });
            this.startImportHistoryPolling();
            if (this.showApiSyncHistoryDialog) this.loadApiSyncHistory();
            this.loadApiEndpoints();
          } else this.$swal.fire({ icon: 'error', title: response.message || 'Sync could not be queued.' });
        },
        () => {
          this.runningEndpointSyncId = null;
          this.loadImportProblems();
        }
      );
    },
    runAllEndpointSyncs() {
      this.runningAllEndpointSyncs = true;
      this.$call.RunMutualFundApiSync(
        null,
        (response) => {
          this.runningAllEndpointSyncs = false;
          this.loadImportProblems();
          if (response.status === 0) {
            this.$swal.fire({ icon: 'success', title: 'Active live connections queued.', text: 'Each active URL is importing in the background.', timer: 2200, showConfirmButton: false });
            this.startImportHistoryPolling();
            if (this.showApiSyncHistoryDialog) this.loadApiSyncHistory();
            this.loadApiEndpoints();
          } else this.$swal.fire({ icon: 'error', title: response.message || 'Sync could not be queued.' });
        },
        () => {
          this.runningAllEndpointSyncs = false;
          this.loadImportProblems();
        }
      );
    },
    openApiSyncHistory() {
      this.apiSyncHistoryGeneration += 1;
      this.apiSyncHistory = [];
      this.apiSyncHistoryError = '';
      this.apiSyncHistorySelectedId = null;
      this.apiSyncHistoryStatus = 'All statuses';
      this.apiSyncTechnicalPanel = undefined;
      this.showApiSyncHistoryDialog = true;
      this.loadApiSyncHistory();
    },
    closeApiSyncHistory() {
      this.showApiSyncHistoryDialog = false;
    },
    loadApiSyncHistory() {
      if (!this.showApiSyncHistoryDialog) return;
      const generation = ++this.apiSyncHistoryGeneration;
      this.loadingApiSyncHistory = true;
      this.apiSyncHistoryError = '';
      this.stopApiSyncHistoryPolling(false);
      const isCurrent = () => this.showApiSyncHistoryDialog && generation === this.apiSyncHistoryGeneration;
      this.$call.GetMutualFundApiSyncRunHistory(25, (response) => {
        if (!isCurrent()) return;
        this.loadingApiSyncHistory = false;
        if (response.status !== 0) {
          this.apiSyncHistoryError = response.message || 'Live connection history could not be loaded.';
          return;
        }
        this.apiSyncHistory = Array.isArray(response.data) ? response.data : [];
        const newestActive = this.apiSyncHistory.find(run => this.isImportActiveStatus(run.status));
        if (newestActive) this.startApiSyncHistoryPolling();
      }, () => {
        if (!isCurrent()) return;
        this.loadingApiSyncHistory = false;
        this.apiSyncHistoryError = 'Live connection history could not be loaded. This does not mean a sync failed.';
      });
    },
    startApiSyncHistoryPolling() {
      this.stopApiSyncHistoryPolling(false);
      if (!this.showApiSyncHistoryDialog) return;
      this.apiSyncHistoryPollTimer = setTimeout(() => this.loadApiSyncHistory(), 3000);
    },
    stopApiSyncHistoryPolling(invalidate = true) {
      if (this.apiSyncHistoryPollTimer) clearTimeout(this.apiSyncHistoryPollTimer);
      this.apiSyncHistoryPollTimer = null;
      if (invalidate) {
        this.apiSyncHistoryGeneration += 1;
        this.loadingApiSyncHistory = false;
      }
    },
    apiSyncTriggerLabel(sourceType) {
      return sourceType === 'ScheduledApi' ? 'Scheduled sync' : 'Manual sync';
    },
    apiSyncConnectionLabel(run) {
      return run?.fileName || 'Live data connection';
    },
    apiSyncRunSummary(run) {
      return formatApiSyncRunSummary(run);
    },
    apiSyncTechnicalLog(run) {
      return String(run?.message || 'No progress details were recorded.').replace(/(\d{4}-\d{2}-\d{2}T[\d:.]+) UTC/g, (_, stamp) => `${this.formatSftpRunTime(stamp)} Bangkok`);
    },
    closeTestImportDialog() {
      if (this.runningTestImport) return;
      this.showTestImportDialog = false;
      this.clearMorningStarFolderSelection();
    },
    browseMorningStarFolder() {
      this.$refs.morningStarFolderInput?.click();
    },
    browseMorningStarCsvFiles() {
      this.$refs.morningStarCsvInput?.click();
    },
    onMorningStarFolderSelected(event) {
      const selected = Array.from(event?.target?.files || []).filter((file) => file.name.toLowerCase().endsWith('.csv'));
      this.morningStarFiles = selected;
      const relativePath = selected[0]?.webkitRelativePath || '';
      this.morningStarFolderName = relativePath.includes('/') ? relativePath.split('/')[0] : 'Selected CSV files';
      this.lastImportMessage = selected.length ? '' : 'The selected folder does not contain CSV files.';
      this.lastImportAlertType = selected.length ? 'info' : 'warning';
    },
    clearMorningStarFolderSelection() {
      this.morningStarFiles = [];
      this.morningStarFolderName = '';
      if (this.$refs.morningStarFolderInput) this.$refs.morningStarFolderInput.value = '';
      if (this.$refs.morningStarCsvInput) this.$refs.morningStarCsvInput.value = '';
    },
    runMorningStarFolderImport() {
      if (this.morningStarFiles.length === 0) return;
      const formData = new FormData();
      this.morningStarFiles.forEach((file) => formData.append('uploaded_files', file, file.name));
      this.runningTestImport = true;
      this.lastImportMessage = '';
      const done = (response) => {
        this.runningTestImport = false;
        if (response.status === 0) {
          const batch = response.data || {};
          if (this.isImportActiveStatus(batch.status)) {
            this.activeImportBatchId = batch.importBatchId;
            this.lastImportHasErrors = false;
            this.lastImportAlertType = 'info';
            this.lastImportMessage = `Batch ${batch.importBatchId} is ${String(batch.status).toLowerCase()}. You may close this dialog; processing will continue in the background.`;
          } else {
            const hasErrors = batch.status === 'Failed' || batch.status === 'CompletedWithErrors';
            const hasWarnings = batch.status === 'CompletedWithWarnings';
            this.lastImportHasErrors = hasErrors || hasWarnings;
            this.lastImportAlertType = hasErrors ? 'error' : hasWarnings ? 'warning' : 'success';
            this.lastImportMessage = `Batch ${batch.importBatchId}: ${batch.status}. Inserted ${batch.insertedCount || 0}, updated ${batch.updatedCount || 0}, rejected ${batch.rejectedCount || 0}.`;
          }
          this.loadImportHistory();
          this.loadImportFrameworkStatus();
          this.Get();
          if (this.activeImportBatchId) this.startImportHistoryPolling();
        } else {
          this.lastImportHasErrors = true;
          this.lastImportAlertType = 'error';
          this.lastImportMessage = response.message || 'The import could not be started.';
        }
      };
      const failed = () => {
        this.runningTestImport = false;
        this.lastImportHasErrors = true;
        this.lastImportAlertType = 'error';
        this.lastImportMessage = 'The folder import could not be queued. Check the CSV filenames and the Import History result.';
      };
      this.$call.ImportMutualFundMorningStarFolder(formData, done, failed);
    },
    btnDisableDelete(item) {
      if ((this.RoleId == 2 || this.RoleId == 6) && item.createBy != this.Username) {
        return true;
      }
      return false;
    },
    validateString(item) {
      if (this.requestMutualFundIntegration.Type === 'E') {
        const stringTypes = ['nvarchar', 'text', 'varchar', 'varchar2', 'char', 'nchar', 'TEXT', 'VARCHAR2', 'CHAR', 'NCHAR', 'NVARCHAR2'];
        return !stringTypes.includes(item.typeId);
      }
    },
    setFuzzyValue(item, value) {
      // Reset all fuzzy options
      item.fuzzy = false;
      item.fuzzyBot = false;

      // Set the selected option
      if (value === 'fuzzy') {
        item.fuzzy = true;
      } else if (value === 'fuzzyBot') {
        item.fuzzyBot = true;
      }
    },
    toggleActive(item, isActive) {
      // Handle the toggle active state with API call
      const self = this;
      const requestData = {
        ID: item.id,
        ActiveStatus: isActive,
      };

      self.$call.UpdateMutualFundIntegrationActiveStatus(
        requestData,
        (res) => {
          if (res.status === 0) {
            item.activeStatus = isActive;
            self.$swal.fire({
              title: 'Success!',
              text: `Status updated successfully`,
              icon: 'success',
              timer: 2000,
              showConfirmButton: false,
            });
            console.log(`Toggle active for ${item.dataName}:`, isActive);
          } else {
            self.$swal.fire({
              title: 'Error!',
              text: res.message || 'Failed to update status',
              icon: 'error',
            });
            // Revert the toggle if API fails
            item.activeStatus = !isActive;
          }
        },
        (error) => {
          console.error('Error updating active status:', error);
          self.$swal.fire({
            title: 'Error!',
            text: 'Failed to update status',
            icon: 'error',
          });
          // Revert the toggle if API fails
          item.activeStatus = !isActive;
        }
      );
    },
    getFuzzyColor(itemOrOption) {
      if (itemOrOption.color) return itemOrOption.color; // For dropdown options

      // For actual items
      if (itemOrOption.fuzzy) return 'primary';
      if (itemOrOption.fuzzyBot) return 'success';
      return 'grey';
    },
    getFuzzyIcon(itemOrOption) {
      if (itemOrOption.icon) return itemOrOption.icon; // For dropdown options

      // For actual items
      if (itemOrOption.fuzzy) return 'mdi-magnify';
      if (itemOrOption.fuzzyBot) return 'mdi-robot';
      return 'mdi-close-circle-outline';
    },
    Get() {
      let self = this;
      self.loadingTable = true;

      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let activeStatus = null;
      if (self.statusFilters.active) {
        activeStatus = true;
      } else if (self.statusFilters.inactive) {
        activeStatus = false;
      }

      let searchValue = self.searchMutualFundIntegrationName && self.searchMutualFundIntegrationName.trim()
        ? self.searchMutualFundIntegrationName.trim()
        : null;

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage !== -1 ? itemsPerPage : Math.max(self.searchTotalTable || self.totalTable || 10, 1),
        DataName: searchValue,
        CreateBy: searchValue,
        ActiveStatus: activeStatus,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableMutualFundIntegration(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = dataResponse.data.total;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    triggerFileUpload() {
      // à¹€à¸£à¸µà¸¢à¸ method click à¸‚à¸­à¸‡ DragDropFile component
      if (this.$refs.dragDropRef) {
        // à¸«à¸²à¸›à¸¸à¹ˆà¸¡ upload à¹ƒà¸™ DragDropFile component à¹à¸¥à¸°à¸„à¸¥à¸´à¸
        const uploadButton = this.$refs.dragDropRef.$el.querySelector('input[type="file"]');
        if (uploadButton) {
          this.errorMessages.columns.push({ error: false, message: '' });
          uploadButton.click();
        }
      }
    },
    Search() {
      let self = this;
      self.isSearch = true;
      if (self.options.page !== 1) {
        self.options.page = 1;
        return;
      }
      self.Get();
    },
    refreshTable() {
      this.Get();
    },
    Save() {
      let self = this;
      let tempCheckColumns = [];
      let headers = [];
      let listindexnamefuzzy = [];
      let columnData = [];
      let spaceText = false;
      self.requestMutualFundIntegration.Columns.forEach((item, index) => {
        // validate Column ' abc defg '
        const splitText = item.name.split(' ');
        if (this.errorMessages.columns[index]) {
          this.errorMessages.columns[index].error = false;
          this.errorMessages.columns[index].message = '';
        }

        if (splitText.length > 1 && (splitText[0] === '' || splitText[splitText.length - 1] === '')) {
          if (!this.errorMessages.columns[index]) {
            this.errorMessages.columns[index] = { error: false, message: '' };
          }

          this.errorMessages.columns[index].error = true;
          this.errorMessages.columns[index].message = 'Column name cannot have leading or trailing spaces!';
          spaceText = true;
        }

        if (item.name !== null && item.name !== undefined && item.name !== '' && item.typeId !== null && item.typeId !== undefined && item.typeId !== '') {
          tempCheckColumns.push(item);
          headers.push(item.name);
        }
        if (item.fuzzy == true || item.fuzzyBot == true) {
          let index = headers.indexOf(item.name);
          listindexnamefuzzy.push(index);
        }
      });

      if (spaceText) {
        return;
      }

      if (new Set(headers).size !== headers.length) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('_duplicateColumn'),
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }

      if (!self.requestMutualFundIntegration.MutualFundIntegrationName || tempCheckColumns.length < 1 || self.requestMutualFundIntegration.Columns.length != tempCheckColumns.length) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warningFillAll'),
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }

      self.requestMutualFundIntegration.Columns = tempCheckColumns;
      let chkValidateLimitFuzzy = self.ValidateLimitFuzzy(headers, listindexnamefuzzy);
      if (chkValidateLimitFuzzy != null) {
        self.$swal.fire({
          icon: 'warning',
          title: chkValidateLimitFuzzy,
          showConfirmButton: true,
        });
        return;
      }
      self.dialog = true;

      let temp = {
        ReqData: self.requestMutualFundIntegration,
        uploaded_file: self.requestMutualFundIntegration.entity,
      };
      try {
        self.$call.AddMutualFundIntegration_Table(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.Get();
              if (self.requestMutualFundIntegration.entity != null) {
                self.SaveData(dataResponse.data);
              } else {
                self.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.dialog = false;
                self.AddMutualFundIntegration = false;
                self.ClearPopupAddMutualFundIntegration();
              }
            } else {
              self.$swal.fire({
                icon: 'error',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2500,
              });
              self.dialog = false;
            }
          },
          (errorResource) => {
            self.dialog = false;
            self.AddVector = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    SaveData(id) {
      let self = this;
      self.dialog = true;
      let temp = {
        id,
        uploaded_file: self.requestMutualFundIntegration.entity,
        deleteAll: false,
      };
      try {
        self.$call.AddMutualFundIntegration_Data(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.AddMutualFundIntegration = false;
              self.requestMutualFundIntegration.MutualFundIntegrationName = null;
              // self.Get();
            } else {
              self.$swal.fire({
                icon: 'error',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2500,
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.AddVector = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    back(e) {
      if (e) {
        this.EditdialogUser = false;
        this.AddVector = false;
      }
    },
    Delete(id) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t('ConfirmDeletion'),
            text: this.$t('confirmDeletionTableName'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteMutualFundIntegration(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.Get();
                  } else if (dataResponse.status == 1) {
                    self.$swal.fire({
                      icon: 'error',
                      title: dataResponse.message,
                      showConfirmButton: true,
                      confirmButtonText: this.$t('gotIt'),
                      confirmButtonColor: '#d33',
                    });
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  console.error(errorResource);
                }
              );
              self.Get();
            }
          });
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    Add() {
      let self = this;
      self.AddMutualFundIntegration = true;
      self.uploadedFiles = [];
      self.requestMutualFundIntegration.entity = null;
      self.requestMutualFundIntegration.Type = 'I';
      self.requestMutualFundIntegration.Columns = [{ name: '', typeId: 'nvarchar', fuzzy: false, fuzzyBot: false }];
      self.errorMessages.columns = [{ error: false, message: '' }];
    },
    Edit(item) {
      let self = this;
      self.$router.push({
        name: 'MutualFundDetail',
        query: {
          id: item.id,
        },
      });
    },
    convertDateToString(date, seperator = '/') {
      return dateUtils.getStringWithTimeFromDate(moment(date).toDate(), seperator);
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!
      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      this.today = dd + '/' + mm + '/' + yyyy;
    },
    // async AutoRefresh() {
    //   let self = this;
    //   let death_waiting = true;
    //   do {
    //     for (let value of self.dataTable) {
    //       if (value.inProcess < value.inProcessMax && !value.isError) {
    //         self.ReFreshGet();
    //         death_waiting = true;
    //         break;
    //       } else {
    //         death_waiting = false;
    //       }
    //     }
    //     if (window.location.pathname != '/VectorManagement') {
    //       death_waiting = false;
    //     }
    //     console.log('Wait for 5 seconds!');
    //     await new Promise((resolve) => setTimeout(resolve, 5000));
    //   } while (death_waiting);
    // },
    getColumnData(dataRows, columnCount = 0) {
      if (!dataRows.length) {
        return Array(columnCount).fill('nvarchar');
      }

      const dataTypes = [];
      dataRows[0].forEach((_, colIndex) => {
        // à¹€à¸à¹‡à¸šà¸‚à¹‰à¸­à¸¡à¸¹à¸¥à¸Šà¸™à¸´à¸”à¸•à¹ˆà¸²à¸‡à¹† à¸—à¸µà¹ˆà¸žà¸šà¹ƒà¸™à¸„à¸­à¸¥à¸±à¸¡à¸™à¹Œ
        let hasString = false;
        let hasFloat = false;
        let hasInteger = false;
        let hasBoolean = false;
        let hasDate = false;

        // à¸§à¸™à¸¥à¸¹à¸›à¹€à¸Šà¹‡à¸„à¸‚à¹‰à¸­à¸¡à¸¹à¸¥à¸—à¸±à¹‰à¸‡à¸«à¸¡à¸”à¹ƒà¸™à¸„à¸­à¸¥à¸±à¸¡à¸™à¹Œ
        for (let i = 0; i < dataRows.length; i++) {
          const value = dataRows[i][colIndex];
          if (value instanceof Date && !isNaN(value)) {
            hasDate = true;
          } else if (typeof value === 'boolean') {
            hasBoolean = true;
          } else if (Number.isInteger(value)) {
            hasInteger = true;
          } else if (typeof value === 'number') {
            hasFloat = true;
          } else if (typeof value === 'string') {
            // à¸•à¸£à¸§à¸ˆà¸ªà¸­à¸šà¸§à¹ˆà¸² string à¸™à¸µà¹‰à¹€à¸›à¹‡à¸™à¸•à¸±à¸§à¹€à¸¥à¸‚à¸«à¸£à¸·à¸­à¹„à¸¡à¹ˆ
            const numValue = Number(value);
            if (!isNaN(numValue) && isFinite(numValue)) {
              if (Number.isInteger(numValue)) {
                hasInteger = true;
              } else {
                hasFloat = true;
              }
            } else {
              hasString = true;
            }
          } else {
            hasString = true;
          }
        }

        // à¸à¸³à¸«à¸™à¸” data type à¸•à¸²à¸¡à¸¥à¸³à¸”à¸±à¸šà¸„à¸§à¸²à¸¡à¹€à¸«à¸¡à¸²à¸°à¸ªà¸¡
        let detectedType = 'nvarchar'; // à¸„à¹ˆà¸²à¹€à¸£à¸´à¹ˆà¸¡à¸•à¹‰à¸™

        if (hasString) {
          detectedType = 'nvarchar'; // à¸–à¹‰à¸²à¸¡à¸µ string à¹€à¸¥à¸¢à¹€à¸›à¹‡à¸™ nvarchar
        } else if (hasDate) {
          detectedType = 'datetime'; // à¸–à¹‰à¸²à¸¡à¸µ date
        } else if (hasFloat) {
          detectedType = 'float'; // à¸–à¹‰à¸²à¸¡à¸µ float (à¸£à¸§à¸¡à¸–à¸¶à¸‡à¸à¸£à¸“à¸µ int+float)
        } else if (hasInteger) {
          detectedType = 'int'; // à¸–à¹‰à¸²à¸¡à¸µà¹à¸•à¹ˆ integer
        } else if (hasBoolean) {
          detectedType = 'bit'; // à¸–à¹‰à¸²à¸¡à¸µà¹à¸•à¹ˆ boolean
        }
        dataTypes.push(detectedType);
      });
      return dataTypes;
    },
    processUpload(e) {
      let self = this;
      this.files = e;
      if (this.files.length == 0) {
        this.requestMutualFundIntegration.entity = null;
        this.uploadedFiles = [];
        return;
      }
      const reader = new FileReader();
      const file = this.files[0];
      reader.onload = async (event) => {
        const buffer = event.target.result;
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(buffer);

        // Get the first worksheet
        const worksheet = workbook.getWorksheet(1);
        if (!worksheet) {
          self.$swal.fire({
            icon: 'error',
            title: 'No worksheet found in the Excel file',
            showConfirmButton: false,
            timer: 2500,
          });
          return;
        }

        // Extract data from the worksheet
        const jsonData = [];
        const headers = [];

        // Get headers from the first row
        worksheet.getRow(1).eachCell((cell, colNumber) => {
          headers.push(cell.value);
        });
        jsonData.push(headers);

        // Get data from remaining rows
        worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
          if (rowNumber === 1) return; // Skip header row

          const rowData = [];
          row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            rowData[colNumber - 1] = cell.value;
          });

          // Ensure rowData has the same length as headers
          while (rowData.length < headers.length) {
            rowData.push('');
          }

          jsonData.push(rowData);
        });

        self.DataRowUpload = jsonData.slice(1);
        const columnData = self.getColumnData(self.DataRowUpload, headers.length);

        if (self.ValidateColumns(headers, columnData)) {
          self.$swal.fire({
            icon: 'error',
            title: self.$t('_duplicateColumn'),
            showConfirmButton: false,
            timer: 2500,
          });
        } else {
          this.MapData(self.files);
        }
      };
      reader.readAsArrayBuffer(file);
    },
    ValidateLimitFuzzy(headers, listindexnamefuzzy) {
      let self = this;
      for (let j = 0; j < listindexnamefuzzy.length; j++) {
        let indexcol = listindexnamefuzzy[j];
        for (let i = 0; i < self.DataRowUpload.length; i++) {
          let tmpdata = self.DataRowUpload[i][indexcol];
          if (tmpdata.length > 800) {
            return 'The data in column ' + headers[indexcol] + ', row ' + (i + 2) + ' exceeds the limit of 800 characters.';
          }
        }
      }
      return null;
    },
    ValidateColumns(columns, columnData) {
      let self = this;

      const uniqueColumns = [...new Set(columns)];
      if (uniqueColumns.length !== columns.length) {
        return true; //à¸¡à¸µ Header à¸‹à¹‰à¸³
      } else {
        self.requestMutualFundIntegration.Columns = [];
        self.requestMutualFundIntegration.Columns = columns.map((item, index) => ({
          name: item,
          typeId: columnData[index],
          fuzzy: false,
          fuzzyBot: false,
        }));
        return false;
      }
    },
    MapData(files) {
      const formDataDoc = new FormData();
      formDataDoc.append('uploaded_file', files[0]);
      //console.log(files[0]);
      this.uploadedFiles = files;
      this.requestMutualFundIntegration.entity = formDataDoc;
    },
    ConfirmProcess(type) {
      let self = this;
      self.$swal
        .fire({
          icon: 'warning',
          title: this.$t('ConfirmDataAddition'),
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('cancel'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (type == 'I') {
              self.totalTable = self.totalTable + 1;
              self.Save();
            } else if (type == 'E') {
              self.totalTable = self.totalTable + 1;
              self.AddMutualFundIntegrationConnection();
            }
          }
        });
    },
    TestConnection() {
      let self = this;
      if (!self.requestMutualFundIntegration.ConnectionString) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please fill in information Connection String!',
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      if (self.chkAllColumns) {
        if (self.requestMutualFundIntegration.Schema == '' || self.requestMutualFundIntegration.Schema == null) {
          alert('Please fill in information Schema!');
          return;
        }
        if (self.requestMutualFundIntegration.View == '' || self.requestMutualFundIntegration.View == null) {
          alert('Please fill in information View!');
          return;
        }
      }
      self.dialog = true;

      if (!self.chkAllColumns) {
        if (self.requestMutualFundIntegration.Columns.some((col) => col.name.trim() === '')) {
          self.$swal.fire({
            icon: 'warning',
            title: 'Please fill in all column names!',
            showConfirmButton: false,
            timer: 2500,
          });
          self.dialog = false;
          return;
        }
      }
      let cols = self.requestMutualFundIntegration.Columns.map((col) => col.name);
      let temp = {
        ConnectionString: self.requestMutualFundIntegration.ConnectionString,
        Schema: self.requestMutualFundIntegration.Schema,
        View: self.requestMutualFundIntegration.View,
        Database: self.requestMutualFundIntegration.Database,
        chkAllColumns: self.chkAllColumns,
        ColumnChecklist: cols,
      };
      self.$call.TestMutualFundIntegrationConnection(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.GetALLColumnByTestConnection(dataResponse.data.columns);
            self.$swal.fire({
              icon: 'success',
              title: dataResponse.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            self.$swal.fire({
              icon: 'error',
              title: dataResponse.data.message,
              showConfirmButton: true,
              confirmButtonText: 'Okay',
            });
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    AddColumn() {
      let self = this;

      let temp = {
        name: '',
        typeId: 'nvarchar',
        fuzzy: false,
        fuzzyBot: false,
      };
      self.requestMutualFundIntegration.Columns.push(temp);
      self.errorMessages.columns.push({ error: false, message: '' });
    },
    GetALLColumnByTestConnection(listColumns) {
      let self = this;
      self.requestMutualFundIntegration.Columns = [];
      listColumns.forEach((columnName) => {
        let temp = {
          name: columnName.name, // à¸™à¸³ columnName à¹ƒà¸ªà¹ˆà¹ƒà¸™ temp.name
          // dataType : columnName.dataType, // à¸™à¸³ columnName.dataType à¹ƒà¸ªà¹ˆà¹ƒà¸™ temp.dataType
          typeId: columnName.dataType, // à¸™à¸³ columnName.dataType à¹ƒà¸ªà¹ˆà¹ƒà¸™ temp.typeId
          fuzzy: false,
          fuzzyBot: false,
        };
        self.requestMutualFundIntegration.Columns.push(temp);
      });
    },
    DeleteAction(index) {
      let self = this;
      if (index > -1 && index < self.requestMutualFundIntegration.Columns.length) {
        self.requestMutualFundIntegration.Columns.splice(index, 1);
        self.errorMessages.columns.splice(index, 1);
      }
    },
    ClearPopupAddMutualFundIntegration() {
      let self = this;
      self.requestMutualFundIntegration.entity = null;
      self.requestMutualFundIntegration.MutualFundIntegrationName = null;
      self.requestMutualFundIntegration.ConnectionString = '';
      self.requestMutualFundIntegration.Schema = '';
      self.requestMutualFundIntegration.View = '';
      self.requestMutualFundIntegration.Columns = [{ name: '', typeId: 'nvarchar', fuzzy: false, fuzzyBot: false }];
      self.requestMutualFundIntegration.Type = 'I';
      self.requestMutualFundIntegration.Database = '';
    },
    closeDialog() {
      // Reset all form data
      this.requestMutualFundIntegration = {
        entity: null,
        MutualFundIntegrationName: null,
        ConnectionString: '',
        Schema: '',
        View: '',
        Columns: [{ name: '', typeId: 'nvarchar', fuzzy: false, fuzzyBot: false }],
        Type: 'I',
        Database: '',
      };

      // Reset other form states
      this.uploadedFiles = [];
      this.chkAllColumns = false;

      // Close the dialog
      this.AddMutualFundIntegration = false;
    },
    ClearPopupWhenChange() {
      let self = this;
      self.requestMutualFundIntegration.entity = null;
      self.requestMutualFundIntegration.MutualFundIntegrationName = null;
      self.requestMutualFundIntegration.ConnectionString = '';
      self.requestMutualFundIntegration.Schema = '';
      self.requestMutualFundIntegration.View = '';
      self.requestMutualFundIntegration.Columns = [{ name: '', fuzzy: false, fuzzyBot: false }];
      self.errorMessages.columns = [{ error: false, message: '' }];
    },
    AddMutualFundIntegrationConnection() {
      let self = this;
      let tempCheckColumns = [];
      let headers = [];
      let columnData = [];
      let spaceText = false;
      self.requestMutualFundIntegration.Columns.forEach((item,index) => {
        // Ensure errorMessages.columns array has enough elements
        if (!this.errorMessages.columns[index]) {
          this.errorMessages.columns[index] = { error: false, message: '' };
        }

        this.errorMessages.columns[index].error = false;
        this.errorMessages.columns[index].message = '';

        // Check if item.name exists and is a string before splitting
        if (item.name && typeof item.name === 'string') {
          const splitText = item.name.split(' ');
          if (splitText.length > 1 && (splitText[0] === '' || splitText[splitText.length - 1] === '')) {
            this.errorMessages.columns[index].error = true;
            this.errorMessages.columns[index].message = 'Column name cannot have leading or trailing spaces!';
            spaceText = true;
          }
        }

        if (item.name !== null && item.name !== undefined && item.name !== '') {
          tempCheckColumns.push(item);
          headers.push(item.name);
        }
      });

      if (spaceText) {
        return;
      }

      if (self.ValidateColumns(headers, columnData)) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('_duplicateColumn'),
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }

      if (
        !self.requestMutualFundIntegration.MutualFundIntegrationName ||
        !self.requestMutualFundIntegration.ConnectionString ||
        !self.requestMutualFundIntegration.Schema ||
        !self.requestMutualFundIntegration.View ||
        !self.requestMutualFundIntegration.Database ||
        tempCheckColumns.length < 1
      ) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please Fill All The Fields!',
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }

      self.dialog = true;
      self.requestMutualFundIntegration.Columns = tempCheckColumns;

      self.$call.AddMutualFundIntegrationConnection(
        self.requestMutualFundIntegration,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: 'success',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
            self.AddMutualFundIntegration = false;
            self.ClearPopupAddMutualFundIntegration();
            self.Get();
          } else {
            self.$swal.fire({
              icon: 'error',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 2500,
            });
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.AddMutualFundIntegration = false;
          console.error(errorResource);
        }
      );
    },
    setDefault(item) {
      item.fuzzy = false;
      item.fuzzyBot = false;
    },
    onInputSchema() {
      let self = this;
      if (self.requestMutualFundIntegration.Database == '5') {
        const cs = self.requestMutualFundIntegration.ConnectionString || '';
        const newSchema = (self.requestMutualFundIntegration.Schema || '').trim();
        let updatedCS;

        // à¸–à¹‰à¸²à¸¡à¸µ key schema à¸­à¸¢à¸¹à¹ˆà¹à¸¥à¹‰à¸§ à¹ƒà¸«à¹‰ replace à¸„à¹ˆà¸²
        if (/(^|;)schema=[^;]*/i.test(cs)) {
          updatedCS = cs.replace(/(^|;)schema=[^;]*/i, `$1schema=${newSchema}`);
        } else {
          updatedCS = cs ? `${cs.replace(/;$/, '')};schema=${newSchema}` : `schema=${newSchema}`;
        }

        self.requestMutualFundIntegration.ConnectionString = updatedCS;
      }
    },
    onInputConnectionString() {
      let self = this;
      if (self.requestMutualFundIntegration.Database == '5') {
        const cs = self.requestMutualFundIntegration.ConnectionString || '';
        const schema = this.extractSchema(cs);
        if (schema) {
          self.requestMutualFundIntegration.Schema = schema;
        }
      }
    },
    extractSchema(connectionString) {
      const match = connectionString.match(/(?:^|;)schema=([^;]+)/i);
      return match ? match[1].trim() : '';
    },
  },
  mounted() {
    this.GetDate();
  },
  beforeUnmount() {
    this.stopFileFeedRunPolling();
    this.stopApiSyncHistoryPolling();
    // Clean up debounce timer to prevent memory leaks
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
    this.stopImportHistoryPolling();
  },
};
</script>
<style scoped>
.import-framework-btn,
.test-import-btn,
.sync-schedule-btn,
.refresh-table-btn {
  min-height: 42px;
  border-radius: 12px;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
}

.import-framework-btn {
  margin-left: 10px;
}

.test-import-btn {
  margin-left: 8px;
}

.sync-schedule-btn {
  margin-left: 8px;
  color: #0f766e !important;
  border-color: rgba(15, 118, 110, 0.45) !important;
  background: #f8fffe;
}

.refresh-table-btn {
  margin-left: 8px;
  color: #0f766e !important;
  border-color: rgba(15, 118, 110, 0.45) !important;
  background: #f8fffe;
}

.schedule-dialog-card {
  display: flex;
  max-height: calc(100vh - 40px);
  flex-direction: column;
  border-radius: 20px !important;
  overflow: hidden;
}

:deep(.mutual-fund-schedule-overlay) {
  width: calc(100vw - 40px) !important;
  max-width: 1320px !important;
  max-height: calc(100vh - 40px);
  margin: 20px !important;
}

.schedule-dialog-header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 22px 24px;
  color: #fff;
  background: linear-gradient(120deg, #0f766e 0%, #0f5c65 55%, #153e75 100%);
}

.schedule-header-copy,
.source-identity,
.source-schedule-topline,
.schedule-timezone-row,
.schedule-action-note {
  display: flex;
  align-items: center;
}

.schedule-header-copy {
  gap: 14px;
}

.schedule-header-icon {
  display: grid;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.14);
}

.schedule-dialog-title {
  font-size: 20px;
  font-weight: 700;
  line-height: 1.25;
}

.schedule-dialog-subtitle {
  max-width: 650px;
  margin-top: 4px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 13px;
  line-height: 1.45;
}

.schedule-dialog-content {
  flex: 1 1 auto;
  min-height: 0;
  padding: 22px 24px 26px !important;
  overflow-y: auto;
  background: #fbfdfd;
}

.schedule-timezone-row {
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.schedule-section-label {
  color: #153e3d;
  font-size: 15px;
  font-weight: 700;
}

.schedule-section-hint {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.schedule-card-grid {
  margin: -8px;
}

.schedule-card-grid > .v-col {
  display: flex;
}

.source-schedule-card {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-color: rgba(15, 118, 110, 0.17) !important;
  border-radius: 16px !important;
  background: #fff;
  box-shadow: 0 8px 24px rgba(15, 76, 75, 0.06);
}

.source-schedule-card--disabled {
  background: #f8fafc;
}

.source-schedule-accent {
  height: 4px;
}

.source-schedule-accent--api {
  background: linear-gradient(90deg, #0f766e, #2dd4bf);
}

.source-schedule-accent--sftp {
  background: linear-gradient(90deg, #4338ca, #818cf8);
}

.source-schedule-content {
  padding: 20px !important;
}

.source-schedule-card--disabled .source-schedule-content {
  opacity: 0.74;
}

.source-schedule-topline {
  justify-content: space-between;
  gap: 16px;
}

.source-identity {
  min-width: 0;
  gap: 12px;
}

.source-icon {
  display: grid;
  flex: 0 0 42px;
  width: 42px;
  height: 42px;
  place-items: center;
  border-radius: 12px;
}

.source-icon--api {
  color: #0f766e;
  background: #ccfbf1;
}

.source-icon--sftp {
  color: #4338ca;
  background: #e0e7ff;
}

.source-title {
  color: #0f172a;
  font-size: 16px;
  font-weight: 700;
}

.source-description {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
}

.source-table-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 20px 0 16px;
  color: #64748b;
  font-size: 12px;
}

.schedule-time-input {
  margin-top: 2px;
}

.schedule-run-meta {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #e2e8f0;
}

.schedule-run-meta div {
  display: grid;
  gap: 3px;
}

.schedule-run-meta span {
  color: #94a3b8;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.schedule-run-meta strong {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
}

.schedule-dialog-actions {
  flex: 0 0 auto;
  min-height: 72px;
  padding: 14px 24px !important;
  background: #fff;
}

.import-problem-panel {
  border-color: rgba(239, 68, 68, 0.22) !important;
  border-radius: 16px !important;
  background: #fff;
}

.import-problem-heading {
  display: flex;
  align-items: center;
}

.import-problem-heading {
  justify-content: space-between;
  gap: 16px;
}

.recipient-field-label {
  display: block;
  margin: 0 0 6px 2px;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
}

.recipient-chip-editor {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  min-height: 42px;
  padding: 5px 10px;
  border: 1px solid #b9c4d0;
  border-radius: 4px;
  background: #fff;
}

.recipient-chip-editor:focus-within {
  border-color: #2563eb;
  box-shadow: 0 0 0 1px #2563eb;
}

.recipient-chip-editor input {
  flex: 1 1 180px;
  min-width: 0;
  height: 28px;
  border: 0;
  outline: 0;
  color: #334155;
  font: inherit;
  font-size: 13px;
}

.recipient-chip-editor input::placeholder {
  color: #94a3b8;
}

.recipient-field-hint {
  display: block;
  margin: 5px 0 0 2px;
  color: #64748b;
  font-size: 11px;
}

.recipient-save-button {
  min-height: 42px;
}

.import-problem-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 72px;
  color: #166534;
  font-size: 13px;
}

.import-problem-table-wrap {
  overflow-x: auto;
  border: 1px solid #fee2e2;
  border-radius: 12px;
}

.import-problem-table {
  width: 100%;
  min-width: 720px;
  border-collapse: collapse;
  table-layout: fixed;
}

.import-problem-table th,
.import-problem-table td {
  padding: 12px 14px;
  border-bottom: 1px solid #fee2e2;
  text-align: left;
  vertical-align: middle;
}

.import-problem-table th {
  background: #fff8f8;
  color: #7f1d1d;
  font-size: 12px;
  font-weight: 700;
}

.import-problem-table th:nth-child(1) { width: 13%; }
.import-problem-table th:nth-child(2) { width: 27%; }
.import-problem-table th:nth-child(3) { width: 33%; }
.import-problem-table th:nth-child(4) { width: 12%; }
.import-problem-table th:nth-child(5) { width: 15%; }

.import-problem-table tbody tr:last-child td {
  border-bottom: 0;
}

.import-problem-table tbody tr:hover {
  background: #fffafa;
}

.import-problem-table-row--sample {
  background: #fffdfd;
}

.import-problem-batch {
  display: flex;
  align-items: center;
  gap: 6px;
}

.import-problem-source {
  display: block;
  overflow: hidden;
  color: #334155;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.import-problem-message {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.import-problem-message ~ small {
  display: block;
  margin-top: 3px;
  color: #94a3b8;
  font-size: 11px;
}

.import-problem-count {
  color: #991b1b;
  font-weight: 700;
}

.schedule-action-note {
  gap: 6px;
  color: #64748b;
  font-size: 12px;
}

.manual-sync-btn {
  margin-top: 16px;
  min-height: 42px;
  text-transform: none;
}

.manual-folder-copy {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-height: 86px;
  padding: 16px;
  border: 1px solid #e0e7ff;
  border-radius: 12px;
  color: #475569;
  background: #f8faff;
}

.manual-folder-copy p {
  margin: 0;
  font-size: 12px;
  line-height: 1.55;
}

.folder-file-input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  clip-path: inset(50%);
}

.folder-picker {
  display: flex;
  width: 100%;
  min-height: 94px;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  border: 1px dashed rgba(15, 118, 110, 0.5);
  border-radius: 14px;
  color: #0f3d3e;
  text-align: left;
  background: #f6fffd;
  cursor: pointer;
  transition: border-color 160ms ease, background-color 160ms ease, box-shadow 160ms ease;
}

.folder-picker:hover,
.folder-picker:focus-visible {
  border-color: #0f766e;
  background: #effcf9;
  box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.12);
  outline: none;
}

.folder-picker-icon {
  display: grid;
  flex: 0 0 52px;
  width: 52px;
  height: 52px;
  place-items: center;
  border-radius: 14px;
  color: #0f766e;
  background: #ccfbf1;
}

.folder-picker-copy {
  display: grid;
  flex: 1;
  min-width: 0;
  gap: 4px;
}

.folder-picker-copy strong {
  overflow: hidden;
  font-size: 15px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.folder-picker-copy small {
  color: #64748b;
  font-size: 12px;
  line-height: 1.4;
}

.folder-picker-alternative {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 8px;
  color: #94a3b8;
  font-size: 12px;
}

.endpoint-section-header,
.endpoint-name-line,
.endpoint-row,
.api-endpoint-dialog-title {
  display: flex;
  align-items: center;
}

.endpoint-section-header {
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.endpoint-section-header > div {
  display: grid;
  gap: 2px;
}

.endpoint-section-actions {
  display: flex !important;
  align-items: center;
  gap: 8px;
}

.endpoint-section-actions .v-btn {
  text-transform: none;
}

.composite-mapping-group-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.composite-mapping-group-heading > div {
  display: grid;
  gap: 2px;
}

.composite-mapping-group-heading strong {
  color: #173d3e;
  font-size: 12px;
}

.composite-mapping-group-heading small {
  color: #64748b;
  font-size: 10px;
}

.composite-mapping-group-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.composite-mapping-group {
  margin-top: 10px;
  padding: 10px 10px 4px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
}

.composite-mapping-group-many {
  border-color: #c7d2fe;
  background: #fafaff;
}

.composite-mapping-empty {
  padding: 12px 4px 8px;
  color: #94a3b8;
  font-size: 11px;
}

.composite-mapping-row {
  display: grid;
  grid-template-columns: minmax(180px, 1fr) minmax(240px, 1.35fr) 36px;
  align-items: center;
  gap: 8px;
}

.composite-mapping-row {
  padding: 6px 4px;
  border-top: 1px solid #e2e8f0;
}

.composite-mapping-row--path-only {
  grid-template-columns: minmax(0, 1fr) 36px;
}

.composite-save-note {
  color: #92400e;
  font-size: 11px;
}

.endpoint-section-header strong {
  color: #0f3d3e;
  font-size: 14px;
}

.endpoint-section-header span,
.endpoint-row-main span,
.endpoint-row-main small {
  color: #64748b;
  font-size: 11px;
}

.endpoint-list {
  display: grid;
  gap: 8px;
}

.endpoint-row {
  justify-content: space-between;
  gap: 12px;
  padding: 11px 10px 11px 12px;
  border: 1px solid #dbe7e6;
  border-radius: 10px;
  background: #fbfefd;
}

.api-connection-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 0 12px;
  padding: 14px 14px 12px 16px;
}

.api-connection-schedule {
  display: grid;
  grid-column: 1 / -1;
  grid-row: 2;
  grid-template-columns: 144px 142px minmax(116px, 1fr) 158px;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 8px 0 0;
  border-top: 1px solid #dbe7e6;
}

.api-connection-schedule :deep(.v-input) {
  min-width: 0;
}

.api-schedule-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  white-space: nowrap;
  color: #173d3e;
  font-size: 13px;
  font-weight: 600;
}

.api-schedule-toggle :deep(.v-switch) {
  flex: 0 0 auto;
}

.api-connection-schedule :deep(.v-field) {
  min-height: 34px;
}

/* Use Chrome's native picker icon once, with enough space from the selected time. */
.api-connection-schedule :deep(input[type='time']),
.rule-schedule-controls :deep(input[type='time']) {
  padding-right: 12px;
}

.api-connection-schedule > small {
  grid-column: 3;
  color: #64748b;
  font-size: 11px;
}

.api-connection-schedule-actions {
  display: flex;
  grid-column: 4;
  gap: 8px;
}

.api-connection-schedule-actions .v-btn {
  flex: 1 1 0;
  min-height: 32px;
  text-transform: none;
}

.api-connection-row .endpoint-actions {
  padding-top: 2px;
}

.file-feed-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 0 12px;
  padding: 16px;
  border-color: #cbd5e1;
  border-radius: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.file-feed-row > .endpoint-row-main {
  grid-column: 1;
}

.file-feed-row > .file-feed-summary,
.file-feed-row > .schedule-run-meta,
.file-feed-row > small,
.file-feed-row > .file-feed-run-controls,
.file-feed-row > .file-feed-import-status,
.file-feed-row > .file-feed-poll-error,
.file-feed-row > .file-feed-actions {
  grid-column: 1 / -1;
  width: 100%;
}

.file-feed-heading {
  grid-column: 1 / -1 !important;
}

.file-feed-summary {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
  margin-top: 14px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.78);
}

.file-feed-summary > div {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.file-feed-summary span {
  color: #64748b;
  font-size: 10px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.file-feed-summary strong {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
  white-space: normal;
}

.file-feed-last-message {
  color: #475569 !important;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.file-feed-setup-message {
  color: #a16207 !important;
  font-weight: 600;
  line-height: 1.45;
}

.file-feed-row > .file-feed-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #dbe7e6;
}

.file-feed-actions .v-btn {
  min-width: 0;
  min-height: 40px;
  text-transform: none;
}

.file-feed-actions .file-feed-history-button,
.file-feed-actions .file-feed-download-note {
  grid-column: 1 / -1;
}

.file-feed-actions .file-feed-download-note {
  color: #4b5f63;
  line-height: 1.45;
}

.file-feed-history-log {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-family: ui-monospace, Consolas, monospace;
  font-size: 0.875rem;
  line-height: 1.65;
  margin: 0;
}

.file-feed-run-controls { min-width: 0; margin-top: 24px; }
.file-feed-run-controls :deep(.v-input), .file-feed-run-controls :deep(.v-field) { width: 100%; min-width: 0; }
.file-feed-import-status { margin-top: 16px; padding: 14px; background: #f1f5f9; border: 1px solid #e2e8f0; border-radius: 8px; color: #334155; min-width: 0; }
.file-feed-import-status small { display: block; margin-top: 6px; color: #64748b; }
.file-feed-import-status p { margin: 8px 0 0; font-size: 13px; line-height: 1.5; overflow-wrap: anywhere; }
.sftp-history-dialog :deep(.v-card-text) { padding: 24px; }
.sftp-history-title { font-size: 20px; font-weight: 600; line-height: 1.4; margin: 0; }
.sftp-history-subtitle { color: #64748b; font-size: 13px; margin: 6px 0 0; }
.sftp-history-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 24px; margin-bottom: 24px; }
.sftp-history-filter { flex: 0 0 230px; }
.sftp-history-table-wrap { overflow-x: auto; }
.sftp-history-table { border-collapse: collapse; width: 100%; min-width: 640px; text-align: left; }
.sftp-history-table th { color: #475569; font-size: 13px; font-weight: 600; background: #f8fafc; }
.sftp-history-table th, .sftp-history-table td { padding: 15px 12px; border-bottom: 1px solid #e2e8f0; }
.sftp-history-table td { font-size: 14px; }
.sftp-history-table td:last-child { text-align: right; }
.sftp-history-table tbody tr:hover { background: #f8fafc; }
.sftp-history-empty { text-align: center; padding: 40px 16px; color: #64748b; }
.sftp-history-back { margin: -8px 0 16px -12px; }
.sftp-history-facts { display: grid; grid-template-columns: 1.3fr 1fr 1fr; gap: 20px; margin-top: 24px; }
.sftp-history-facts > div { display: flex; flex-direction: column; align-items: flex-start; gap: 8px; }
.sftp-history-facts span { font-size: 12px; color: #64748b; }
.sftp-history-facts strong { font-size: 14px; font-weight: 500; }
.sftp-history-table .sr-only { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0, 0, 0, 0); }
@media (max-width: 600px) {
  .sftp-history-toolbar { align-items: stretch; flex-direction: column; gap: 16px; }
  .sftp-history-filter { flex: none; width: 100%; }
  .sftp-history-facts { grid-template-columns: 1fr; gap: 16px; }
}

.file-feed-actions :deep(.v-btn__content) {
  white-space: normal;
}

.file-feed-connection-dialog .endpoint-test-row {
  white-space: normal;
}

.sftp-test-fingerprint {
  margin-top: 4px;
  overflow-wrap: anywhere;
  font-family: monospace;
  font-size: 11px;
}

.import-problem-server {
  margin-top: 4px;
  color: #64748b;
  font-size: 11px;
  overflow-wrap: anywhere;
}

.import-problem-details {
  margin: 6px 0;
  font-size: 11px;
  line-height: 1.5;
}

.import-problem-details > summary {
  width: fit-content;
  color: #1d4ed8;
  cursor: pointer;
}

.import-problem-details > summary:focus-visible {
  outline: 2px solid #1d4ed8;
  outline-offset: 3px;
}

.import-problem-details > div {
  margin-top: 5px;
  padding: 8px 10px;
  border-left: 2px solid #cbd5e1;
  background: #f8fafc;
  color: #475569;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.import-problem-details.is-email-error > summary {
  color: #b91c1c;
}

.sftp-password-kept {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 6px 0 0 2px;
  color: #0f766e;
  font-size: 11px;
  font-weight: 600;
}

.file-table-mapping-list {
  max-height: 290px;
  padding-right: 2px;
  overflow-y: auto;
}

.file-table-mapping-row {
  align-items: center;
  border-color: #d8d8f7;
  background: linear-gradient(100deg, #fbfaff 0%, #f8fcfc 100%);
}

.file-table-mapping-row .endpoint-actions .v-btn {
  min-height: 34px;
  text-transform: none;
}

.file-table-mapping-dialog :deep(.v-card-text) {
  max-height: min(68vh, 720px);
  overflow-y: auto;
}

.delivered-files-panel {
  margin-top: 18px;
  padding: 14px 16px;
  border: 1px solid #dce7f6;
  border-radius: 12px;
  background: #f8fbff;
}

.delivered-files-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 10px;
}

.delivered-files-heading > div {
  display: grid;
  gap: 3px;
}

.delivered-files-heading strong {
  color: #173d3e;
  font-size: 14px;
}

.delivered-files-heading span {
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
}

.delivered-files-heading code,
.delivered-file-row code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.delivered-file-list {
  display: grid;
  gap: 7px;
}

.delivered-file-rule-list {
  display: grid;
  gap: 8px;
}

.delivered-file-rule-row {
  display: grid;
  gap: 10px;
  padding: 12px;
  border: 1px solid #dbe7f6;
  border-left: 3px solid #4f6ed8;
  border-radius: 11px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(41, 73, 123, 0.045);
}

.delivered-file-rule-row.is-monthly {
  border-left-color: #805ad5;
  background: linear-gradient(90deg, #fcfbff 0%, #ffffff 35%);
}

.delivered-file-rule-row.is-hourly {
  border-left-color: #0f9f9a;
  background: linear-gradient(90deg, #f5fffe 0%, #ffffff 35%);
}

.rule-file-identity {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  align-items: center;
  gap: 9px;
}

.rule-file-icon {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border-radius: 9px;
  color: #3858b6;
  background: #eaf0ff;
}

.is-monthly .rule-file-icon {
  color: #6d45c4;
  background: #f1ebff;
}

.is-hourly .rule-file-icon {
  color: #087f7a;
  background: #e5fbf8;
}

.rule-schedule-controls {
  display: grid;
  grid-template-columns: 122px 126px 142px minmax(150px, 1fr) 44px 34px;
  align-items: center;
  gap: 8px;
}

.monthly-day-picker-card {
  overflow: hidden;
  min-width: 292px;
  border: 1px solid #dbe7f6;
  border-radius: 12px;
}

.monthly-day-picker-copy {
  display: grid;
  gap: 2px;
  padding: 12px 16px 8px;
  color: #314869;
}

.monthly-day-picker-copy strong {
  color: #263f70;
  font-size: 13px;
}

.monthly-day-picker-copy span {
  color: #7285a4;
  font-size: 12px;
}

.monthly-day-picker-card :deep(.v-date-picker) {
  width: 100%;
}

/* The calendar is only a day-of-month selector; its fixed Jan-2024 reference is not user data. */
.monthly-day-picker-card :deep(.v-date-picker-header),
.monthly-day-picker-card :deep(.v-date-picker-controls) {
  display: none;
}

.monthly-day-picker-card :deep(.v-date-picker-month) {
  padding-top: 0;
}

.rule-daily-summary {
  display: flex;
  min-height: 40px;
  align-items: center;
  gap: 7px;
  padding: 0 10px;
  border: 1px dashed #cbd9ed;
  border-radius: 7px;
  color: #587095;
  font-size: 12px;
  white-space: nowrap;
}

.rule-hourly-summary {
  display: flex;
  min-height: 40px;
  align-items: center;
  gap: 7px;
  padding: 0 10px;
  border: 1px dashed #a8d8d4;
  border-radius: 7px;
  color: #087f7a;
  background: #f7fffe;
  font-size: 12px;
  white-space: nowrap;
}

.rule-monthly-note {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  padding: 8px 10px;
  border-radius: 7px;
  color: #6845a8;
  background: #f5f1ff;
  font-size: 12px;
  line-height: 1.4;
}

.rule-hourly-note {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  padding: 8px 10px;
  border-radius: 7px;
  color: #087f7a;
  background: #edfbf9;
  font-size: 12px;
  line-height: 1.4;
}

.delivered-file-rule-row :deep(.v-input) {
  min-width: 0;
}

.delivered-file-rule-row :deep(.v-switch) {
  justify-self: center;
}

.delivered-file-rule-status {
  overflow: hidden;
  color: #64748b;
  font-size: 11px;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.delivered-file-rule-status.is-completed {
  color: #27835c;
}

.delivered-file-rule-status.is-failed {
  color: #be3d4d;
}

.delivered-file-row {
  display: grid;
  grid-template-columns: 20px minmax(0, max-content) max-content minmax(160px, 1fr);
  align-items: center;
  gap: 8px;
  min-height: 30px;
  padding: 6px 8px;
  border: 1px solid #e5edf8;
  border-radius: 8px;
  background: #fff;
}

.delivered-file-row code {
  color: #24496b;
  font-size: 12px;
  overflow-wrap: anywhere;
}

.delivered-file-row small {
  color: #64748b;
  font-size: 12px;
}

.file-field-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e8f0;
}

.file-field-heading > div {
  display: grid;
  gap: 2px;
}

.file-field-heading strong {
  color: #173d3e;
  font-size: 15px;
}

.file-field-heading span {
  color: #64748b;
  font-size: 12px;
}

.file-field-grid-header,
.file-field-grid {
  display: grid;
  grid-template-columns: 58px minmax(160px, 1fr) minmax(160px, 1fr) 82px;
  align-items: center;
  gap: 10px;
}

.file-field-grid-header {
  padding: 14px 8px 7px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.file-field-grid {
  min-height: 52px;
  padding: 6px 8px;
  border-top: 1px solid #eef2f7;
}

.file-field-grid :deep(.v-input) {
  margin: 0;
}

.endpoint-row-main {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.endpoint-name-line {
  gap: 8px;
}

.endpoint-name-line strong {
  overflow: hidden;
  color: #173d3e;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.endpoint-row-main span,
.endpoint-row-main small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.endpoint-actions {
  display: flex;
  flex: 0 0 auto;
}

.endpoint-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 72px;
  padding: 14px;
  border: 1px dashed #bfd9d7;
  border-radius: 10px;
  color: #64748b;
  font-size: 12px;
  text-align: center;
}

.api-endpoint-dialog {
  overflow: hidden;
  border-radius: 18px !important;
}

.api-endpoint-dialog-title {
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px;
  color: #fff;
  background: linear-gradient(120deg, #0f766e, #155e75);
}

.api-endpoint-dialog-title > div {
  display: grid;
  gap: 3px;
}

.api-endpoint-dialog-title strong {
  font-size: 19px;
}

.api-endpoint-dialog-title span {
  color: rgba(255, 255, 255, 0.78);
  font-size: 12px;
}

.api-endpoint-dialog-title .v-btn {
  color: #fff;
}

.api-endpoint-dialog-content {
  padding: 24px !important;
}

.endpoint-form-section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 2px 0 18px;
}

.endpoint-form-section-title > span {
  display: grid;
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  background: #0f766e;
}

.endpoint-form-section-title > div {
  display: grid;
  gap: 2px;
}

.endpoint-form-section-title strong {
  color: #0f3d3e;
  font-size: 14px;
}

.endpoint-form-section-title small,
.endpoint-test-row > span {
  color: #64748b;
  font-size: 12px;
}

.endpoint-test-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 4px;
}

.endpoint-test-row .v-btn {
  min-height: 44px;
  text-transform: none;
}

.endpoint-discovery-panel {
  margin-top: 22px;
  padding: 20px;
  border: 1px solid #bfdbd8;
  border-radius: 14px;
  background: #f8fffe;
}

.discovered-column-list {
  display: grid;
  gap: 8px;
  margin: 14px 0 18px;
  padding: 12px;
  border-radius: 10px;
  background: #fff;
}

.discovered-column-list > span {
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.discovered-column-list > div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

@media (max-width: 600px) {
  .endpoint-test-row {
    align-items: stretch;
    flex-direction: column;
  }
}

.import-dialog-card {
  border-radius: 18px !important;
  overflow: hidden;
}

.import-dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px 18px;
  color: #fff;
  background: linear-gradient(120deg, #0f766e, #0f5c65);
}

.import-dialog-title {
  font-size: 20px;
  font-weight: 700;
}

.import-dialog-subtitle {
  margin-top: 4px;
  max-width: 540px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 13px;
  line-height: 1.45;
}

.import-history {
  border: 1px solid rgba(15, 118, 110, 0.15);
  border-radius: 12px;
  overflow: hidden;
}

.import-history-title {
  padding: 10px 14px;
  color: #0f5c65;
  background: #f0fdfa;
  font-size: 13px;
  font-weight: 700;
}

.import-history-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  border-top: 1px solid rgba(15, 118, 110, 0.1);
  font-size: 13px;
}

.import-history-row div {
  display: grid;
  gap: 2px;
  min-width: 0;
}

.import-history-row span {
  overflow: hidden;
  color: #64748b;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 960px) {
  .import-framework-btn {
    margin-left: 0;
  }

  .test-import-btn {
    margin-left: 0;
  }

  .sync-schedule-btn {
    margin-left: 0;
  }

  .refresh-table-btn {
    margin-left: 0;
  }

  .schedule-timezone-row,
  .schedule-dialog-actions {
    align-items: flex-start;
    flex-direction: column;
  }

  .api-connection-row {
    grid-template-columns: minmax(0, 1fr) auto;
  }

  .api-connection-schedule {
    grid-template-columns: 144px minmax(142px, 1fr) auto;
  }

  .api-connection-schedule > small {
    grid-column: 1 / -1;
  }

  .api-connection-schedule-actions {
    grid-column: 3;
  }

  .endpoint-section-header {
    align-items: flex-start;
    flex-direction: column;
  }
}

@media (max-width: 600px) {
  .schedule-dialog-header,
  .schedule-dialog-content {
    padding-right: 16px !important;
    padding-left: 16px !important;
  }

  .schedule-header-icon,
  .schedule-action-note {
    display: none;
  }

  .schedule-run-meta {
    grid-template-columns: 1fr;
  }

  .file-feed-row {
    grid-template-columns: minmax(0, 1fr);
  }

  .file-feed-summary {
    grid-template-columns: minmax(0, 1fr);
  }

  .file-feed-connection-dialog .endpoint-test-row {
    align-items: stretch;
    flex-direction: column;
  }

  .api-connection-row {
    grid-template-columns: minmax(0, 1fr) auto;
  }

  .api-connection-schedule {
    grid-template-columns: minmax(0, 1fr);
  }

  .api-connection-schedule > small,
  .api-connection-schedule-actions {
    grid-column: 1;
  }

  .composite-mapping-row {
    grid-template-columns: minmax(0, 1fr) auto;
    padding: 8px 0;
  }

  .composite-mapping-row .v-input {
    grid-column: 1 / -1;
  }

  .composite-mapping-row--path-only .v-input {
    grid-column: auto;
  }
}

.card2 {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  padding-top: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.card {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

/* Table improvements */
:deep(.v-data-table) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table__wrapper) {
  border-radius: 12px;
}

:deep(.v-data-table tbody tr) {
  transition: background-color 0.2s ease;
}

:deep(.v-data-table tbody tr:hover) {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

:deep(.v-data-table-header) {
  background: rgba(0, 0, 0, 0.02);
}

:deep(.v-data-table-header th) {
  font-weight: 600 !important;
  color: rgba(0, 0, 0, 0.7) !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.025em !important;
}

/* Search panel improvements */
.search-panel {
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  border-radius: 12px !important;
  background: rgba(0, 0, 0, 0.01);
}

/* Header improvements */
:deep(.v-toolbar) {
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12) !important;
}

/* Dialog improvements */
:deep(.v-dialog .v-card) {
  border-radius: 16px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .action-controls {
    width: 100%;
    justify-content: center;
    min-width: auto;
  }

  .control-btn {
    flex: 1;
  }
}

/* Smooth animations */
* {
  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

/* Loading states */
.v-skeleton-loader {
  border-radius: 12px !important;
}

/* Focus states */
.control-btn:focus-visible {
  outline: 2px solid rgb(25, 118, 210);
  outline-offset: 2px;
}

/* Custom scrollbar */
:deep(.v-data-table__wrapper)::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-track {
  background: transparent;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.AddColumn:hover {
  background-color: #1976d2 !important;
  color: white !important;
}

::v-deep.UploadFile .NoDragDrop button.v-btn {
  margin: 0px !important;
}

.middle4 {
  position: absolute;
  right: 3px;
  top: 18px;
  transform: translateY(-50%);
  opacity: 0;
  transition: 0.2s ease;
}

.Card-Action {
  padding: 0 5px 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
  position: relative;
  margin-bottom: 5px;
}

.Card-Action:hover .middle4 {
  opacity: 1;
}
/* Action Divider */
.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.1);
  margin: 0 12px;
  align-self: center;
  border-radius: 1px;
}

.dialog-container :deep(.v-overlay__content) {
  margin: 24px;
  max-height: calc(100vh - 48px);
  overflow-y: auto;
}

.modern-card {
  border-radius: 20px !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid rgba(0, 0, 0, 0.04);
  background: #ffffff;
}

/* Enhanced Header */
.modern-header {
  padding: 24px 24px 16px 24px;
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.02) 0%, rgba(25, 118, 210, 0.01) 100%);
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: rgba(25, 118, 210, 0.1);
  border-radius: 12px;
}

.header-text {
  flex: 1;
}

.title-text {
  font-size: 1.5rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
  margin: 0;
  line-height: 1.2;
}

.subtitle-text {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  margin: 4px 0 0 0;
  line-height: 1.2;
}

.close-btn {
  opacity: 0.7;
  transition: all 0.2s ease;
}

.close-btn:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.04);
}

.header-divider {
  margin: 0 24px;
  opacity: 0.1;
}

/* Content Section */
.modern-content {
  padding: 24px;
  max-height: 60vh;
  overflow-y: auto;
}

.section-container {
  margin-bottom: 32px;
}

.section-container:last-child {
  margin-bottom: 0;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.section-icon {
  opacity: 0.8;
}

.section-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
}

/* Radio Group Modern */
.radio-group-modern {
  margin-top: 8px;
}

.radio-options {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.radio-option {
  flex: none;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.radio-icon {
  opacity: 0.7;
}

/* Configuration Sections */
.config-section {
  animation: fadeInUp 0.3s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Form Grid */
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group-large {
  grid-column: 1 / -1;
}

.full-width {
  grid-column: 1 / -1;
}

.upload-section {
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.modern-upload {
  flex: 1;
}

.upload-section {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.upload-container {
  position: relative;
  width: 100%;
  max-width: 400px;
}

.upload-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 24px;
  border: 2px dashed rgba(25, 118, 210, 0.3);
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.02) 0%, rgba(25, 118, 210, 0.01) 100%);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.upload-area::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(25, 118, 210, 0.05) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.upload-area:hover {
  border-color: rgba(25, 118, 210, 0.5);
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.04) 0%, rgba(25, 118, 210, 0.02) 100%);
  /* transform: translateY(-2px); */
  box-shadow: 0 6px 15px rgba(25, 118, 210, 0.15);
}

.upload-area:hover::before {
  opacity: 1;
}

/* Main Upload Button */
.upload-main-btn {
  position: relative;
  z-index: 2;
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  padding: 0 24px !important;
  height: 48px !important;
  box-shadow: 0 4px 15px rgba(25, 118, 210, 0.25) !important;
  transition: all 0.3s ease !important;
}

.upload-main-btn:hover {
  box-shadow: 0 6px 20px rgba(25, 118, 210, 0.35) !important;
  transform: translateY(-1px);
}

.upload-main-btn:active {
  transform: translateY(0);
}

.upload-text {
  font-size: 1rem;
  font-weight: 600;
}

/* Upload Info Section */
.upload-info {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  z-index: 2;
}

.upload-description {
  display: flex;
  align-items: center;
  gap: 4px;
}

.upload-hint {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
}

.upload-help-btn {
  opacity: 0.7;
  transition: all 0.2s ease;
}

.upload-help-btn:hover {
  opacity: 1;
  background: rgba(25, 118, 210, 0.1);
}

/* Uploaded File Info */
.uploaded-file-info {
  position: relative;
  z-index: 2;
  animation: fadeInUp 0.3s ease;
}

.file-chip {
  font-weight: 500 !important;
  max-width: 280px;
}

.file-chip :deep(.v-chip__content) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Hidden Upload Component */
.hidden-upload {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  z-index: -1;
}

/* Responsive Design */
@media (max-width: 768px) {
  .upload-area {
    padding: 24px 16px;
    margin: 0 16px;
  }

  .upload-main-btn {
    height: 44px !important;
    padding: 0 20px !important;
  }

  .upload-text {
    font-size: 0.9rem;
  }

  .upload-info {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }

  .upload-hint {
    font-size: 0.8rem;
  }
}

/* Loading State */
.upload-main-btn:disabled {
  opacity: 0.6;
  transform: none !important;
  box-shadow: none !important;
}

.upload-main-btn:disabled:hover {
  transform: none !important;
  box-shadow: none !important;
}

/* Focus States */
.upload-main-btn:focus-visible {
  outline: 2px solid rgba(25, 118, 210, 0.5);
  outline-offset: 2px;
}

.upload-help-btn:focus-visible {
  outline: 2px solid rgba(25, 118, 210, 0.5);
  outline-offset: 2px;
}

/* Animation for file upload success */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Hover effects for better UX */
.upload-area:hover .upload-main-btn {
  box-shadow: 0 8px 25px rgba(25, 118, 210, 0.3) !important;
}

.upload-area:hover .upload-hint {
  color: rgba(25, 118, 210, 0.8);
}

.upload-info-icon {
  position: absolute;
  top: -8px;
  right: -8px;
}

/* Modern Inputs */
.modern-input {
  background: rgba(0, 0, 0, 0.01);
}

.modern-input :deep(.v-field) {
  border-radius: 12px;
  transition: all 0.2s ease;
}

.modern-input :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.modern-input :deep(.v-field--focused) {
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
}

.info-icon {
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.info-icon:hover {
  opacity: 1;
}

/* Columns Section */
.columns-section {
  margin-top: 32px;
}

.columns-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.columns-title {
  font-size: 1rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
  margin: 0;
}

.columns-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.column-card {
  border-radius: 16px !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  background: rgba(0, 0, 0, 0.01);
}

.column-card:hover {
  border-color: rgba(25, 118, 210, 0.2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}

.column-content {
  padding: 20px;
}

.column-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.column-input {
  background: rgba(255, 255, 255, 0.8);
}

.column-options {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.modern-checkbox {
  flex: none;
}

.modern-checkbox :deep(.v-selection-control) {
  min-height: auto;
}

/* External Columns */
.external-columns-section {
  margin-top: 24px;
}

.add-column-btn {
  border-radius: 10px !important;
  font-weight: 500;
}

.external-columns-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
}

.external-column-card {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  background: rgba(0, 0, 0, 0.01);
  width: 100%;
}

.external-column-card:hover {
  border-color: rgba(25, 118, 210, 0.2);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.external-column-content {
  padding: 16px;
}

.external-column-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.delete-column-btn {
  opacity: 0.6;
  transition: all 0.2s ease;
}

.delete-column-btn:hover {
  opacity: 1;
  background: rgba(244, 67, 54, 0.1);
}

.external-column-input {
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.8);
}

.checkbox-label {
  display: flex;
  align-items: center;
  font-weight: 500;
}

/* Actions */
/* .modern-actions {
  padding: 16px 24px 24px 24px;
  background: rgba(0, 0, 0, 0.01);
}

.cancel-btn {
  padding: 0 15px;
  margin-right: 15px;
}

.cancel-btn:hover {
  background: rgba(0, 0, 0, 0.04);
} */

/* .save-btn {
  padding: 0 15px;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.25);
}

.save-btn:hover {
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.35);
  transform: translateY(-1px);
}

.save-btn:disabled {
  opacity: 0.5;
  transform: none;
  box-shadow: none;
} */

/* Responsive Design */
@media (max-width: 768px) {
  .modern-header {
    padding: 20px 16px 12px 16px;
  }

  .header-content {
    gap: 12px;
  }

  .header-icon {
    width: 40px;
    height: 40px;
  }

  .title-text {
    font-size: 1.25rem;
  }

  .modern-content {
    padding: 16px;
    max-height: 70vh;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .column-fields {
    grid-template-columns: 1fr;
  }

  .external-columns-grid {
    grid-template-columns: 1fr;
  }

  .radio-options {
    flex-direction: column;
    gap: 12px;
  }

  .column-options {
    flex-direction: column;
    gap: 8px;
  }

  .modern-actions {
    padding: 12px 16px 20px 16px;
    flex-direction: column;
    gap: 12px;
  }

  .action-btn {
    width: 100%;
  }
}

/* Smooth Scrollbar */
.modern-content::-webkit-scrollbar {
  width: 6px;
}

.modern-content::-webkit-scrollbar-track {
  background: transparent;
}

.modern-content::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.modern-content::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.2);
}

/* personal info */
.personal-info-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 8px;
}

.personal-info-container {
  background-color: #fffbf2;
  border: 1px solid #ffeeba;
  border-radius: 8px;
  padding: 4px 12px;
  width: 100%;
  transition: all 0.2s ease;
}
.personal-info-container:hover {
  background-color: #fff8e5;
  border-color: #ffe8a1;
}

.personal-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.personal-info-label {
  display: flex;
  align-items: center;
  cursor: help;
}

.personal-info-switch {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.personal-info-switch :deep(.v-switch__track) {
  opacity: 0.4;
}

.status-on {
  font-weight: 700;
  color: #ff9800;
}

/* Data Table Styling */
.date-cell {
  text-align: left;
}

.time-text {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 2px;
}

.status-chip {
  font-weight: 500;
  text-transform: capitalize;
}

::v-deep.toggle-switch.v-switch--inset .v-switch__thumb {
  height: 26px;
  width: 28px;
  transform: none !important;
}

/* Custom inset switch styling */
::v-deep.toggle-switch.v-switch--inset .v-switch__track {
  width: 55px !important;
  height: 30px !important;
  background-color: #c2c2c2 !important;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  border: none !important;
  border-radius: 50px !important;
  min-width: none;
}

.action-group {
  background: none;
  display: flex;
  align-items: center;
  gap: 14px;
}

.action-divider {
  width: 1px;
  height: 20px;
  background-color: rgba(0, 0, 0, 0.12);
  margin: 0 4px;
}

.action-btn {
  min-width: 32px;
  border-radius: 6px;
}

.edit-btn:hover {
  background-color: rgba(25, 118, 210, 0.08);
  color: #1976d2;
}

.delete-btn:hover {
  background-color: rgba(211, 47, 47, 0.08);
  color: #d32f2f;
}

.status-off {
  font-weight: 500;
  color: #757575;
}
.page-title {
  font-weight: 600;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.87);
  text-align: left;
  display: flex;
  align-items: center;
  height: 100%;
  min-height: 48px;
}
/* Custom Search Field Styling */
.custom-search-field {
  height: 48px !important;
}

.custom-search-field :deep(.v-field) {
  border-radius: 16px 16px !important;
  height: 48px !important;
  border-color: #c9c9c9 !important;
}

.custom-search-field :deep(.v-field__outline) {
  border-color: #c9c9c9 !important;
}

.custom-search-field :deep(.v-field__outline__start),
.custom-search-field :deep(.v-field__outline__end) {
  border-color: #c9c9c9 !important;
}

.custom-search-field :deep(.v-field__input) {
  display: flex !important;
  align-items: center !important;
  min-height: 48px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.custom-search-field :deep(.v-field__prepend-inner) {
  display: flex !important;
  align-items: center !important;
  padding-left: 5px !important;
}

.custom-search-field :deep(.v-input__control) {
  height: 48px !important;
}

.custom-search-field :deep(.v-field__field) {
  height: 48px !important;
  display: flex !important;
  align-items: center !important;
}

.custom-document-btn {
  color: #ffff;
  text-transform: none;
  box-shadow: 0 2px 4px rgba(80, 72, 151, 0.3);
  border-radius: 16px !important;
  height: 48px !important;
  min-width: 170px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: linear-gradient(90deg, #504897 0%, #4b2667 100%);
}

.custom-document-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(80, 72, 151, 0.4);
}

.filter-btn {
  height: 48px;
  border-radius: 50% !important;
  box-shadow: 0 2px 4px rgba(75, 40, 105, 0.3);
  transition: all 0.2s ease;
}

.filter-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(75, 40, 105, 0.4);
}

.filter-drawer-fullpage {
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
  height: 100vh !important;
  z-index: 1999 !important;
  border-radius: 16px 0 0 16px;
}
.filter-drawer-card {
  border-radius: 16px 0 0 16px;
}

.v-navigation-drawer__scrim {
  background-color: rgba(0, 0, 0, 0.9) !important;
  z-index: 1997 !important;
}

/* Filter Drawer Styling */
.drawer-icon {
  width: 24px;
  height: 24px;
}
.filter-section-title {
  color: #000000;
  font-size: 16px;
  font-weight: 700;
}
/* Custom Date Picker Styling */
.custom-date-picker {
  margin-bottom: 8px !important;
}

.custom-date-picker :deep(.v-field) {
  border-radius: 48px !important;
  border: 1px solid #c9c9c9 !important;
  background: white !important;
  transition: all 0.2s ease !important;
}

.custom-date-picker :deep(.v-field__outline) {
  display: none !important;
}

/* DateTime Picker Styling */
.datetime-picker-card {
  max-width: 350px;
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15) !important;
}

.time-picker-section {
  background-color: #fafafa;
}

.time-picker-section .v-select {
  background-color: white;
}

.time-picker-section .v-select :deep(.v-field) {
  border-radius: 8px;
}

.time-picker-section .text-subtitle-2 {
  color: rgba(0, 0, 0, 0.7);
  font-weight: 600;
}

.datetime-picker-card :deep(.v-date-picker) {
  border-radius: 12px 12px 0 0;
}

.datetime-picker-card :deep(.v-date-picker-header) {
  padding: 16px;
}

.datetime-picker-card :deep(.v-btn) {
  text-transform: none;
  font-weight: 500;
}

.datetime-picker-card .v-card-actions {
  padding: 12px 16px;
  background-color: white;
}

.custom-date-picker :deep(.v-field__input) {
  padding: 12px 16px !important;
  min-height: 48px !important;
  color: #999 !important;
  font-size: 14px !important;
}

.custom-date-picker :deep(.v-field__append-inner) {
  padding-right: 16px !important;
  display: flex !important;
  align-items: center !important;
}

.custom-date-picker :deep(.v-field__append-inner .v-icon) {
  opacity: 1 !important;
  cursor: pointer !important;
}

/* Hover state for date picker */
.custom-date-picker:hover :deep(.v-field) {
  border-color: #903f98 !important;
}

/* Focus state for date picker */
.custom-date-picker :deep(.v-field--focused) {
  border-color: #903f98 !important;
  box-shadow: 0 0 0 2px rgba(144, 63, 152, 0.1) !important;
}

::v-deep .v-table .v-table__wrapper > table > thead > tr > th {
  background: #f5f5f5 !important;
  font-weight: 600 !important;
  color: #000000 !important;
}
::v-deep .v-table .v-table__wrapper > table > thead > tr > th:first-child {
  border-top-left-radius: 16px !important;
}
::v-deep .v-table .v-table__wrapper > table > thead > tr > th:last-child {
  border-top-right-radius: 16px !important;
}
.custom-rounded-table {
  border: 1px solid #f5f5f5 !important;
  border-radius: 16px !important;
}

::v-deep.toggle-switch.v-switch--inset .v-selection-control--dirty .v-switch__thumb {
  background-color: #4e3982 !important;
}
::v-deep.toggle-switch.v-switch--inset .v-selection-control--dirty .v-switch__track {
  background-color: #ffffff !important;
  border: 1px solid #4e3982 !important;
}

/* Mutual Fund keeps the Database Integration layout but uses its own calm teal identity. */
.mutual-fund-page {
  --mutual-fund-accent: #0f766e;
  --mutual-fund-accent-strong: #0b5f59;
  --mutual-fund-accent-soft: #e6f4f1;
}

.mutual-fund-page .list-toolbar {
  padding: 24px 24px 16px !important;
}

.mutual-fund-page .list-toolbar-row {
  row-gap: 12px;
}

.mutual-fund-page .toolbar-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 12px;
}

.mutual-fund-page .page-title {
  color: #134e4a;
}

.mutual-fund-page .custom-search-field {
  flex: 1 1 360px;
  min-width: 220px;
  max-width: 700px;
}

.mutual-fund-page .search-icon {
  color: var(--mutual-fund-accent);
}

.mutual-fund-page :deep(.v-data-table) {
  border: 0;
  border-top: 1px solid rgba(15, 118, 110, 0.12);
  border-radius: 0;
}

.mutual-fund-page .mutual-fund-list-table :deep(.v-data-table__tr),
.mutual-fund-page .mutual-fund-list-table :deep(tbody tr) {
  height: 58px;
}

.mutual-fund-page .mutual-fund-list-table :deep(th),
.mutual-fund-page .mutual-fund-list-table :deep(td) {
  padding-inline: 16px !important;
}

.mutual-fund-page .mutual-fund-list-table :deep(th:nth-child(5) .v-data-table-header__content) {
  justify-content: center;
}

.number-cell,
.status-cell,
.active-cell,
.action-cell {
  text-align: center;
}

.active-switch-wrap {
  display: flex;
  justify-content: center;
}

.active-switch-wrap .toggle-switch {
  margin-inline: 0 !important;
}

.created-by-cell {
  color: #334155;
  text-align: left;
}

.table-name-content {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.table-icon-shell {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--mutual-fund-accent);
  background: var(--mutual-fund-accent-soft);
  border: 1px solid rgba(15, 118, 110, 0.12);
  border-radius: 9px;
}

.table-name-text {
  overflow: hidden;
  color: #0f172a;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mutual-fund-page .action-group {
  justify-content: center;
}

.mutual-fund-page .custom-document-btn {
  background: linear-gradient(90deg, #0f766e 0%, #0b5f59 100%);
  box-shadow: 0 2px 4px rgba(15, 118, 110, 0.3);
}

.mutual-fund-page .custom-document-btn:hover {
  box-shadow: 0 4px 8px rgba(15, 118, 110, 0.42);
}

.mutual-fund-page .filter-btn {
  background: #0f766e !important;
  box-shadow: 0 2px 4px rgba(15, 118, 110, 0.3);
}

.mutual-fund-page .filter-btn:hover {
  box-shadow: 0 4px 8px rgba(15, 118, 110, 0.42);
}

.mutual-fund-page .section-header {
  border-bottom-color: rgba(15, 118, 110, 0.18);
}

.mutual-fund-page .section-title {
  color: #115e59;
}

.mutual-fund-page .custom-search-field :deep(.v-field--focused) {
  box-shadow: 0 0 0 2px rgba(20, 184, 166, 0.18);
}

.mutual-fund-page .custom-date-picker:hover :deep(.v-field),
.mutual-fund-page .custom-date-picker :deep(.v-field--focused) {
  border-color: var(--mutual-fund-accent) !important;
  box-shadow: 0 0 0 2px rgba(20, 184, 166, 0.14) !important;
}

.mutual-fund-page ::v-deep.toggle-switch.v-switch--inset .v-selection-control--dirty .v-switch__thumb {
  background-color: var(--mutual-fund-accent) !important;
}

.mutual-fund-page ::v-deep.toggle-switch.v-switch--inset .v-selection-control--dirty .v-switch__track {
  border-color: var(--mutual-fund-accent) !important;
}

@media (max-width: 768px) {
  .delivered-files-heading {
    align-items: flex-start;
  }

  .delivered-file-row {
    grid-template-columns: 20px minmax(0, 1fr) max-content;
  }

  .delivered-file-row small {
    grid-column: 2 / -1;
  }

  .delivered-file-rule-row {
    padding: 10px;
  }

  .rule-schedule-controls {
    grid-template-columns: minmax(118px, 1fr) minmax(118px, 1fr) minmax(120px, 1fr) minmax(138px, 1.2fr) 44px 34px;
    gap: 7px;
  }

  .mutual-fund-page .list-toolbar {
    padding: 20px 16px 14px !important;
  }

  .mutual-fund-page .toolbar-actions {
    flex-wrap: wrap;
    justify-content: stretch;
  }

  .mutual-fund-page .toolbar-actions .custom-search-field {
    flex-basis: 100%;
    max-width: none;
  }

  .file-field-grid-header {
    display: none;
  }

  .file-field-grid {
    grid-template-columns: 50px minmax(0, 1fr) 62px;
  }

  .file-field-grid > :nth-child(3) {
    grid-column: 2;
  }

  .file-table-mapping-row {
    align-items: flex-start;
  }
}

@media (max-width: 640px) {
  .rule-schedule-controls {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 38px 34px;
  }

  .rule-schedule-controls > :nth-child(1),
  .rule-schedule-controls > :nth-child(2),
  .rule-schedule-controls > :nth-child(3),
  .rule-schedule-controls > :nth-child(4) {
    min-width: 0;
  }

  .rule-schedule-controls > :nth-child(3),
  .rule-schedule-controls > :nth-child(4) {
    grid-column: span 2;
  }

  .rule-schedule-controls > :nth-child(5) {
    grid-column: 3;
    grid-row: 1;
  }

  .rule-schedule-controls > :nth-child(6) {
    grid-column: 4;
    grid-row: 1;
  }
}

/* Disabled trash icon â€” visually convey it can't be clicked */
.trash-icon-wrapper.is-disabled {
  opacity: 0.5;
  pointer-events: auto;
}
.trash-icon-wrapper.is-disabled .v-icon {
  cursor: not-allowed !important;
}
</style>
